import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import type { ResolverContext } from '../resolver-context';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** See also: CCGraphQLSchema : Long */
  ExperimentalLong: { input: number; output: number; }
  JSON: { input: { [key: string]: any }; output: { [key: string]: any }; }
  Upload: { input: any; output: any; }
};

export type Ancestor = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ContentRestrictionObj = {
  operation?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<UserAndGroupRestrictions>;
};

export type ContentRestrictionsObj = {
  administer?: InputMaybe<ContentRestrictionObj>;
  copy?: InputMaybe<ContentRestrictionObj>;
  create?: InputMaybe<ContentRestrictionObj>;
  delete?: InputMaybe<ContentRestrictionObj>;
  export?: InputMaybe<ContentRestrictionObj>;
  move?: InputMaybe<ContentRestrictionObj>;
  purge?: InputMaybe<ContentRestrictionObj>;
  purge_version?: InputMaybe<ContentRestrictionObj>;
  read?: InputMaybe<ContentRestrictionObj>;
  restore?: InputMaybe<ContentRestrictionObj>;
  update?: InputMaybe<ContentRestrictionObj>;
  use?: InputMaybe<ContentRestrictionObj>;
};

export type ExperimentalAbTest = {
  __typename?: 'ExperimentalAbTest';
  abTestId?: Maybe<Scalars['String']['output']>;
  controlId?: Maybe<Scalars['String']['output']>;
  experimentId?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalAboutConfluence = {
  __typename?: 'ExperimentalAboutConfluence';
  html: Scalars['String']['output'];
};

export type ExperimentalAddCustomizedPersonalSpaceResult = {
  __typename?: 'ExperimentalAddCustomizedPersonalSpaceResult';
  error?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalAnalyticsActivityByDateActivity = {
  __typename?: 'ExperimentalAnalyticsActivityByDateActivity';
  creates?: Maybe<Array<Maybe<ExperimentalAnalyticsActivityByDateDateLevelActivity>>>;
  searches?: Maybe<Array<Maybe<ExperimentalAnalyticsActivityByDateDateLevelActivity>>>;
  updates?: Maybe<Array<Maybe<ExperimentalAnalyticsActivityByDateDateLevelActivity>>>;
  views?: Maybe<Array<Maybe<ExperimentalAnalyticsActivityByDateDateLevelActivity>>>;
};

export type ExperimentalAnalyticsActivityByDateDateLevelActivity = {
  __typename?: 'ExperimentalAnalyticsActivityByDateDateLevelActivity';
  date?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalAnalyticsActivityByDateResponse = {
  __typename?: 'ExperimentalAnalyticsActivityByDateResponse';
  activityByDate?: Maybe<ExperimentalAnalyticsActivityByDateActivity>;
};

export type ExperimentalAnalyticsActivityBySpaceResponse = {
  __typename?: 'ExperimentalAnalyticsActivityBySpaceResponse';
  activityBySpace?: Maybe<Array<Maybe<ExperimentalAnalyticsSpaceLevelActivity>>>;
  paginationInfo?: Maybe<ExperimentalAnalyticsPagination>;
};

export type ExperimentalAnalyticsActivityByUser = {
  __typename?: 'ExperimentalAnalyticsActivityByUser';
  accountId?: Maybe<Scalars['String']['output']>;
  commentCreated?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  searchPerformed?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
  viewed?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalAnalyticsActivityByUserResponse = {
  __typename?: 'ExperimentalAnalyticsActivityByUserResponse';
  activityByUser?: Maybe<Array<Maybe<ExperimentalAnalyticsActivityByUser>>>;
  paginationInfo?: Maybe<ExperimentalAnalyticsPaginationInfo>;
};

export type ExperimentalAnalyticsContentViews = {
  __typename?: 'ExperimentalAnalyticsContentViews';
  contentId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  lastModificationDate?: Maybe<Scalars['String']['output']>;
  lastViewedAt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalComments?: Maybe<Scalars['Int']['output']>;
  totalViewed?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uniqueUsersViewed?: Maybe<Scalars['Int']['output']>;
  webui?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalAnalyticsContentViewsResponse = {
  __typename?: 'ExperimentalAnalyticsContentViewsResponse';
  contentViews?: Maybe<Array<Maybe<ExperimentalAnalyticsContentViews>>>;
  paginationInfo?: Maybe<ExperimentalAnalyticsPaginationInfo>;
};

export type ExperimentalAnalyticsPagination = {
  __typename?: 'ExperimentalAnalyticsPagination';
  next?: Maybe<Scalars['String']['output']>;
  previous?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalAnalyticsPaginationInfo = {
  __typename?: 'ExperimentalAnalyticsPaginationInfo';
  next?: Maybe<Scalars['String']['output']>;
  prev?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalAnalyticsSpaceLevelActivity = {
  __typename?: 'ExperimentalAnalyticsSpaceLevelActivity';
  created?: Maybe<Scalars['Int']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastViewedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
  usersViewed?: Maybe<Scalars['Int']['output']>;
  views?: Maybe<Scalars['Int']['output']>;
  webui?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalAnalyticsViewsByDate = {
  __typename?: 'ExperimentalAnalyticsViewsByDate';
  date?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalAnalyticsViewsByDateResponse = {
  __typename?: 'ExperimentalAnalyticsViewsByDateResponse';
  viewsByDate?: Maybe<Array<Maybe<ExperimentalAnalyticsViewsByDate>>>;
};

export type ExperimentalApplication = {
  __typename?: 'ExperimentalApplication';
  applicationType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  local?: Maybe<Scalars['Boolean']['output']>;
  self?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalApplicationList = {
  __typename?: 'ExperimentalApplicationList';
  linkedApplications?: Maybe<Array<Maybe<ExperimentalApplication>>>;
};

export type ExperimentalArchiveSpace = {
  __typename?: 'ExperimentalArchiveSpace';
  archived: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type ExperimentalAutomationActor = {
  __typename?: 'ExperimentalAutomationActor';
  type?: Maybe<ExperimentalAutomationActorConfigType>;
  value?: Maybe<Scalars['String']['output']>;
};

export enum ExperimentalAutomationActorConfigType {
  ACCOUNT_ID = 'ACCOUNT_ID',
  EVENT_INITIATOR = 'EVENT_INITIATOR',
  SMART_VALUE = 'SMART_VALUE'
}

export enum ExperimentalAutomationBillingType {
  NORMAL = 'NORMAL',
  SYSTEM = 'SYSTEM'
}

export type ExperimentalAutomationComponent = {
  __typename?: 'ExperimentalAutomationComponent';
  children?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  component?: Maybe<Scalars['String']['output']>;
  conditionParentId?: Maybe<Scalars['ID']['output']>;
  conditions?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  connectionId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
  schemaVersion?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ExperimentalAutomationComponentConfigSummary = {
  __typename?: 'ExperimentalAutomationComponentConfigSummary';
  childComponentSummaries: Array<ExperimentalAutomationComponentConfigSummary>;
  component: Scalars['String']['output'];
  componentName: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ExperimentalAutomationRuleConnectionsResponse = {
  __typename?: 'ExperimentalAutomationRuleConnectionsResponse';
  accountId: Scalars['String']['output'];
  connectionTargetKey: Scalars['String']['output'];
  container?: Maybe<ExperimentalConnectionContainer>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  targetConfigJson?: Maybe<ExperimentalConnectionTargetConfig>;
  updatedAt: Scalars['String']['output'];
};

export type ExperimentalAutomationRuleHome = {
  __typename?: 'ExperimentalAutomationRuleHome';
  ruleBillingHome?: Maybe<ExperimentalRuleHomeBilling>;
  ruleLifecycleHome?: Maybe<ExperimentalRuleHomeLifecycle>;
};

export type ExperimentalAutomationRuleScope = {
  __typename?: 'ExperimentalAutomationRuleScope';
  resources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum ExperimentalAutomationRuleState {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  NEW = 'NEW'
}

export type ExperimentalAutomationRuleSummaryResponse = {
  __typename?: 'ExperimentalAutomationRuleSummaryResponse';
  authorAccountId: Scalars['ID']['output'];
  componentSummaries: Array<ExperimentalAutomationComponentConfigSummary>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ruleState: ExperimentalAutomationRuleState;
};

export type ExperimentalAutomationRuleTag = {
  __typename?: 'ExperimentalAutomationRuleTag';
  id?: Maybe<Scalars['ID']['output']>;
  tagType?: Maybe<ExperimentalTagType>;
  tagValue?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalAutomationUpdateRuleActor = {
  type: ExperimentalAutomationActorConfigType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentalAutomationUpdateRuleComponent = {
  children: Array<InputMaybe<Scalars['JSON']['input']>>;
  component: Scalars['String']['input'];
  conditionParentId?: InputMaybe<Scalars['ID']['input']>;
  conditions: Array<InputMaybe<Scalars['JSON']['input']>>;
  connectionId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  schemaVersion?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

export type ExperimentalAutomationUpdateRuleHome = {
  ruleBillingHome: ExperimentalAutomationUpdateRuleHomeBilling;
  ruleLifecycleHome: ExperimentalAutomationUpdateRuleHomeLifecycle;
};

export type ExperimentalAutomationUpdateRuleHomeBilling = {
  locationARI: Scalars['String']['input'];
};

export type ExperimentalAutomationUpdateRuleHomeLifecycle = {
  locationARI: Scalars['String']['input'];
};

export type ExperimentalAutomationUpdateRuleScope = {
  resources: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ExperimentalAutomationUpdateRuleTag = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tagType: ExperimentalTagType;
  tagValue?: InputMaybe<Scalars['String']['input']>;
};

export enum ExperimentalAutomationWriteAccessType {
  OWNER_ONLY = 'OWNER_ONLY',
  SPECIFIED_USERS = 'SPECIFIED_USERS',
  UNRESTRICTED = 'UNRESTRICTED'
}

export type ExperimentalBlueprint = {
  __typename?: 'ExperimentalBlueprint';
  blueprintModuleCompleteKey?: Maybe<Scalars['String']['output']>;
  contentBlueprintId?: Maybe<Scalars['String']['output']>;
  createResult?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  howToUseTemplate?: Maybe<Scalars['String']['output']>;
  iconURL?: Maybe<Scalars['String']['output']>;
  isNew?: Maybe<Scalars['Boolean']['output']>;
  isPromoted?: Maybe<Scalars['Boolean']['output']>;
  itemModuleCompleteKey?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  new?: Maybe<Scalars['Boolean']['output']>;
  promoted?: Maybe<Scalars['Boolean']['output']>;
  skipHowToUse?: Maybe<Scalars['Boolean']['output']>;
  styleClass?: Maybe<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  wizard?: Maybe<ExperimentalBlueprintWizard>;
};

export type ExperimentalBlueprintWizard = {
  __typename?: 'ExperimentalBlueprintWizard';
  pages?: Maybe<Array<Maybe<ExperimentalBlueprintWizardPage>>>;
};

export type ExperimentalBlueprintWizardPage = {
  __typename?: 'ExperimentalBlueprintWizardPage';
  descriptionContent?: Maybe<Scalars['String']['output']>;
  descriptionHeader?: Maybe<Scalars['String']['output']>;
  descriptionHeaderLink?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  templateKey?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCalendarViewPreference = {
  __typename?: 'ExperimentalCalendarViewPreference';
  subCalendarsInView?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  view: Scalars['String']['output'];
};

export type ExperimentalCancelScheduledPublishResponse = {
  __typename?: 'ExperimentalCancelScheduledPublishResponse';
  success: Scalars['Boolean']['output'];
};

export type ExperimentalCaptcha = {
  id?: InputMaybe<Scalars['String']['input']>;
  response?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentalComment = {
  __typename?: 'ExperimentalComment';
  author: ExperimentalUser;
  body: Scalars['String']['output'];
  friendlyLastModified: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  location?: Maybe<ExperimentalInlineComment>;
  replies: ExperimentalComments;
};

export type ExperimentalCommentInput = {
  captcha?: InputMaybe<ExperimentalCaptcha>;
  commentId?: InputMaybe<Scalars['ID']['input']>;
  contentId: Scalars['ID']['input'];
  html: Scalars['String']['input'];
  requestType: Scalars['String']['input'];
  uuid: Scalars['String']['input'];
  watch: Scalars['Boolean']['input'];
};

export type ExperimentalCommentMutationResponse = {
  __typename?: 'ExperimentalCommentMutationResponse';
  asyncRenderSafe?: Maybe<Scalars['Boolean']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isInlineComment?: Maybe<Scalars['Boolean']['output']>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type ExperimentalCommentVersion = {
  number?: InputMaybe<Scalars['Int']['input']>;
};

export type ExperimentalComments = {
  __typename?: 'ExperimentalComments';
  nodes: Array<ExperimentalComment>;
};

export type ExperimentalConnectContext = {
  __typename?: 'ExperimentalConnectContext';
  connectDescriptor?: Maybe<ExperimentalConnectIFrame>;
  hasResponse: Scalars['Boolean']['output'];
};

export type ExperimentalConnectIFrame = {
  __typename?: 'ExperimentalConnectIFrame';
  addon_key?: Maybe<Scalars['String']['output']>;
  apiMigrations?: Maybe<ExperimentalThemeAPIMigrations>;
  contentClassifier?: Maybe<Scalars['String']['output']>;
  contextJwt?: Maybe<Scalars['String']['output']>;
  cp?: Maybe<Scalars['String']['output']>;
  general?: Maybe<Scalars['String']['output']>;
  h?: Maybe<Scalars['String']['output']>;
  hostOrigin?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  moduleType?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  productCtx?: Maybe<Scalars['String']['output']>;
  sandbox?: Maybe<Scalars['String']['output']>;
  structuredContext?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  uniqueKey?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  w?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalConnectModule = {
  __typename?: 'ExperimentalConnectModule';
  modules?: Maybe<Scalars['JSON']['output']>;
};

export type ExperimentalConnectServletResponse = {
  __typename?: 'ExperimentalConnectServletResponse';
  url?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalConnectionConfig = {
  accountId: Scalars['String']['input'];
  authType: Scalars['String']['input'];
  authUserSource: Scalars['String']['input'];
  connectionTargetKey: Scalars['String']['input'];
  container: ExperimentalConnectionContainerInput;
  createdAt: Scalars['String']['input'];
  id: Scalars['String']['input'];
  targetConfigJson: Scalars['String']['input'];
  updatedAt: Scalars['String']['input'];
};

export type ExperimentalConnectionContainer = {
  __typename?: 'ExperimentalConnectionContainer';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ExperimentalConnectionContainerInput = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ExperimentalConnectionTargetConfig = {
  __typename?: 'ExperimentalConnectionTargetConfig';
  baseUrl: Scalars['String']['output'];
  cloudId: Scalars['String']['output'];
};

export type ExperimentalContainer = {
  __typename?: 'ExperimentalContainer';
  id?: Maybe<Scalars['ID']['output']>;
  macroRenderedOutput?: Maybe<ExperimentalFormattedBody>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalContent = {
  __typename?: 'ExperimentalContent';
  ancestors?: Maybe<Array<Maybe<ExperimentalContent>>>;
  body?: Maybe<ExperimentalContentBodyPerRepresentation>;
  container?: Maybe<ExperimentalSpaceOrContent>;
  history?: Maybe<ExperimentalHistory>;
  id?: Maybe<Scalars['ID']['output']>;
  links?: Maybe<ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
  operations?: Maybe<Array<Maybe<ExperimentalOperationCheckResult>>>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<ExperimentalVersion>;
};

export type ExperimentalContentBody = {
  __typename?: 'ExperimentalContentBody';
  content?: Maybe<ExperimentalContent>;
  links?: Maybe<ExperimentalLinksContextBase>;
  macroRenderedOutput?: Maybe<ExperimentalFormattedBody>;
  representation?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  webresource?: Maybe<ExperimentalWebResourceDependencies>;
};

export type ExperimentalContentBodyConvertResult = {
  __typename?: 'ExperimentalContentBodyConvertResult';
  value?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalContentBodyPerRepresentation = {
  __typename?: 'ExperimentalContentBodyPerRepresentation';
  editor?: Maybe<ExperimentalContentBody>;
  view?: Maybe<ExperimentalContentBody>;
};

export type ExperimentalContentDraftDiff = {
  __typename?: 'ExperimentalContentDraftDiff';
  body?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalContentHistory = {
  __typename?: 'ExperimentalContentHistory';
  createdBy?: Maybe<ExperimentalContentHistoryUser>;
  createdDate?: Maybe<Scalars['String']['output']>;
  latest?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalContentHistoryUser = {
  __typename?: 'ExperimentalContentHistoryUser';
  accountId?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<ExperimentalIcon>;
  publicName?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalContentMetadata = {
  __typename?: 'ExperimentalContentMetadata';
  labels?: Maybe<ExperimentalContentMetadataLabels>;
};

export type ExperimentalContentMetadataLabelResult = {
  __typename?: 'ExperimentalContentMetadataLabelResult';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalContentMetadataLabels = {
  __typename?: 'ExperimentalContentMetadataLabels';
  limit?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ExperimentalContentMetadataLabelResult>>>;
  size?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalContentOperations = {
  __typename?: 'ExperimentalContentOperations';
  operation?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalContentType = {
  __typename?: 'ExperimentalContentType';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalContentVersionRestored = {
  __typename?: 'ExperimentalContentVersionRestored';
  restored: Scalars['Boolean']['output'];
};

export type ExperimentalCopyPageTreeLinksResponse = {
  __typename?: 'ExperimentalCopyPageTreeLinksResponse';
  status?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCopyPageTreeResponse = {
  __typename?: 'ExperimentalCopyPageTreeResponse';
  id?: Maybe<Scalars['String']['output']>;
  links?: Maybe<ExperimentalCopyPageTreeLinksResponse>;
};

export type ExperimentalCreateAutomationRuleFromTemplateParameter = {
  name: Scalars['String']['input'];
  type: TemplateParameterTypeEnum;
  value: Scalars['String']['input'];
};

export type ExperimentalCreateAutomationRuleFromTemplateResponse = {
  __typename?: 'ExperimentalCreateAutomationRuleFromTemplateResponse';
  ruleId?: Maybe<Scalars['ID']['output']>;
};

export type ExperimentalCreateContentResponse = {
  __typename?: 'ExperimentalCreateContentResponse';
  collabService?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  links?: Maybe<ExperimentalPublishContent>;
  spaceId?: Maybe<Scalars['String']['output']>;
  subType?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCrossProductSearchFilter = {
  ancestorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  containerStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contributors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  date?: InputMaybe<ExperimentalCrossProductSearchFilterDate>;
  labels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  spaceKeys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  titleMatchOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExperimentalCrossProductSearchFilterDate = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentalCrossProductSearchResult = {
  __typename?: 'ExperimentalCrossProductSearchResult';
  abTest?: Maybe<ExperimentalAbTest>;
  nodes?: Maybe<Array<Maybe<ExperimentalCrossProductSearchResultItem>>>;
  pageInfo?: Maybe<ExperimentalPageInfo>;
};

export type ExperimentalCrossProductSearchResultItem = {
  __typename?: 'ExperimentalCrossProductSearchResultItem';
  content?: Maybe<ExperimentalCrossProductSearchResultItemContent>;
  entityType?: Maybe<Scalars['String']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
  lastModified?: Maybe<Scalars['String']['output']>;
  space?: Maybe<ExperimentalCrossProductSearchResultItemSpace>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCrossProductSearchResultItemContent = {
  __typename?: 'ExperimentalCrossProductSearchResultItemContent';
  id?: Maybe<Scalars['ID']['output']>;
  space?: Maybe<ExperimentalCrossProductSearchResultItemSpace>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCrossProductSearchResultItemSpace = {
  __typename?: 'ExperimentalCrossProductSearchResultItemSpace';
  icon?: Maybe<ExperimentalIcon>;
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  links?: Maybe<ExperimentalCrossProductSearchResultItemSpaceLinks>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCrossProductSearchResultItemSpaceLinks = {
  __typename?: 'ExperimentalCrossProductSearchResultItemSpaceLinks';
  webui?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCurrentUser = {
  __typename?: 'ExperimentalCurrentUser';
  timeZone?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCustomContentExpandable = {
  __typename?: 'ExperimentalCustomContentExpandable';
  ancestors?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  childTypes?: Maybe<Scalars['String']['output']>;
  children?: Maybe<Scalars['String']['output']>;
  container?: Maybe<Scalars['String']['output']>;
  descendants?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  operations?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<Scalars['String']['output']>;
  schedulePublishDate?: Maybe<Scalars['String']['output']>;
  space?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCustomContentPageResponse = {
  __typename?: 'ExperimentalCustomContentPageResponse';
  _links?: Maybe<ExperimentalLinksContextSelfBase>;
  limit?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ExperimentalCustomContentPageResponseResult>>>;
  size?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalCustomContentPageResponseResult = {
  __typename?: 'ExperimentalCustomContentPageResponseResult';
  _expandable?: Maybe<ExperimentalCustomContentExpandable>;
  _links?: Maybe<ExperimentalLinksContextSelfCollectionWebuiBase>;
  id?: Maybe<Scalars['ID']['output']>;
  macroRenderedOutput?: Maybe<ExperimentalFormattedBody>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCustomContentPropertiesPageResponse = {
  __typename?: 'ExperimentalCustomContentPropertiesPageResponse';
  results?: Maybe<Array<Maybe<ExperimentalCustomContentPropertiesResponse>>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalCustomContentPropertiesResponse = {
  __typename?: 'ExperimentalCustomContentPropertiesResponse';
  _links?: Maybe<ExperimentalLinksContextSelfCollectionWebuiBase>;
  history?: Maybe<ExperimentalContentHistory>;
  id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<ExperimentalContentMetadata>;
  operations?: Maybe<Array<Maybe<ExperimentalContentOperations>>>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalDRSEligibility = {
  __typename?: 'ExperimentalDRSEligibility';
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalDRSSettings = {
  __typename?: 'ExperimentalDRSSettings';
  cloudId?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalDRSSettingsInput = {
  action: Scalars['String']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  promotionLocation: Scalars['String']['input'];
};

export type ExperimentalDefaultLogoForSpace = {
  __typename?: 'ExperimentalDefaultLogoForSpace';
  logoDownloadPath?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalDeleteComment = {
  __typename?: 'ExperimentalDeleteComment';
  contentId?: Maybe<Scalars['ID']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalDemoSpace = {
  __typename?: 'ExperimentalDemoSpace';
  draftId?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalDesPromotionEligibility = {
  __typename?: 'ExperimentalDesPromotionEligibility';
  desPromotionEligible: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalDesSettings = {
  __typename?: 'ExperimentalDesSettings';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalDesSettingsInput = {
  action: Scalars['String']['input'];
  domains: Array<InputMaybe<Scalars['String']['input']>>;
  location: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  setting: Scalars['String']['input'];
};

export type ExperimentalDiscoveredFeature = {
  __typename?: 'ExperimentalDiscoveredFeature';
  featureKey?: Maybe<Scalars['String']['output']>;
  pluginKey?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalEditorBreadcrumb = {
  __typename?: 'ExperimentalEditorBreadcrumb';
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalEditorBreadcrumbs = {
  __typename?: 'ExperimentalEditorBreadcrumbs';
  breadcrumbs?: Maybe<Array<Maybe<ExperimentalEditorBreadcrumb>>>;
};

export type ExperimentalEditorHeartbeatResponse = {
  __typename?: 'ExperimentalEditorHeartbeatResponse';
  editorSessionId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  orderedUsers?: Maybe<Array<ExperimentalHeartbeatUser>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalExpandable = {
  __typename?: 'ExperimentalExpandable';
  relationData?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalExtension = {
  __typename?: 'ExperimentalExtension';
  location?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalFabricComment = {
  __typename?: 'ExperimentalFabricComment';
  ancestors?: Maybe<Array<Maybe<ExperimentalFabricComment>>>;
  container?: Maybe<ExperimentalContainer>;
  extensions?: Maybe<ExperimentalExtension>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ExperimentalFabricCommentInput = {
  adfContent: Scalars['String']['input'];
  commentId?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  location: Scalars['String']['input'];
  requestType: Scalars['String']['input'];
  version?: InputMaybe<ExperimentalCommentVersion>;
};

export type ExperimentalFabricInlineComment = {
  __typename?: 'ExperimentalFabricInlineComment';
  authorAccountId?: Maybe<Scalars['String']['output']>;
  authorAvatarUrl: Scalars['String']['output'];
  authorDisplayName: Scalars['String']['output'];
  authorUserName: Scalars['String']['output'];
  body?: Maybe<Scalars['String']['output']>;
  commentDateUrl: Scalars['String']['output'];
  hasDeletePermission: Scalars['Boolean']['output'];
  hasEditPermission: Scalars['Boolean']['output'];
  hasReplyPermission: Scalars['Boolean']['output'];
  hasResolvePermission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastModificationDate: Scalars['String']['output'];
  markerRef: Scalars['String']['output'];
  originalSelection: Scalars['String']['output'];
  parentCommentId: Scalars['ID']['output'];
  resolveProperties?: Maybe<ExperimentalFabricInlineCommentResolveProperties>;
};

export type ExperimentalFabricInlineCommentError = {
  __typename?: 'ExperimentalFabricInlineCommentError';
  errorId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ExperimentalFabricInlineCommentInput = {
  adfContent: Scalars['String']['input'];
  authorAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  commentId?: InputMaybe<Scalars['ID']['input']>;
  contentId: Scalars['ID']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  lastFetchTime?: InputMaybe<Scalars['String']['input']>;
  matchIndex?: InputMaybe<Scalars['Int']['input']>;
  numMatches?: InputMaybe<Scalars['Int']['input']>;
  originalSelection?: InputMaybe<Scalars['String']['input']>;
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
  requestType: Scalars['String']['input'];
  serializedHighlights?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentalFabricInlineCommentResolveProperties = {
  __typename?: 'ExperimentalFabricInlineCommentResolveProperties';
  resolved?: Maybe<Scalars['Boolean']['output']>;
  resolvedByDangling?: Maybe<Scalars['Boolean']['output']>;
  resolvedTime?: Maybe<Scalars['ExperimentalLong']['output']>;
};

export type ExperimentalFabricInlineCommentResponse = {
  __typename?: 'ExperimentalFabricInlineCommentResponse';
  error?: Maybe<ExperimentalFabricInlineCommentError>;
  result?: Maybe<ExperimentalFabricInlineComment>;
};

export type ExperimentalFabricInlineReply = {
  __typename?: 'ExperimentalFabricInlineReply';
  authorAccountId?: Maybe<Scalars['String']['output']>;
  authorAvatarUrl?: Maybe<Scalars['String']['output']>;
  authorDisplayName?: Maybe<Scalars['String']['output']>;
  authorUserName?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  commentDateUrl: Scalars['String']['output'];
  commentId: Scalars['ID']['output'];
  hasDeletePermission: Scalars['Boolean']['output'];
  hasEditPermission: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastModificationDate?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalFabricInlineReplyError = {
  __typename?: 'ExperimentalFabricInlineReplyError';
  errorId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type ExperimentalFabricInlineReplyInput = {
  adfContent: Scalars['String']['input'];
  authorAccountId?: InputMaybe<Scalars['String']['input']>;
  authorAvatarUrl?: InputMaybe<Scalars['String']['input']>;
  authorDisplayName?: InputMaybe<Scalars['String']['input']>;
  commentDateUrl?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['ID']['input'];
  hasDeletePermission: Scalars['Boolean']['input'];
  hasEditPermission: Scalars['Boolean']['input'];
  lastModificationDate?: InputMaybe<Scalars['String']['input']>;
  parentCommentId: Scalars['ID']['input'];
  replyId?: InputMaybe<Scalars['ID']['input']>;
  requestType: Scalars['String']['input'];
};

export type ExperimentalFabricInlineReplyResponse = {
  __typename?: 'ExperimentalFabricInlineReplyResponse';
  error?: Maybe<ExperimentalFabricInlineReplyError>;
  result?: Maybe<ExperimentalFabricInlineReply>;
};

export type ExperimentalFavouriteSpaceQuery = {
  __typename?: 'ExperimentalFavouriteSpaceQuery';
  isSpaceFavourited?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalFavouriteSpaceType = {
  __typename?: 'ExperimentalFavouriteSpaceType';
  spaceKey?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalFlagResult = {
  __typename?: 'ExperimentalFlagResult';
  lastSeenDate?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type ExperimentalFormattedBody = {
  __typename?: 'ExperimentalFormattedBody';
  links?: Maybe<ExperimentalLinksContextBase>;
  representation?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  webresource?: Maybe<ExperimentalWebResourceDependencies>;
};

export type ExperimentalGenerateSpaceKey = {
  __typename?: 'ExperimentalGenerateSpaceKey';
  key?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalGetAutomationRuleByIdResponse = {
  __typename?: 'ExperimentalGetAutomationRuleByIdResponse';
  actor?: Maybe<ExperimentalAutomationActor>;
  authorAccountId?: Maybe<Scalars['ID']['output']>;
  billingType?: Maybe<ExperimentalAutomationBillingType>;
  canOtherRuleTrigger?: Maybe<Scalars['Boolean']['output']>;
  clientKey?: Maybe<Scalars['String']['output']>;
  collaborators?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  components?: Maybe<Array<Maybe<ExperimentalAutomationComponent>>>;
  created?: Maybe<Scalars['ExperimentalLong']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  notifyOnError?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Array<Maybe<Scalars['JSON']['output']>>>;
  ruleHome?: Maybe<ExperimentalAutomationRuleHome>;
  ruleScope?: Maybe<ExperimentalAutomationRuleScope>;
  state?: Maybe<ExperimentalAutomationRuleState>;
  tags?: Maybe<Array<Maybe<ExperimentalAutomationRuleTag>>>;
  trigger?: Maybe<ExperimentalAutomationComponent>;
  updated?: Maybe<Scalars['ExperimentalLong']['output']>;
  writeAccessType?: Maybe<ExperimentalAutomationWriteAccessType>;
};

export type ExperimentalGrantAccess = {
  __typename?: 'ExperimentalGrantAccess';
  responseStatus?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExperimentalGroup = {
  __typename?: 'ExperimentalGroup';
  content?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalHeartbeatUser = {
  __typename?: 'ExperimentalHeartbeatUser';
  accountId: Scalars['String']['output'];
  heartbeatUserType: ExperimentalHeartbeatUserType;
};

export enum ExperimentalHeartbeatUserType {
  EDIT = 'EDIT',
  VIEW = 'VIEW'
}

export type ExperimentalHistory = {
  __typename?: 'ExperimentalHistory';
  createdBy?: Maybe<ExperimentalKnownUser>;
  createdDate?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<ExperimentalVersion>;
  latest?: Maybe<Scalars['Boolean']['output']>;
  links?: Maybe<ExperimentalLinksContextSelfBase>;
};

export type ExperimentalIcon = {
  __typename?: 'ExperimentalIcon';
  height?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  path: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};


export type ExperimentalIconpathArgs = {
  type?: InputMaybe<ExperimentalPathType>;
};

export type ExperimentalInlineComment = {
  __typename?: 'ExperimentalInlineComment';
  hasResolvePermission: Scalars['Boolean']['output'];
  inlineMarkerRef: Scalars['String']['output'];
  inlineText: Scalars['String']['output'];
  resolveProperties: ExperimentalResolveProperties;
};

export type ExperimentalInlineCommentReopened = {
  __typename?: 'ExperimentalInlineCommentReopened';
  result: Scalars['Boolean']['output'];
};

export type ExperimentalIntegrationsInstalled = {
  __typename?: 'ExperimentalIntegrationsInstalled';
  integrations?: Maybe<Array<ExperimentalOnboardingIntegration>>;
  isSlackConnected: Scalars['Boolean']['output'];
  isSlackEnabled: Scalars['Boolean']['output'];
};

export type ExperimentalJiraIssue = {
  __typename?: 'ExperimentalJiraIssue';
  authUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalKeyboardShortcutsStatus = {
  __typename?: 'ExperimentalKeyboardShortcutsStatus';
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalKnownUser = {
  __typename?: 'ExperimentalKnownUser';
  accountId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  links?: Maybe<ExperimentalLinksContextSelfBase>;
  operations?: Maybe<Array<Maybe<ExperimentalOperationCheckResult>>>;
  profilePicture?: Maybe<ExperimentalIcon>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalLinks = {
  __typename?: 'ExperimentalLinks';
  base?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalLinksContextBase = {
  __typename?: 'ExperimentalLinksContextBase';
  base?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalLinksContextSelfBase = {
  __typename?: 'ExperimentalLinksContextSelfBase';
  base?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalLinksContextSelfCollectionWebuiBase = {
  __typename?: 'ExperimentalLinksContextSelfCollectionWebuiBase';
  base?: Maybe<Scalars['String']['output']>;
  collection?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['String']['output']>;
  webui?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase = {
  __typename?: 'ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase';
  base?: Maybe<Scalars['String']['output']>;
  collection?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  download?: Maybe<Scalars['String']['output']>;
  editui?: Maybe<Scalars['String']['output']>;
  self?: Maybe<Scalars['String']['output']>;
  tinyui?: Maybe<Scalars['String']['output']>;
  webui?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalLongTask = {
  __typename?: 'ExperimentalLongTask';
  _links?: Maybe<ExperimentalTaskLinks>;
  elapsedTime?: Maybe<Scalars['Int']['output']>;
  finished: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  messages: Array<ExperimentalTaskMessage>;
  name?: Maybe<ExperimentalTaskName>;
  percentageComplete?: Maybe<Scalars['Int']['output']>;
  successful: Scalars['Boolean']['output'];
};

/** A simplified version of the macro's ADF node */
export type ExperimentalMacroNode = {
  /** The type of macro */
  extensionKey: Scalars['String']['input'];
  extensionType: Scalars['String']['input'];
  /** The type of macro */
  parameters: ExperimentalMacroParameters;
  /** The type of ADF node */
  type: Scalars['String']['input'];
};

export type ExperimentalMacroParameters = {
  macroMetadata: Scalars['String']['input'];
  macroParams: Scalars['String']['input'];
};

/** The metadata payload for a given macro */
export type ExperimentalMacroPayload = {
  __typename?: 'ExperimentalMacroPayload';
  contentId?: Maybe<Scalars['String']['output']>;
  /** The metadata payload stringified */
  payload?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalMacroPlaceholderResponse = {
  __typename?: 'ExperimentalMacroPlaceholderResponse';
  json: Scalars['String']['output'];
};

export type ExperimentalMarketplaceApp = {
  __typename?: 'ExperimentalMarketplaceApp';
  key: Scalars['String']['output'];
  listingUrl?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ratings: ExperimentalMarketplaceAppRating;
  tagLine?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalMarketplaceAppRating = {
  __typename?: 'ExperimentalMarketplaceAppRating';
  averageStars: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
};

export type ExperimentalMigratePages = {
  __typename?: 'ExperimentalMigratePages';
  status?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalMigrateTemplate = {
  __typename?: 'ExperimentalMigrateTemplate';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalNotification = {
  __typename?: 'ExperimentalNotification';
  content: ExperimentalNotificationContent;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  path: Array<ExperimentalNotificationPathNode>;
  readState: ExperimentalNotificationReadState;
  timestamp: Scalars['String']['output'];
};

export type ExperimentalNotificationActor = {
  __typename?: 'ExperimentalNotificationActor';
  avatarUrl: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ExperimentalNotificationBody = {
  __typename?: 'ExperimentalNotificationBody';
  data: Scalars['String']['output'];
  format: Scalars['String']['output'];
};

export type ExperimentalNotificationContent = {
  __typename?: 'ExperimentalNotificationContent';
  actor: ExperimentalNotificationActor;
  body?: Maybe<ExperimentalNotificationBody>;
  iconUrl: Scalars['String']['output'];
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type ExperimentalNotificationPathNode = {
  __typename?: 'ExperimentalNotificationPathNode';
  iconUrl?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum ExperimentalNotificationReadState {
  READ = 'READ',
  UNREAD = 'UNREAD'
}

export type ExperimentalNotificationsResponse = {
  __typename?: 'ExperimentalNotificationsResponse';
  cursor: Scalars['String']['output'];
  nodes: Array<ExperimentalNotification>;
};

export enum ExperimentalNotifyOnError {
  EVERYERROR = 'EVERYERROR',
  FIRSTERROR = 'FIRSTERROR',
  NEVER = 'NEVER'
}

export type ExperimentalOnboardingCompletion = {
  __typename?: 'ExperimentalOnboardingCompletion';
  complete?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalOnboardingIntegration = {
  __typename?: 'ExperimentalOnboardingIntegration';
  appKey: Scalars['String']['output'];
  isInstalled: Scalars['Boolean']['output'];
};

export type ExperimentalOnboardingSpace = {
  __typename?: 'ExperimentalOnboardingSpace';
  description?: Maybe<Scalars['String']['output']>;
  draftId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalOnboardingSpaceBlueprints = {
  __typename?: 'ExperimentalOnboardingSpaceBlueprints';
  spaceBlueprints?: Maybe<Array<Maybe<ExperimentalBlueprint>>>;
};

export type ExperimentalOnboardingTemplate = {
  __typename?: 'ExperimentalOnboardingTemplate';
  templateId?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalOpenInvite = {
  __typename?: 'ExperimentalOpenInvite';
  mode: Scalars['String']['output'];
};

export type ExperimentalOpenInviteSettings = {
  __typename?: 'ExperimentalOpenInviteSettings';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalOpenInviteSettingsInput = {
  mode: Scalars['String']['input'];
};

export type ExperimentalOperationCheckResult = {
  __typename?: 'ExperimentalOperationCheckResult';
  links?: Maybe<ExperimentalLinksContextBase>;
  operation?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalPageInfo = {
  __typename?: 'ExperimentalPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum ExperimentalPathType {
  ABSOLUTE = 'ABSOLUTE',
  RELATIVE = 'RELATIVE',
  RELATIVE_NO_CONTEXT = 'RELATIVE_NO_CONTEXT'
}

export type ExperimentalPromotedSpace = {
  __typename?: 'ExperimentalPromotedSpace';
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalPromotedSpaces = {
  __typename?: 'ExperimentalPromotedSpaces';
  nodes?: Maybe<Array<Maybe<ExperimentalPromotedSpace>>>;
};

export type ExperimentalPublishContent = {
  __typename?: 'ExperimentalPublishContent';
  draftUrl?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalPublishContentLink = {
  __typename?: 'ExperimentalPublishContentLink';
  links?: Maybe<ExperimentalPublishContent>;
};

export type ExperimentalPublishEditorContentResponse = {
  __typename?: 'ExperimentalPublishEditorContentResponse';
  createdDate?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  space?: Maybe<ExperimentalPublishEditorContentResponseSpace>;
  status?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalPublishEditorContentResponseSpace = {
  __typename?: 'ExperimentalPublishEditorContentResponseSpace';
  name?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalPublishPageAsBlog = {
  __typename?: 'ExperimentalPublishPageAsBlog';
  _links?: Maybe<ExperimentalPublishPageAsBlogLinks>;
  id?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalPublishPageAsBlogLinks = {
  __typename?: 'ExperimentalPublishPageAsBlogLinks';
  editui?: Maybe<Scalars['String']['output']>;
  webui?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalQuickLinks = {
  __typename?: 'ExperimentalQuickLinks';
  quickLinks?: Maybe<Array<Maybe<ExperimentalSpaceSidebarQuickLink>>>;
};

/** See also: CCGraphQLSchema : QuickReload */
export type ExperimentalQuickReload = {
  __typename?: 'ExperimentalQuickReload';
  comments: Array<ExperimentalQuickReloadComment>;
  editorForPage?: Maybe<ExperimentalQuickReloadUser>;
  time: Scalars['ExperimentalLong']['output'];
};

/** See also: CCGraphQLSchema : QuickReloadComment */
export type ExperimentalQuickReloadComment = {
  __typename?: 'ExperimentalQuickReloadComment';
  comment?: Maybe<ExperimentalQuickReloadCommentComment>;
};

/** See also: CCGraphQLSchema : Comment */
export type ExperimentalQuickReloadCommentComment = {
  __typename?: 'ExperimentalQuickReloadCommentComment';
  author: ExperimentalQuickReloadUser;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** See also: CCGraphQLSchema : Person */
export type ExperimentalQuickReloadUser = {
  __typename?: 'ExperimentalQuickReloadUser';
  accountId?: Maybe<Scalars['ID']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalRecentContainer = {
  __typename?: 'ExperimentalRecentContainer';
  iconUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalRecentContainerList = {
  __typename?: 'ExperimentalRecentContainerList';
  recentContainers?: Maybe<Array<Maybe<ExperimentalRecentContainer>>>;
};

export type ExperimentalRelation = {
  __typename?: 'ExperimentalRelation';
  _expandable?: Maybe<ExperimentalExpandable>;
  _links?: Maybe<ExperimentalLinks>;
  name?: Maybe<Scalars['String']['output']>;
  relationData?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalRelationDataForContent = {
  __typename?: 'ExperimentalRelationDataForContent';
  friendlyCreatedDate?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalRelationForContent = {
  __typename?: 'ExperimentalRelationForContent';
  relationData?: Maybe<ExperimentalRelationDataForContent>;
  source?: Maybe<ExperimentalKnownUser>;
};

export type ExperimentalRelations = {
  __typename?: 'ExperimentalRelations';
  _links?: Maybe<ExperimentalLinks>;
  context?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  results?: Maybe<Array<Maybe<ExperimentalRelation>>>;
  size?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalRelationsForContent = {
  __typename?: 'ExperimentalRelationsForContent';
  results?: Maybe<Array<Maybe<ExperimentalRelationForContent>>>;
};

export type ExperimentalRemoveUnlicensedPermissionResponse = {
  __typename?: 'ExperimentalRemoveUnlicensedPermissionResponse';
  success: Scalars['Boolean']['output'];
};

export type ExperimentalRequestAccess = {
  __typename?: 'ExperimentalRequestAccess';
  complete: Scalars['Boolean']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalResetCollabServiceResponse = {
  __typename?: 'ExperimentalResetCollabServiceResponse';
  traceId: Scalars['String']['output'];
};

export type ExperimentalResolveProperties = {
  __typename?: 'ExperimentalResolveProperties';
  resolvedByDangling: Scalars['Boolean']['output'];
  resolvedFriendlyDate: Scalars['String']['output'];
  resolvedUser: Scalars['String']['output'];
};

export type ExperimentalRuleHomeBilling = {
  __typename?: 'ExperimentalRuleHomeBilling';
  locationARI?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalRuleHomeLifecycle = {
  __typename?: 'ExperimentalRuleHomeLifecycle';
  locationARI?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSearchSessionType = {
  referrerId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};

export type ExperimentalShareRequestBodyCommentType = {
  format: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ExperimentalShareRequestBodyContentType = {
  ari: Scalars['String']['input'];
  link: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ExperimentalShareRequestBodyMetadataType = {
  atlOriginId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
  shareeAction?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentalShareRequestBodyType = {
  comment?: InputMaybe<ExperimentalShareRequestBodyCommentType>;
  content: ExperimentalShareRequestBodyContentType;
  metadata: ExperimentalShareRequestBodyMetadataType;
  recipients: Array<ExperimentalShareRequestBodyUserOrGroupEntityList>;
};

export type ExperimentalShareRequestBodyUserOrGroupEntityList = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ExperimentalShareResponse = {
  __typename?: 'ExperimentalShareResponse';
  status?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExperimentalSitePersonalization = {
  __typename?: 'ExperimentalSitePersonalization';
  attributes?: Maybe<Array<ExperimentalSitePersonalizationAttributes>>;
};

export type ExperimentalSitePersonalizationAttributes = {
  __typename?: 'ExperimentalSitePersonalizationAttributes';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExperimentalSiteSignUpSettings = {
  __typename?: 'ExperimentalSiteSignUpSettings';
  domains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  notifyAdmin?: Maybe<Scalars['Boolean']['output']>;
  openInvite?: Maybe<Scalars['Boolean']['output']>;
  selfJoinMode?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSiteSignUpSettingsInput = {
  domains: Array<InputMaybe<Scalars['String']['input']>>;
  notifyAdmin: Scalars['Boolean']['input'];
  openInvite: Scalars['Boolean']['input'];
  selfJoinMode: Scalars['String']['input'];
};

export type ExperimentalSpace = {
  __typename?: 'ExperimentalSpace';
  statusCode: Scalars['Int']['output'];
};

export type ExperimentalSpaceLogo = {
  __typename?: 'ExperimentalSpaceLogo';
  iconPath?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSpaceOrContent = {
  __typename?: 'ExperimentalSpaceOrContent';
  ancestors?: Maybe<Array<Maybe<ExperimentalContent>>>;
  body?: Maybe<ExperimentalContentBodyPerRepresentation>;
  container?: Maybe<ExperimentalSpaceOrContent>;
  history?: Maybe<ExperimentalHistory>;
  homepage?: Maybe<ExperimentalContent>;
  homepageId?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<ExperimentalIcon>;
  id?: Maybe<Scalars['ID']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSpaceProperty = {
  __typename?: 'ExperimentalSpaceProperty';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  version?: Maybe<ExperimentalSpacePropertyVersion>;
};

export type ExperimentalSpacePropertyVersion = {
  __typename?: 'ExperimentalSpacePropertyVersion';
  number?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalSpaceSidebarLink = {
  id?: InputMaybe<Scalars['ID']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentalSpaceSidebarQuickLink = {
  __typename?: 'ExperimentalSpaceSidebarQuickLink';
  id?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  styleClass?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSpaceWatch = {
  __typename?: 'ExperimentalSpaceWatch';
  key?: Maybe<Scalars['String']['output']>;
  watching?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalSuggestLabel = {
  __typename?: 'ExperimentalSuggestLabel';
  className?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSuperBatchWebResources = {
  __typename?: 'ExperimentalSuperBatchWebResources';
  links?: Maybe<ExperimentalLinksContextBase>;
  metatags?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<ExperimentalWebResourceTags>;
  uris?: Maybe<ExperimentalWebResourceUris>;
};

export type ExperimentalSynchronyJwt = {
  __typename?: 'ExperimentalSynchronyJwt';
  applicationId?: Maybe<Scalars['String']['output']>;
  configuredUrl?: Maybe<Scalars['String']['output']>;
  synchronyExpiry?: Maybe<Scalars['String']['output']>;
  synchronyToken?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSynchronySnapshot = {
  __typename?: 'ExperimentalSynchronySnapshot';
  adf?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalSystemInfoSettings = {
  __typename?: 'ExperimentalSystemInfoSettings';
  baseUrl?: Maybe<Scalars['String']['output']>;
  defaultTimeZone?: Maybe<Scalars['String']['output']>;
  fallbackBaseUrl?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCCustomEventType = {
  __typename?: 'ExperimentalTCCustomEventType';
  created?: Maybe<Scalars['String']['output']>;
  customEventTypeId?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  parentSubCalendarId?: Maybe<Scalars['String']['output']>;
  periodInMins?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCDateField = {
  __typename?: 'ExperimentalTCDateField';
  customfield: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExperimentalTCDecoratedSubCalendar = {
  __typename?: 'ExperimentalTCDecoratedSubCalendar';
  administrable: Scalars['Boolean']['output'];
  childSubCalendars?: Maybe<Array<ExperimentalTCDecoratedSubCalendar>>;
  deletable: Scalars['Boolean']['output'];
  editable: Scalars['Boolean']['output'];
  eventsEditable: Scalars['Boolean']['output'];
  eventsHidden: Scalars['Boolean']['output'];
  groupsPermittedToEdit?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groupsPermittedToView?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reminderMe?: Maybe<Scalars['Boolean']['output']>;
  subCalendar: ExperimentalTCSubCalendar;
  subscriberCount?: Maybe<Scalars['Int']['output']>;
  usersPermittedToEdit?: Maybe<Array<Maybe<ExperimentalTCUser>>>;
  usersPermittedToView?: Maybe<Array<Maybe<ExperimentalTCUser>>>;
};

export type ExperimentalTCEvent = {
  __typename?: 'ExperimentalTCEvent';
  allDay?: Maybe<Scalars['Boolean']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  borderColor?: Maybe<Scalars['String']['output']>;
  calendarReloadRequiredOnUpdate?: Maybe<Scalars['Boolean']['output']>;
  className?: Maybe<Scalars['String']['output']>;
  colorScheme?: Maybe<Scalars['String']['output']>;
  confluenceFormattedStartDate?: Maybe<Scalars['String']['output']>;
  customEventTypeId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editable?: Maybe<Scalars['Boolean']['output']>;
  end: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  expandDates?: Maybe<Scalars['Boolean']['output']>;
  extraProperties?: Maybe<ExperimentalTCEventExtraProperties>;
  extraPropertiesTemplate?: Maybe<Scalars['String']['output']>;
  iconLink?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invitees?: Maybe<Array<ExperimentalTCEventInvitees>>;
  localizedEndDate?: Maybe<Scalars['String']['output']>;
  localizedEndTime?: Maybe<Scalars['String']['output']>;
  localizedOriginalEndDate?: Maybe<Scalars['String']['output']>;
  localizedOriginalStartDate?: Maybe<Scalars['String']['output']>;
  localizedStartDate?: Maybe<Scalars['String']['output']>;
  localizedStartTime?: Maybe<Scalars['String']['output']>;
  mediumIconUrl?: Maybe<Scalars['String']['output']>;
  originalEndDateTime: Scalars['String']['output'];
  originalEndTime?: Maybe<Scalars['String']['output']>;
  originalStart?: Maybe<Scalars['String']['output']>;
  originalStartDateTime: Scalars['String']['output'];
  originalStartTime?: Maybe<Scalars['String']['output']>;
  recur?: Maybe<ExperimentalTCEventRecur>;
  recurId?: Maybe<Scalars['String']['output']>;
  rruleStr?: Maybe<Scalars['String']['output']>;
  secondaryBorderColor?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  start: Scalars['String']['output'];
  subCalendarId: Scalars['String']['output'];
  textColor?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  urlAlias?: Maybe<Scalars['String']['output']>;
  where?: Maybe<Scalars['String']['output']>;
  workingUrl?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCEventExtraProperties = {
  __typename?: 'ExperimentalTCEventExtraProperties';
  assigneeName?: Maybe<Scalars['String']['output']>;
  assigneeProfileUrl?: Maybe<Scalars['String']['output']>;
  dateField?: Maybe<Scalars['String']['output']>;
  issueLink?: Maybe<Scalars['String']['output']>;
  jiraIssueDisplayDayDuration: Scalars['String']['output'];
  jiraVersionDisplayDayDuration: Scalars['String']['output'];
  releaseNotesLink?: Maybe<Scalars['String']['output']>;
  resolved: Scalars['String']['output'];
  statusText?: Maybe<Scalars['String']['output']>;
  summaryLink?: Maybe<Scalars['String']['output']>;
  viewBoardsUrl?: Maybe<Scalars['String']['output']>;
  viewIssuesLink?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCEventInvitees = {
  __typename?: 'ExperimentalTCEventInvitees';
  avatarIconUrl: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ExperimentalTCEventRecur = {
  __typename?: 'ExperimentalTCEventRecur';
  byDay?: Maybe<Scalars['String']['output']>;
  freq?: Maybe<Scalars['String']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  until?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCEventTypeCustomDeleteResponse = {
  __typename?: 'ExperimentalTCEventTypeCustomDeleteResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalTCEventTypeCustomUpdateResponse = {
  __typename?: 'ExperimentalTCEventTypeCustomUpdateResponse';
  created: Scalars['String']['output'];
  customEventTypeId: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  parentSubCalendarId: Scalars['String']['output'];
  periodInMins: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type ExperimentalTCEventTypeDefaultUpdateResponse = {
  __typename?: 'ExperimentalTCEventTypeDefaultUpdateResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalTCEventTypeDisableResponse = {
  __typename?: 'ExperimentalTCEventTypeDisableResponse';
  modifiedSubCalendarId?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Array<Maybe<ExperimentalTCDecoratedSubCalendar>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalTCEventTypeReminder = {
  __typename?: 'ExperimentalTCEventTypeReminder';
  eventTypeId?: Maybe<Scalars['String']['output']>;
  isCustomEventType?: Maybe<Scalars['Boolean']['output']>;
  periodInMins?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalTCEvents = {
  __typename?: 'ExperimentalTCEvents';
  events?: Maybe<Array<Maybe<ExperimentalTCEvent>>>;
  success: Scalars['Boolean']['output'];
};

export type ExperimentalTCFieldError = {
  __typename?: 'ExperimentalTCFieldError';
  errorMessages: Array<Scalars['String']['output']>;
  field: Scalars['String']['output'];
};

export type ExperimentalTCFormatDate = {
  __typename?: 'ExperimentalTCFormatDate';
  dates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExperimentalTCJiraCalendarDurations = {
  __typename?: 'ExperimentalTCJiraCalendarDurations';
  endDateFieldName: Scalars['String']['output'];
  startDateFieldName: Scalars['String']['output'];
};

export type ExperimentalTCJiraEventProps = {
  __typename?: 'ExperimentalTCJiraEventProps';
  assigneeName?: Maybe<Scalars['String']['output']>;
  assigneeProfileUrl?: Maybe<Scalars['String']['output']>;
  dateField?: Maybe<Scalars['String']['output']>;
  issueLink?: Maybe<Scalars['String']['output']>;
  jiraIssueDisplayDayDuration?: Maybe<Scalars['String']['output']>;
  jiraVersionDisplayDayDuration?: Maybe<Scalars['String']['output']>;
  releaseNotesLink?: Maybe<Scalars['String']['output']>;
  resolved?: Maybe<Scalars['String']['output']>;
  statusText?: Maybe<Scalars['String']['output']>;
  summaryLink?: Maybe<Scalars['String']['output']>;
  viewBoardsUrl?: Maybe<Scalars['String']['output']>;
  viewIssuesLink?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCJiraLink = {
  __typename?: 'ExperimentalTCJiraLink';
  displayUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExperimentalTCJiraLinks = {
  __typename?: 'ExperimentalTCJiraLinks';
  jiraLinks?: Maybe<Array<ExperimentalTCJiraLink>>;
};

export type ExperimentalTCJiraOption = {
  __typename?: 'ExperimentalTCJiraOption';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExperimentalTCJiraOptions = {
  __typename?: 'ExperimentalTCJiraOptions';
  projects?: Maybe<Array<ExperimentalTCJiraOption>>;
  searchRequests?: Maybe<Array<ExperimentalTCJiraSearchRequest>>;
};

export type ExperimentalTCJiraSearchRequest = {
  __typename?: 'ExperimentalTCJiraSearchRequest';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ExperimentalTCSubCalendar = {
  __typename?: 'ExperimentalTCSubCalendar';
  applicationId?: Maybe<Scalars['String']['output']>;
  applicationName?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  customEventTypes?: Maybe<Array<Maybe<ExperimentalTCCustomEventType>>>;
  dateFieldNames?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  disableEventTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  durations?: Maybe<Array<ExperimentalTCJiraCalendarDurations>>;
  id?: Maybe<Scalars['String']['output']>;
  jql?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  sanboxEventTypeReminders?: Maybe<Array<Maybe<ExperimentalTCEventTypeReminder>>>;
  searchFilterId?: Maybe<Scalars['Int']['output']>;
  sourceLocation?: Maybe<Scalars['String']['output']>;
  spaceKey?: Maybe<Scalars['String']['output']>;
  spaceName?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  subscriptionType?: Maybe<Scalars['String']['output']>;
  timeZoneId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCSubCalendars = {
  __typename?: 'ExperimentalTCSubCalendars';
  payload?: Maybe<Array<ExperimentalTCDecoratedSubCalendar>>;
  success: Scalars['Boolean']['output'];
};

export type ExperimentalTCSubscriberCount = {
  __typename?: 'ExperimentalTCSubscriberCount';
  subscriptionCount: Scalars['Int']['output'];
};

export type ExperimentalTCTimezone = {
  __typename?: 'ExperimentalTCTimezone';
  name: Scalars['String']['output'];
  offset: Scalars['String']['output'];
};

export type ExperimentalTCTimezones = {
  __typename?: 'ExperimentalTCTimezones';
  timeZones?: Maybe<Array<Maybe<ExperimentalTCTimezone>>>;
};

export type ExperimentalTCUser = {
  __typename?: 'ExperimentalTCUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTCWatchStatus = {
  __typename?: 'ExperimentalTCWatchStatus';
  payload?: Maybe<Array<Maybe<ExperimentalTCWatchStatusEachCal>>>;
};

export type ExperimentalTCWatchStatusEachCal = {
  __typename?: 'ExperimentalTCWatchStatusEachCal';
  isWatchable?: Maybe<Scalars['Boolean']['output']>;
  subCalendarId?: Maybe<Scalars['String']['output']>;
  watched?: Maybe<Scalars['Boolean']['output']>;
  watchedViaContent?: Maybe<Scalars['Boolean']['output']>;
};

export enum ExperimentalTagType {
  BILLABLE = 'BILLABLE',
  CREATION_TYPE = 'CREATION_TYPE',
  IS_RULE_UPDATED = 'IS_RULE_UPDATED',
  POLLING = 'POLLING',
  SAMPLE_RULE = 'SAMPLE_RULE',
  SAMPLE_RULE_INTENT = 'SAMPLE_RULE_INTENT',
  SERVICE_LIMIT_BREACHED = 'SERVICE_LIMIT_BREACHED',
  TEMPLATE_ID = 'TEMPLATE_ID',
  USES_DEVOPS_INTEGRATION = 'USES_DEVOPS_INTEGRATION',
  WEBHOOK_TOKEN = 'WEBHOOK_TOKEN'
}

export type ExperimentalTaskLinks = {
  __typename?: 'ExperimentalTaskLinks';
  base?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalTaskMessage = {
  __typename?: 'ExperimentalTaskMessage';
  args: Array<Maybe<Scalars['String']['output']>>;
  translation: Scalars['String']['output'];
};

export type ExperimentalTaskName = {
  __typename?: 'ExperimentalTaskName';
  args?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  key: Scalars['String']['output'];
};

export type ExperimentalTeamCalendarColorsResponse = {
  __typename?: 'ExperimentalTeamCalendarColorsResponse';
  modifiedSubCalendarId?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Array<Maybe<ExperimentalTCDecoratedSubCalendar>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalTeamCalendarDeleteEventResponse = {
  __typename?: 'ExperimentalTeamCalendarDeleteEventResponse';
  success: Scalars['Boolean']['output'];
};

export type ExperimentalTeamCalendarEditResponse = {
  __typename?: 'ExperimentalTeamCalendarEditResponse';
  fieldErrors?: Maybe<Array<Maybe<ExperimentalTCFieldError>>>;
  modifiedSubCalendarId?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Array<Maybe<ExperimentalTCDecoratedSubCalendar>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalTeamCalendarImportResponse = {
  __typename?: 'ExperimentalTeamCalendarImportResponse';
  fieldErrors?: Maybe<Array<ExperimentalTCFieldError>>;
  subCalendarId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ExperimentalTeamCalendarJiraJQLValidateResponse = {
  __typename?: 'ExperimentalTeamCalendarJiraJQLValidateResponse';
  valid: Scalars['Boolean']['output'];
};

export type ExperimentalTeamCalendarRemindersResponse = {
  __typename?: 'ExperimentalTeamCalendarRemindersResponse';
  for_user?: Maybe<Scalars['String']['output']>;
  on_calendar?: Maybe<Scalars['String']['output']>;
  reminder_status?: Maybe<Scalars['Boolean']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalTeamCalendarRestrictionResponse = {
  __typename?: 'ExperimentalTeamCalendarRestrictionResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalTeamCalendarsAddEventPerson = {
  person?: InputMaybe<Scalars['String']['input']>;
};

export type ExperimentalTeamCalendarsAddEventResponse = {
  __typename?: 'ExperimentalTeamCalendarsAddEventResponse';
  event?: Maybe<ExperimentalTCEvent>;
  fieldErrors?: Maybe<Array<Maybe<ExperimentalTCFieldError>>>;
  subCalendar?: Maybe<ExperimentalTCDecoratedSubCalendar>;
  success: Scalars['Boolean']['output'];
};

export type ExperimentalTeamCalendarsResetSubscribeLinkResponse = {
  __typename?: 'ExperimentalTeamCalendarsResetSubscribeLinkResponse';
  success: Scalars['Boolean']['output'];
};

export type ExperimentalTeamCalendarsSubscribe = {
  __typename?: 'ExperimentalTeamCalendarsSubscribe';
  url?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalThemeAPIMigrations = {
  __typename?: 'ExperimentalThemeAPIMigrations';
  gdpr?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalThemeSpaceHomeOverride = {
  __typename?: 'ExperimentalThemeSpaceHomeOverride';
  hasSpaceHomeOverride: Scalars['Boolean']['output'];
  spaceHomeOverrideDescriptor?: Maybe<ExperimentalConnectIFrame>;
};

export type ExperimentalUnlicensedPermissionResponse = {
  __typename?: 'ExperimentalUnlicensedPermissionResponse';
  unlicensedPermissionId?: Maybe<Scalars['Int']['output']>;
};

export type ExperimentalUpdateAutomationRuleConfigBean = {
  actor: ExperimentalAutomationUpdateRuleActor;
  authorAccountId?: InputMaybe<Scalars['ID']['input']>;
  billingType: ExperimentalAutomationBillingType;
  canOtherRuleTrigger: Scalars['Boolean']['input'];
  clientKey: Scalars['String']['input'];
  collaborators: Array<InputMaybe<Scalars['JSON']['input']>>;
  components: Array<InputMaybe<ExperimentalAutomationUpdateRuleComponent>>;
  created: Scalars['ExperimentalLong']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ExperimentalLong']['input'];
  labels: Array<InputMaybe<Scalars['JSON']['input']>>;
  name: Scalars['String']['input'];
  notifyOnError: Scalars['String']['input'];
  projects: Array<InputMaybe<Scalars['JSON']['input']>>;
  ruleHome: ExperimentalAutomationUpdateRuleHome;
  ruleScope: ExperimentalAutomationUpdateRuleScope;
  state: ExperimentalAutomationRuleState;
  tags: Array<InputMaybe<ExperimentalAutomationUpdateRuleTag>>;
  trigger: ExperimentalAutomationUpdateRuleComponent;
  updated: Scalars['ExperimentalLong']['input'];
  writeAccessType: ExperimentalAutomationWriteAccessType;
};

export type ExperimentalUpdateAutomationRuleConnectionResponse = {
  __typename?: 'ExperimentalUpdateAutomationRuleConnectionResponse';
  id: Scalars['ExperimentalLong']['output'];
  state: ExperimentalAutomationRuleState;
};

export type ExperimentalUpdateAutomationRuleResponse = {
  __typename?: 'ExperimentalUpdateAutomationRuleResponse';
  id: Scalars['ExperimentalLong']['output'];
  state: ExperimentalAutomationRuleState;
};

export type ExperimentalUpdateContentProperty = {
  __typename?: 'ExperimentalUpdateContentProperty';
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalUpdateInstanceContent = {
  __typename?: 'ExperimentalUpdateInstanceContent';
  _links?: Maybe<ExperimentalUpdateInstanceLinks>;
  id?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<ExperimentalUpdateInstanceMetadata>;
  space?: Maybe<ExperimentalUpdateInstanceSpace>;
  subType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalUpdateInstanceLinks = {
  __typename?: 'ExperimentalUpdateInstanceLinks';
  editui?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalUpdateInstanceMetadata = {
  __typename?: 'ExperimentalUpdateInstanceMetadata';
  properties?: Maybe<ExperimentalUpdateInstanceMetadataProperties>;
};

export type ExperimentalUpdateInstanceMetadataProperties = {
  __typename?: 'ExperimentalUpdateInstanceMetadataProperties';
  editor?: Maybe<ExperimentalUpdateInstanceMetadataPropertiesEditor>;
};

export type ExperimentalUpdateInstanceMetadataPropertiesEditor = {
  __typename?: 'ExperimentalUpdateInstanceMetadataPropertiesEditor';
  value?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalUpdateInstanceResponse = {
  __typename?: 'ExperimentalUpdateInstanceResponse';
  content?: Maybe<ExperimentalUpdateInstanceContent>;
};

export type ExperimentalUpdateInstanceSpace = {
  __typename?: 'ExperimentalUpdateInstanceSpace';
  id?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalUser = {
  __typename?: 'ExperimentalUser';
  accountId?: Maybe<Scalars['ID']['output']>;
  currentUserCanFollow?: Maybe<Scalars['Boolean']['output']>;
  currentUserIsFollowing?: Maybe<Scalars['Boolean']['output']>;
  detailsDepartment?: Maybe<Scalars['String']['output']>;
  detailsLocation?: Maybe<Scalars['String']['output']>;
  detailsPosition?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  hasBlog?: Maybe<Scalars['Boolean']['output']>;
  hasExperimentalKnownUseralSpace?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<ExperimentalIcon>;
};

export type ExperimentalUserInvitation = {
  __typename?: 'ExperimentalUserInvitation';
  email?: Maybe<Scalars['String']['output']>;
  results?: Maybe<ExperimentalUserInvitationResults>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum ExperimentalUserInvitationResult {
  INVITED = 'INVITED',
  INVITED_PENDING_APPROVAL = 'INVITED_PENDING_APPROVAL',
  PENDING_INVITE_EXISTS = 'PENDING_INVITE_EXISTS',
  PRODUCT_ADDED = 'PRODUCT_ADDED',
  PRODUCT_EXISTS = 'PRODUCT_EXISTS',
  USER_EXISTS = 'USER_EXISTS'
}

export type ExperimentalUserInvitationResults = {
  __typename?: 'ExperimentalUserInvitationResults';
  conf?: Maybe<ExperimentalUserInvitationResult>;
};

export type ExperimentalUserPermissions = {
  __typename?: 'ExperimentalUserPermissions';
  canAddProducts?: Maybe<Scalars['Boolean']['output']>;
  canInviteUsers?: Maybe<Scalars['Boolean']['output']>;
};

export type ExperimentalUserPersonalization = {
  __typename?: 'ExperimentalUserPersonalization';
  attributes?: Maybe<Array<ExperimentalUserPersonalizationAttributes>>;
};

export type ExperimentalUserPersonalizationAttributes = {
  __typename?: 'ExperimentalUserPersonalizationAttributes';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ExperimentalVersion = {
  __typename?: 'ExperimentalVersion';
  by?: Maybe<ExperimentalKnownUser>;
  collaborators?: Maybe<Array<Maybe<ExperimentalKnownUser>>>;
  confRev?: Maybe<Scalars['String']['output']>;
  friendlyWhen?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  minorEdit?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  when?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalWebResourceDependencies = {
  __typename?: 'ExperimentalWebResourceDependencies';
  contexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  links?: Maybe<ExperimentalLinksContextBase>;
  superbatch?: Maybe<ExperimentalSuperBatchWebResources>;
  tags?: Maybe<ExperimentalWebResourceTags>;
  uris?: Maybe<ExperimentalWebResourceUris>;
};

export type ExperimentalWebResourceTags = {
  __typename?: 'ExperimentalWebResourceTags';
  css?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  js?: Maybe<Scalars['String']['output']>;
};

export type ExperimentalWebResourceUris = {
  __typename?: 'ExperimentalWebResourceUris';
  css?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  js?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type GroupRestrictions = {
  results?: InputMaybe<Array<InputMaybe<RESTGroup>>>;
};

export type MentionOptions = {
  notificationAction: NotificationActionEnum;
};

export type MoveRequestObj = {
  position?: InputMaybe<Scalars['String']['input']>;
  targetId?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  experimentalAddCustomizedPersonalSpace?: Maybe<ExperimentalAddCustomizedPersonalSpaceResult>;
  experimentalAddPersonalSpaceLink?: Maybe<Scalars['Boolean']['output']>;
  experimentalAddSpaceLink?: Maybe<Scalars['Boolean']['output']>;
  experimentalArchiveSpace?: Maybe<ExperimentalArchiveSpace>;
  experimentalCancelScheduledPublish?: Maybe<ExperimentalCancelScheduledPublishResponse>;
  experimentalCopyPageTree?: Maybe<ExperimentalCopyPageTreeResponse>;
  experimentalCreateAutomationRuleFromTemplate?: Maybe<ExperimentalCreateAutomationRuleFromTemplateResponse>;
  experimentalCreateBlankFabricPage?: Maybe<ExperimentalCreateContentResponse>;
  experimentalCreateDemoSpace?: Maybe<ExperimentalDemoSpace>;
  experimentalCreateFabricBlogpost?: Maybe<ExperimentalCreateContentResponse>;
  experimentalCreateSpecificSpace?: Maybe<ExperimentalOnboardingSpace>;
  experimentalDeleteComment?: Maybe<ExperimentalDeleteComment>;
  experimentalDeleteContentVersion?: Maybe<Scalars['Boolean']['output']>;
  experimentalDisableKeyboardShortcuts?: Maybe<ExperimentalKeyboardShortcutsStatus>;
  experimentalDraftSync?: Maybe<ExperimentalContent>;
  experimentalEditorStartHeartbeat?: Maybe<ExperimentalEditorHeartbeatResponse>;
  experimentalEditorStopHeartbeat?: Maybe<Scalars['Boolean']['output']>;
  experimentalEnableKeyboardShortcuts?: Maybe<ExperimentalKeyboardShortcutsStatus>;
  experimentalFavouriteSpace?: Maybe<ExperimentalFavouriteSpaceType>;
  experimentalFileUpload?: Maybe<Scalars['Boolean']['output']>;
  experimentalGrantAccess?: Maybe<ExperimentalGrantAccess>;
  experimentalMigratePages?: Maybe<ExperimentalMigratePages>;
  experimentalMigrateTemplate?: Maybe<ExperimentalMigrateTemplate>;
  experimentalPublishEditorContent?: Maybe<ExperimentalPublishEditorContentResponse>;
  experimentalPublishPageAsBlog?: Maybe<ExperimentalPublishPageAsBlog>;
  experimentalPublishPageByBlueprint?: Maybe<ExperimentalPublishContentLink>;
  experimentalPublishPageByTemplate?: Maybe<ExperimentalPublishContentLink>;
  experimentalRemoveSpaceLink?: Maybe<Scalars['Boolean']['output']>;
  experimentalRemoveUnlicensedPermission?: Maybe<ExperimentalRemoveUnlicensedPermissionResponse>;
  experimentalRequestAccess?: Maybe<ExperimentalRequestAccess>;
  experimentalResetCollabService?: Maybe<ExperimentalResetCollabServiceResponse>;
  experimentalRestoreContentVersion?: Maybe<ExperimentalContentVersionRestored>;
  experimentalRevertContent?: Maybe<Scalars['Boolean']['output']>;
  experimentalSaveFabricComment?: Maybe<ExperimentalFabricComment>;
  experimentalSetFeatureDiscovered?: Maybe<ExperimentalDiscoveredFeature>;
  experimentalSetHaveISeenIt?: Maybe<Scalars['Boolean']['output']>;
  experimentalShare?: Maybe<ExperimentalShareResponse>;
  experimentalSubmitFeedbackCollector?: Maybe<ExperimentalJiraIssue>;
  experimentalTeamCalendarColors?: Maybe<ExperimentalTeamCalendarColorsResponse>;
  experimentalTeamCalendarDelete?: Maybe<ExperimentalTCSubCalendars>;
  experimentalTeamCalendarDeleteAllFutureEvents?: Maybe<ExperimentalTeamCalendarDeleteEventResponse>;
  experimentalTeamCalendarDeleteEvent?: Maybe<ExperimentalTeamCalendarDeleteEventResponse>;
  experimentalTeamCalendarDeleteSingleEvent?: Maybe<ExperimentalTeamCalendarDeleteEventResponse>;
  experimentalTeamCalendarEdit?: Maybe<ExperimentalTeamCalendarEditResponse>;
  experimentalTeamCalendarEventTypeCustomDelete?: Maybe<ExperimentalTCEventTypeCustomDeleteResponse>;
  experimentalTeamCalendarEventTypeCustomUpdate?: Maybe<ExperimentalTCEventTypeCustomUpdateResponse>;
  experimentalTeamCalendarEventTypeDefaultUpdate?: Maybe<ExperimentalTCEventTypeDefaultUpdateResponse>;
  experimentalTeamCalendarImport?: Maybe<ExperimentalTeamCalendarImportResponse>;
  experimentalTeamCalendarJiraJQLValidate?: Maybe<ExperimentalTeamCalendarJiraJQLValidateResponse>;
  experimentalTeamCalendarPreferences?: Maybe<ExperimentalTCSubCalendars>;
  experimentalTeamCalendarReminders?: Maybe<ExperimentalTeamCalendarRemindersResponse>;
  experimentalTeamCalendarResetSubscribeLink?: Maybe<Scalars['Boolean']['output']>;
  experimentalTeamCalendarRestriction?: Maybe<ExperimentalTeamCalendarRestrictionResponse>;
  experimentalTeamCalendarSubscribe?: Maybe<ExperimentalTCSubCalendars>;
  experimentalTeamCalendarUpdateViewPreference: Scalars['Boolean']['output'];
  experimentalTeamCalendar_EventType_Disable?: Maybe<ExperimentalTCEventTypeDisableResponse>;
  experimentalTeamCalendar_Hide?: Maybe<Scalars['Boolean']['output']>;
  experimentalTeamCalendar_Watch?: Maybe<Scalars['Boolean']['output']>;
  experimentalTeamCalendarsAddEvent?: Maybe<ExperimentalTeamCalendarsAddEventResponse>;
  experimentalUnfavouriteSpace?: Maybe<ExperimentalFavouriteSpaceType>;
  experimentalUpdateAutomationRule?: Maybe<ExperimentalUpdateAutomationRuleResponse>;
  experimentalUpdateAutomationRuleWithConnection?: Maybe<ExperimentalUpdateAutomationRuleConnectionResponse>;
  experimentalUpdateContentProperty?: Maybe<ExperimentalUpdateContentProperty>;
  experimentalUpdateDesSettings?: Maybe<ExperimentalDesSettings>;
  experimentalUpdateDraftWithBlueprint?: Maybe<ExperimentalUpdateInstanceResponse>;
  experimentalUpdateDraftWithTemplate?: Maybe<ExperimentalUpdateInstanceResponse>;
  experimentalUpdateOpenInviteSettings?: Maybe<ExperimentalOpenInviteSettings>;
  experimentalUpdateShortcutLinks?: Maybe<ExperimentalQuickLinks>;
  experimentalUpdateSiteSignUpSettings?: Maybe<ExperimentalSiteSignUpSettings>;
  experimentalUpdateSpaceLogo?: Maybe<ExperimentalSpaceLogo>;
};


export type MutationexperimentalAddCustomizedPersonalSpaceArgs = {
  spaceName: Scalars['String']['input'];
};


export type MutationexperimentalAddPersonalSpaceLinkArgs = {
  spaceUserKey: Scalars['String']['input'];
};


export type MutationexperimentalAddSpaceLinkArgs = {
  id: Scalars['String']['input'];
  spaceKey: Scalars['String']['input'];
};


export type MutationexperimentalArchiveSpaceArgs = {
  archived: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  homePageTitle: Scalars['String']['input'];
  spaceKey: Scalars['String']['input'];
  spaceName: Scalars['String']['input'];
};


export type MutationexperimentalCancelScheduledPublishArgs = {
  contentId: Scalars['ID']['input'];
};


export type MutationexperimentalCopyPageTreeArgs = {
  contentId: Scalars['String']['input'];
  copyDescendants: Scalars['Boolean']['input'];
  copyLabels: Scalars['Boolean']['input'];
  copyPermissions: Scalars['Boolean']['input'];
  destinationPageId: Scalars['String']['input'];
  mentionOptions: MentionOptions;
  prefix: Scalars['String']['input'];
  replace: Scalars['String']['input'];
  search: Scalars['String']['input'];
};


export type MutationexperimentalCreateAutomationRuleFromTemplateArgs = {
  automationStack: Scalars['String']['input'];
  cloudId: Scalars['String']['input'];
  parameters?: InputMaybe<Array<ExperimentalCreateAutomationRuleFromTemplateParameter>>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};


export type MutationexperimentalCreateBlankFabricPageArgs = {
  isSpaceAliasFFEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  spaceKey: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalCreateDemoSpaceArgs = {
  spaceKey: Scalars['String']['input'];
  spaceName: Scalars['String']['input'];
};


export type MutationexperimentalCreateFabricBlogpostArgs = {
  isSpaceAliasFFEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  returnSpaUrl?: InputMaybe<Scalars['Boolean']['input']>;
  spaceKey: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalCreateSpecificSpaceArgs = {
  hasDraft?: InputMaybe<Scalars['Boolean']['input']>;
  spaceBlueprintId: Scalars['String']['input'];
  spaceKey: Scalars['String']['input'];
  spaceName: Scalars['String']['input'];
};


export type MutationexperimentalDeleteCommentArgs = {
  contentId: Scalars['ID']['input'];
};


export type MutationexperimentalDeleteContentVersionArgs = {
  contentId: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};


export type MutationexperimentalDraftSyncArgs = {
  content: Scalars['String']['input'];
  contentId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
  ncsStepVersion: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalEditorStartHeartbeatArgs = {
  collabService: Scalars['String']['input'];
  contentId: Scalars['ID']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  heartbeatUserType?: InputMaybe<ExperimentalHeartbeatUserType>;
};


export type MutationexperimentalEditorStopHeartbeatArgs = {
  contentId: Scalars['ID']['input'];
  contentType?: InputMaybe<Scalars['String']['input']>;
  heartbeatUserType?: InputMaybe<ExperimentalHeartbeatUserType>;
};


export type MutationexperimentalFavouriteSpaceArgs = {
  spaceKey: Scalars['String']['input'];
};


export type MutationexperimentalFileUploadArgs = {
  collectionName: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  fileStoreId: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  minorEdit?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['String']['input'];
  renderEditorHTML?: InputMaybe<Scalars['Boolean']['input']>;
  size: Scalars['Int']['input'];
  uploadSource?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalGrantAccessArgs = {
  accessType: Scalars['String']['input'];
  accountId: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
};


export type MutationexperimentalMigratePagesArgs = {
  contentHash: Scalars['String']['input'];
  contentId: Scalars['ID']['input'];
};


export type MutationexperimentalMigrateTemplateArgs = {
  templateId: Scalars['ID']['input'];
};


export type MutationexperimentalPublishEditorContentArgs = {
  ancestors?: InputMaybe<Array<InputMaybe<Ancestor>>>;
  content: Scalars['String']['input'];
  contentId: Scalars['ID']['input'];
  contentType: Scalars['String']['input'];
  isBlueprintCreate?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  moveRequest?: InputMaybe<MoveRequestObj>;
  ncsStepVersion?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<ContentRestrictionsObj>;
  schedulePublishDate?: InputMaybe<Scalars['String']['input']>;
  spaceKey: Scalars['String']['input'];
  suppressNotifyWatchers?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MutationexperimentalPublishPageAsBlogArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['String']['input'];
  destinationSpaceKey?: InputMaybe<Scalars['String']['input']>;
  destinationType: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  ncsStepVersion?: InputMaybe<Scalars['String']['input']>;
  restrictions?: InputMaybe<ContentRestrictionsObj>;
  schedulePublishDate?: InputMaybe<Scalars['String']['input']>;
  sourceStatus: Scalars['String']['input'];
  suppressNotifyWatchers?: InputMaybe<Scalars['Boolean']['input']>;
  syncRev?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalPublishPageByBlueprintArgs = {
  attemptSpaUrlResponse?: InputMaybe<Scalars['Boolean']['input']>;
  blueprint: Scalars['String']['input'];
  contentId?: InputMaybe<Scalars['String']['input']>;
  spaceKey: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalPublishPageByTemplateArgs = {
  attemptSpaUrlResponse?: InputMaybe<Scalars['Boolean']['input']>;
  blueprint?: InputMaybe<Scalars['String']['input']>;
  contentId?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  spaceKey: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalRemoveSpaceLinkArgs = {
  id: Scalars['String']['input'];
  spaceKey: Scalars['String']['input'];
};


export type MutationexperimentalRemoveUnlicensedPermissionArgs = {
  permissionId: Scalars['Int']['input'];
  spaceKey: Scalars['String']['input'];
};


export type MutationexperimentalRequestAccessArgs = {
  accessType: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
};


export type MutationexperimentalResetCollabServiceArgs = {
  behind?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalRestoreContentVersionArgs = {
  contentId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  versionNumber: Scalars['Int']['input'];
};


export type MutationexperimentalRevertContentArgs = {
  contentId: Scalars['ID']['input'];
};


export type MutationexperimentalSaveFabricCommentArgs = {
  params?: InputMaybe<ExperimentalFabricCommentInput>;
};


export type MutationexperimentalSetFeatureDiscoveredArgs = {
  featureKey: Scalars['String']['input'];
  pluginKey: Scalars['String']['input'];
};


export type MutationexperimentalSetHaveISeenItArgs = {
  flagKey: Scalars['String']['input'];
};


export type MutationexperimentalShareArgs = {
  requestBody: ExperimentalShareRequestBodyType;
};


export type MutationexperimentalSubmitFeedbackCollectorArgs = {
  component: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  summary: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarColorsArgs = {
  calendarContext: Scalars['String']['input'];
  color: Scalars['String']['input'];
  subCalendarId: Scalars['String']['input'];
  viewingSpaceKey: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarDeleteArgs = {
  calendarContext: Scalars['String']['input'];
  subCalendarId: Scalars['String']['input'];
  viewingSpaceKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalTeamCalendarDeleteAllFutureEventsArgs = {
  recurUntil?: InputMaybe<Scalars['String']['input']>;
  subCalendarId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarDeleteEventArgs = {
  subCalendarId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarDeleteSingleEventArgs = {
  originalStart?: InputMaybe<Scalars['String']['input']>;
  recurUntil?: InputMaybe<Scalars['String']['input']>;
  recurrenceId?: InputMaybe<Scalars['String']['input']>;
  singleInstance?: InputMaybe<Scalars['Boolean']['input']>;
  subCalendarId: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarEditArgs = {
  calendarContext?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  spaceKey?: InputMaybe<Scalars['String']['input']>;
  subCalendarId?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  viewingSpaceKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalTeamCalendarEventTypeCustomDeleteArgs = {
  customEventTypeId: Scalars['String']['input'];
  subCalendarId: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarEventTypeCustomUpdateArgs = {
  created?: InputMaybe<Scalars['String']['input']>;
  customEventTypeId: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  periodInMins: Scalars['Int']['input'];
  subCalendarId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarEventTypeDefaultUpdateArgs = {
  created?: InputMaybe<Scalars['String']['input']>;
  eventTypeId: Scalars['String']['input'];
  icon: Scalars['String']['input'];
  periodInMins: Scalars['Int']['input'];
  subCalendarId: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarImportArgs = {
  calendarId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  decorator?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_0: Scalars['Upload']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  spaceKey?: InputMaybe<Scalars['String']['input']>;
  spaceKeyAutocomplete?: InputMaybe<Scalars['String']['input']>;
  timeZoneId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalTeamCalendarJiraJQLValidateArgs = {
  jql: Scalars['String']['input'];
  serverId: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarPreferencesArgs = {
  calendarContext: Scalars['String']['input'];
  subCalendarId: Scalars['String']['input'];
  viewingSpaceKey?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalTeamCalendarRemindersArgs = {
  isReminder: Scalars['Boolean']['input'];
  subCalendarId: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarResetSubscribeLinkArgs = {
  subCalendarId: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarRestrictionArgs = {
  calendarContext: Scalars['String']['input'];
  groupsPermittedToEdit?: InputMaybe<Array<Scalars['String']['input']>>;
  groupsPermittedToView?: InputMaybe<Array<Scalars['String']['input']>>;
  subCalendarId: Scalars['String']['input'];
  updateGroupsPermittedToEdit?: InputMaybe<Scalars['Boolean']['input']>;
  updateGroupsPermittedToView: Scalars['Boolean']['input'];
  updateUsersPermittedToEdit: Scalars['Boolean']['input'];
  updateUsersPermittedToView: Scalars['Boolean']['input'];
  usersPermittedToEdit?: InputMaybe<Array<Scalars['String']['input']>>;
  usersPermittedToView?: InputMaybe<Array<Scalars['String']['input']>>;
  viewingSpaceKey: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarSubscribeArgs = {
  calendarContext: Scalars['String']['input'];
  color: Scalars['String']['input'];
  subCalendarIds: Array<Scalars['String']['input']>;
  viewingSpaceKey?: InputMaybe<Scalars['String']['input']>;
  watchSubCalendars: Scalars['Boolean']['input'];
};


export type MutationexperimentalTeamCalendarUpdateViewPreferenceArgs = {
  view: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendar_EventType_DisableArgs = {
  calendarId: Scalars['String']['input'];
  disableEventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationexperimentalTeamCalendar_HideArgs = {
  action: Scalars['String']['input'];
  calendarIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationexperimentalTeamCalendar_WatchArgs = {
  action: Scalars['String']['input'];
  calendarId: Scalars['String']['input'];
};


export type MutationexperimentalTeamCalendarsAddEventArgs = {
  allDayEvent?: InputMaybe<Scalars['Boolean']['input']>;
  childSubCalendarId?: InputMaybe<Scalars['String']['input']>;
  customEventTypeId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editAllInRecurrenceSeries?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  originalCustomEventTypeId?: InputMaybe<Scalars['String']['input']>;
  originalEventType?: InputMaybe<Scalars['String']['input']>;
  originalStartDate?: InputMaybe<Scalars['String']['input']>;
  originalSubCalendarId?: InputMaybe<Scalars['String']['input']>;
  persons?: InputMaybe<Array<InputMaybe<ExperimentalTeamCalendarsAddEventPerson>>>;
  recurrenceId?: InputMaybe<Scalars['String']['input']>;
  rruleStr?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  subCalendarId?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userTimeZoneId?: InputMaybe<Scalars['String']['input']>;
  what?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalUnfavouriteSpaceArgs = {
  spaceKey: Scalars['String']['input'];
};


export type MutationexperimentalUpdateAutomationRuleArgs = {
  automationStack: Scalars['String']['input'];
  body: ExperimentalUpdateAutomationRuleConfigBean;
  cloudId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalUpdateAutomationRuleWithConnectionArgs = {
  automationStack: Scalars['String']['input'];
  cloudId: Scalars['String']['input'];
  connections?: InputMaybe<Array<ExperimentalConnectionConfig>>;
  ruleConfig: ExperimentalUpdateAutomationRuleConfigBean;
  ruleId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalUpdateContentPropertyArgs = {
  contentId: Scalars['String']['input'];
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  propertyKey: Scalars['String']['input'];
  propertyValue?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalUpdateDesSettingsArgs = {
  cloudId: Scalars['String']['input'];
  settings?: InputMaybe<ExperimentalDesSettingsInput>;
};


export type MutationexperimentalUpdateDraftWithBlueprintArgs = {
  blueprint: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  parentPageId?: InputMaybe<Scalars['String']['input']>;
  spaceKey: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalUpdateDraftWithTemplateArgs = {
  blueprint: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  context?: InputMaybe<Scalars['String']['input']>;
  parentPageId?: InputMaybe<Scalars['String']['input']>;
  spaceKey: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationexperimentalUpdateOpenInviteSettingsArgs = {
  cloudId: Scalars['String']['input'];
  settings?: InputMaybe<ExperimentalOpenInviteSettingsInput>;
};


export type MutationexperimentalUpdateShortcutLinksArgs = {
  quickLinks?: InputMaybe<Array<InputMaybe<ExperimentalSpaceSidebarLink>>>;
  spaceKey: Scalars['String']['input'];
};


export type MutationexperimentalUpdateSiteSignUpSettingsArgs = {
  cloudId: Scalars['String']['input'];
  settings?: InputMaybe<ExperimentalSiteSignUpSettingsInput>;
};


export type MutationexperimentalUpdateSpaceLogoArgs = {
  logoDataURI: Scalars['String']['input'];
  spaceKey: Scalars['String']['input'];
  spaceName: Scalars['String']['input'];
};

export enum NotificationActionEnum {
  DONT_NOTIFY = 'DONT_NOTIFY',
  NOTIFY = 'NOTIFY'
}

export type ProfilePicture = {
  path?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  experimentalAboutConfluence?: Maybe<ExperimentalAboutConfluence>;
  experimentalAnalyticsActivityByDate?: Maybe<ExperimentalAnalyticsActivityByDateResponse>;
  experimentalAnalyticsActivityBySpace?: Maybe<ExperimentalAnalyticsActivityBySpaceResponse>;
  experimentalAnalyticsActivityByUser?: Maybe<ExperimentalAnalyticsActivityByUserResponse>;
  experimentalAnalyticsContentViews?: Maybe<ExperimentalAnalyticsContentViewsResponse>;
  experimentalAnalyticsViewsByDate?: Maybe<ExperimentalAnalyticsViewsByDateResponse>;
  experimentalAutomationRuleConnections?: Maybe<Array<Maybe<ExperimentalAutomationRuleConnectionsResponse>>>;
  experimentalAutomationRuleSummary?: Maybe<ExperimentalAutomationRuleSummaryResponse>;
  experimentalConnectContext?: Maybe<ExperimentalConnectContext>;
  experimentalConnectServlet?: Maybe<ExperimentalConnectServletResponse>;
  experimentalContentBodyConvert?: Maybe<ExperimentalContentBodyConvertResult>;
  experimentalContentDraftDiff?: Maybe<ExperimentalContentDraftDiff>;
  experimentalCrossProductAdvancedSearch?: Maybe<ExperimentalCrossProductSearchResult>;
  experimentalCurrentUser?: Maybe<ExperimentalCurrentUser>;
  experimentalCustomContentConnectModules: ExperimentalConnectModule;
  experimentalCustomContentPage?: Maybe<ExperimentalCustomContentPageResponse>;
  experimentalCustomContentProperties?: Maybe<ExperimentalCustomContentPropertiesResponse>;
  experimentalCustomContentPropertiesPage?: Maybe<ExperimentalCustomContentPropertiesPageResponse>;
  experimentalDefaultLogoForSpace?: Maybe<ExperimentalDefaultLogoForSpace>;
  experimentalDesPromotionEligibility?: Maybe<ExperimentalDesPromotionEligibility>;
  experimentalEditorBreadcrumbs?: Maybe<ExperimentalEditorBreadcrumbs>;
  experimentalFetchHaveISeenIt?: Maybe<ExperimentalFlagResult>;
  experimentalGenerateSpaceKey?: Maybe<ExperimentalGenerateSpaceKey>;
  experimentalGetAutomationRuleById?: Maybe<ExperimentalGetAutomationRuleByIdResponse>;
  experimentalGetCompleteOnboarding?: Maybe<ExperimentalOnboardingCompletion>;
  experimentalIntegrationsInstalled?: Maybe<ExperimentalIntegrationsInstalled>;
  experimentalKeyboardShortcutsStatus?: Maybe<ExperimentalKeyboardShortcutsStatus>;
  experimentalLongTask?: Maybe<ExperimentalLongTask>;
  /** Fetches macro specific data, stringified */
  experimentalMacroMetadata?: Maybe<ExperimentalMacroPayload>;
  experimentalMacroPlaceholderADF?: Maybe<ExperimentalMacroPlaceholderResponse>;
  experimentalMarketplaceApps?: Maybe<Array<ExperimentalMarketplaceApp>>;
  experimentalNotifications: ExperimentalNotificationsResponse;
  experimentalOnboardingSpaceBlueprints?: Maybe<ExperimentalOnboardingSpaceBlueprints>;
  experimentalOnboardingTemplate?: Maybe<ExperimentalOnboardingTemplate>;
  experimentalOpenInvite?: Maybe<ExperimentalOpenInvite>;
  experimentalPromotedSpaces?: Maybe<ExperimentalPromotedSpaces>;
  /** See also: CCGraphQLSchema : quickReload */
  experimentalQuickReload?: Maybe<ExperimentalQuickReload>;
  experimentalRelationsForContent?: Maybe<ExperimentalRelationsForContent>;
  experimentalResolvedInlineComments?: Maybe<ExperimentalComments>;
  experimentalSitePersonalization?: Maybe<ExperimentalSitePersonalization>;
  experimentalSpace?: Maybe<ExperimentalSpace>;
  experimentalSpaceProperties?: Maybe<Array<Maybe<ExperimentalSpaceProperty>>>;
  experimentalSynchronyJwt?: Maybe<ExperimentalSynchronyJwt>;
  experimentalSynchronySnapshot?: Maybe<ExperimentalSynchronySnapshot>;
  experimentalSystemInfoSettings?: Maybe<ExperimentalSystemInfoSettings>;
  experimentalTeamCalendarEvents?: Maybe<ExperimentalTCEvents>;
  experimentalTeamCalendarJiraDateFieldsQuery: Array<ExperimentalTCDateField>;
  experimentalTeamCalendarJiraLinksQuery?: Maybe<ExperimentalTCJiraLinks>;
  experimentalTeamCalendarJiraOptionsQuery?: Maybe<ExperimentalTCJiraOptions>;
  experimentalTeamCalendarSubscriberCount?: Maybe<ExperimentalTCSubscriberCount>;
  experimentalTeamCalendarTimezonesQuery?: Maybe<ExperimentalTCTimezones>;
  experimentalTeamCalendarViewPreference?: Maybe<ExperimentalCalendarViewPreference>;
  experimentalTeamCalendarWatchStatus?: Maybe<Array<Maybe<ExperimentalTCWatchStatusEachCal>>>;
  experimentalTeamCalendars?: Maybe<ExperimentalTCSubCalendars>;
  experimentalTeamCalendarsFormatDate?: Maybe<ExperimentalTCFormatDate>;
  experimentalTeamCalendarsSearch?: Maybe<ExperimentalTCSubCalendars>;
  experimentalTeamCalendarsSubscribe?: Maybe<ExperimentalTeamCalendarsSubscribe>;
  experimentalThemeSpaceHomeOverride?: Maybe<ExperimentalThemeSpaceHomeOverride>;
  experimentalUnlicensedPermission?: Maybe<ExperimentalUnlicensedPermissionResponse>;
  experimentalUserPersonalization?: Maybe<ExperimentalUserPersonalization>;
};


export type QueryexperimentalAnalyticsActivityByDateArgs = {
  aggregation?: InputMaybe<Scalars['String']['input']>;
  cloudId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  period: Scalars['String']['input'];
  spaceDataType?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  spaceKey?: InputMaybe<Scalars['String']['input']>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
  stats?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryexperimentalAnalyticsActivityBySpaceArgs = {
  cloudId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  period: Scalars['String']['input'];
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  spaceType: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryexperimentalAnalyticsActivityByUserArgs = {
  cloudId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortorder?: InputMaybe<Scalars['String']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  spaceType?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryexperimentalAnalyticsContentViewsArgs = {
  cloudId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortorder?: InputMaybe<Scalars['String']['input']>;
  spaceId: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
};


export type QueryexperimentalAnalyticsViewsByDateArgs = {
  cloudId: Scalars['String']['input'];
  contentId: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fromDate: Scalars['String']['input'];
  period: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type QueryexperimentalAutomationRuleConnectionsArgs = {
  automationStack: Scalars['String']['input'];
  cloudId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalAutomationRuleSummaryArgs = {
  automationStack: Scalars['String']['input'];
  cloudId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
  spaceId: Scalars['String']['input'];
};


export type QueryexperimentalConnectContextArgs = {
  addonKey: Scalars['String']['input'];
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentPlugin?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  contentVersion?: InputMaybe<Scalars['Int']['input']>;
  moduleKey: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
  spaceKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalConnectServletArgs = {
  addonKey: Scalars['String']['input'];
  moduleKey: Scalars['String']['input'];
};


export type QueryexperimentalContentBodyConvertArgs = {
  body: Scalars['String']['input'];
  contentIdContext?: InputMaybe<Scalars['String']['input']>;
  embeddedContentRender?: InputMaybe<Scalars['String']['input']>;
  expand?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from: Scalars['String']['input'];
  spaceKeyContext?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};


export type QueryexperimentalContentDraftDiffArgs = {
  contentId: Scalars['String']['input'];
};


export type QueryexperimentalCrossProductAdvancedSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  experimentId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ExperimentalCrossProductSearchFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['String']['input']>;
  searchSession?: InputMaybe<ExperimentalSearchSessionType>;
};


export type QueryexperimentalCustomContentPageArgs = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryexperimentalCustomContentPropertiesArgs = {
  contentId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalCustomContentPropertiesPageArgs = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryexperimentalDefaultLogoForSpaceArgs = {
  spaceKey: Scalars['String']['input'];
};


export type QueryexperimentalDesPromotionEligibilityArgs = {
  cloudId: Scalars['String']['input'];
  domain: Scalars['String']['input'];
};


export type QueryexperimentalEditorBreadcrumbsArgs = {
  contentId: Scalars['ID']['input'];
};


export type QueryexperimentalFetchHaveISeenItArgs = {
  flagKey: Scalars['String']['input'];
};


export type QueryexperimentalGenerateSpaceKeyArgs = {
  spaceName: Scalars['String']['input'];
};


export type QueryexperimentalGetAutomationRuleByIdArgs = {
  automationStack: Scalars['String']['input'];
  cloudId: Scalars['String']['input'];
  ruleId: Scalars['String']['input'];
  spaceId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalGetCompleteOnboardingArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalIntegrationsInstalledArgs = {
  appKeys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryexperimentalLongTaskArgs = {
  taskId: Scalars['ID']['input'];
};


export type QueryexperimentalMacroMetadataArgs = {
  contentId: Scalars['ID']['input'];
  macroNode: ExperimentalMacroNode;
};


export type QueryexperimentalMacroPlaceholderADFArgs = {
  contentId: Scalars['ID']['input'];
  macroDefinition: Scalars['String']['input'];
};


export type QueryexperimentalMarketplaceAppsArgs = {
  application: Scalars['String']['input'];
  isSiteAdmin: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalNotificationsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryexperimentalOpenInviteArgs = {
  cloudId: Scalars['String']['input'];
};


export type QueryexperimentalPromotedSpacesArgs = {
  otherSpacesLimit?: InputMaybe<Scalars['Int']['input']>;
  promotedSpaceKey?: InputMaybe<Scalars['String']['input']>;
  promotedSpacesLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryexperimentalQuickReloadArgs = {
  contentId: Scalars['ID']['input'];
  since: Scalars['ExperimentalLong']['input'];
};


export type QueryexperimentalRelationsForContentArgs = {
  relationName: Scalars['String']['input'];
  sourceType: Scalars['String']['input'];
  targetKey: Scalars['String']['input'];
  targetStatus: Scalars['String']['input'];
};


export type QueryexperimentalResolvedInlineCommentsArgs = {
  contentId: Scalars['ID']['input'];
};


export type QueryexperimentalSitePersonalizationArgs = {
  cloudId: Scalars['String']['input'];
};


export type QueryexperimentalSpaceArgs = {
  spaceKey: Scalars['String']['input'];
};


export type QueryexperimentalSpacePropertiesArgs = {
  propertyKeys: Array<Scalars['String']['input']>;
  spaceKey: Scalars['String']['input'];
};


export type QueryexperimentalSynchronyJwtArgs = {
  contentId?: InputMaybe<Scalars['String']['input']>;
  draftShareId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalSynchronySnapshotArgs = {
  entityId?: InputMaybe<Scalars['String']['input']>;
  jwt?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalTeamCalendarEventsArgs = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
  subCalendarId: Scalars['String']['input'];
  userTimeZoneId: Scalars['String']['input'];
};


export type QueryexperimentalTeamCalendarJiraDateFieldsQueryArgs = {
  displayField?: InputMaybe<Scalars['String']['input']>;
  fieldParam: Scalars['String']['input'];
  queryParam?: InputMaybe<Scalars['String']['input']>;
  serverId: Scalars['String']['input'];
};


export type QueryexperimentalTeamCalendarJiraOptionsQueryArgs = {
  serverId: Scalars['String']['input'];
};


export type QueryexperimentalTeamCalendarSubscriberCountArgs = {
  calendarContext: Scalars['String']['input'];
  calendarId: Scalars['String']['input'];
  viewingSpaceKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalTeamCalendarWatchStatusArgs = {
  subCalendarIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryexperimentalTeamCalendarsArgs = {
  calendarContext: Scalars['String']['input'];
  include?: InputMaybe<Array<Scalars['String']['input']>>;
  viewingSpaceKey?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryexperimentalTeamCalendarsFormatDateArgs = {
  dateTimes: Array<Scalars['String']['input']>;
  pattern: Scalars['String']['input'];
};


export type QueryexperimentalTeamCalendarsSearchArgs = {
  isPopular?: InputMaybe<Scalars['Boolean']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  showSubCalendarsInView?: InputMaybe<Scalars['Boolean']['input']>;
  showSubscriberCount?: InputMaybe<Scalars['Boolean']['input']>;
  startIndex?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalTeamCalendarsSubscribeArgs = {
  calendarId: Scalars['ID']['input'];
};


export type QueryexperimentalThemeSpaceHomeOverrideArgs = {
  spaceHomePageId: Scalars['String']['input'];
  spaceKey: Scalars['String']['input'];
  themeAddonKey?: InputMaybe<Scalars['String']['input']>;
  themeModuleKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryexperimentalUnlicensedPermissionArgs = {
  spaceKey: Scalars['String']['input'];
};


export type QueryexperimentalUserPersonalizationArgs = {
  userId: Scalars['String']['input'];
};

export type RESTGroup = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type RESTUser = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  hasSpaceEditPermission?: InputMaybe<Scalars['Boolean']['input']>;
  hasSpaceViewPermission?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalCollaborator?: InputMaybe<Scalars['Boolean']['input']>;
  profilePicture?: InputMaybe<ProfilePicture>;
  publicName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum TemplateParameterTypeEnum {
  BOOLEAN = 'BOOLEAN',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export type UserAndGroupRestrictions = {
  group?: InputMaybe<GroupRestrictions>;
  user?: InputMaybe<UserRestrictions>;
};

export type UserRestrictions = {
  results?: InputMaybe<Array<InputMaybe<RESTUser>>>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;

export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info?: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info?: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info?: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Ancestor: Ancestor;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  ContentRestrictionObj: ContentRestrictionObj;
  ContentRestrictionsObj: ContentRestrictionsObj;
  ExperimentalAbTest: ResolverTypeWrapper<ExperimentalAbTest>;
  ExperimentalAboutConfluence: ResolverTypeWrapper<ExperimentalAboutConfluence>;
  ExperimentalAddCustomizedPersonalSpaceResult: ResolverTypeWrapper<ExperimentalAddCustomizedPersonalSpaceResult>;
  ExperimentalAnalyticsActivityByDateActivity: ResolverTypeWrapper<ExperimentalAnalyticsActivityByDateActivity>;
  ExperimentalAnalyticsActivityByDateDateLevelActivity: ResolverTypeWrapper<ExperimentalAnalyticsActivityByDateDateLevelActivity>;
  ExperimentalAnalyticsActivityByDateResponse: ResolverTypeWrapper<ExperimentalAnalyticsActivityByDateResponse>;
  ExperimentalAnalyticsActivityBySpaceResponse: ResolverTypeWrapper<ExperimentalAnalyticsActivityBySpaceResponse>;
  ExperimentalAnalyticsActivityByUser: ResolverTypeWrapper<ExperimentalAnalyticsActivityByUser>;
  ExperimentalAnalyticsActivityByUserResponse: ResolverTypeWrapper<ExperimentalAnalyticsActivityByUserResponse>;
  ExperimentalAnalyticsContentViews: ResolverTypeWrapper<ExperimentalAnalyticsContentViews>;
  ExperimentalAnalyticsContentViewsResponse: ResolverTypeWrapper<ExperimentalAnalyticsContentViewsResponse>;
  ExperimentalAnalyticsPagination: ResolverTypeWrapper<ExperimentalAnalyticsPagination>;
  ExperimentalAnalyticsPaginationInfo: ResolverTypeWrapper<ExperimentalAnalyticsPaginationInfo>;
  ExperimentalAnalyticsSpaceLevelActivity: ResolverTypeWrapper<ExperimentalAnalyticsSpaceLevelActivity>;
  ExperimentalAnalyticsViewsByDate: ResolverTypeWrapper<ExperimentalAnalyticsViewsByDate>;
  ExperimentalAnalyticsViewsByDateResponse: ResolverTypeWrapper<ExperimentalAnalyticsViewsByDateResponse>;
  ExperimentalApplication: ResolverTypeWrapper<ExperimentalApplication>;
  ExperimentalApplicationList: ResolverTypeWrapper<ExperimentalApplicationList>;
  ExperimentalArchiveSpace: ResolverTypeWrapper<ExperimentalArchiveSpace>;
  ExperimentalAutomationActor: ResolverTypeWrapper<ExperimentalAutomationActor>;
  ExperimentalAutomationActorConfigType: ExperimentalAutomationActorConfigType;
  ExperimentalAutomationBillingType: ExperimentalAutomationBillingType;
  ExperimentalAutomationComponent: ResolverTypeWrapper<ExperimentalAutomationComponent>;
  ExperimentalAutomationComponentConfigSummary: ResolverTypeWrapper<ExperimentalAutomationComponentConfigSummary>;
  ExperimentalAutomationRuleConnectionsResponse: ResolverTypeWrapper<ExperimentalAutomationRuleConnectionsResponse>;
  ExperimentalAutomationRuleHome: ResolverTypeWrapper<ExperimentalAutomationRuleHome>;
  ExperimentalAutomationRuleScope: ResolverTypeWrapper<ExperimentalAutomationRuleScope>;
  ExperimentalAutomationRuleState: ExperimentalAutomationRuleState;
  ExperimentalAutomationRuleSummaryResponse: ResolverTypeWrapper<ExperimentalAutomationRuleSummaryResponse>;
  ExperimentalAutomationRuleTag: ResolverTypeWrapper<ExperimentalAutomationRuleTag>;
  ExperimentalAutomationUpdateRuleActor: ExperimentalAutomationUpdateRuleActor;
  ExperimentalAutomationUpdateRuleComponent: ExperimentalAutomationUpdateRuleComponent;
  ExperimentalAutomationUpdateRuleHome: ExperimentalAutomationUpdateRuleHome;
  ExperimentalAutomationUpdateRuleHomeBilling: ExperimentalAutomationUpdateRuleHomeBilling;
  ExperimentalAutomationUpdateRuleHomeLifecycle: ExperimentalAutomationUpdateRuleHomeLifecycle;
  ExperimentalAutomationUpdateRuleScope: ExperimentalAutomationUpdateRuleScope;
  ExperimentalAutomationUpdateRuleTag: ExperimentalAutomationUpdateRuleTag;
  ExperimentalAutomationWriteAccessType: ExperimentalAutomationWriteAccessType;
  ExperimentalBlueprint: ResolverTypeWrapper<ExperimentalBlueprint>;
  ExperimentalBlueprintWizard: ResolverTypeWrapper<ExperimentalBlueprintWizard>;
  ExperimentalBlueprintWizardPage: ResolverTypeWrapper<ExperimentalBlueprintWizardPage>;
  ExperimentalCalendarViewPreference: ResolverTypeWrapper<ExperimentalCalendarViewPreference>;
  ExperimentalCancelScheduledPublishResponse: ResolverTypeWrapper<ExperimentalCancelScheduledPublishResponse>;
  ExperimentalCaptcha: ExperimentalCaptcha;
  ExperimentalComment: ResolverTypeWrapper<ExperimentalComment>;
  ExperimentalCommentInput: ExperimentalCommentInput;
  ExperimentalCommentMutationResponse: ResolverTypeWrapper<ExperimentalCommentMutationResponse>;
  ExperimentalCommentVersion: ExperimentalCommentVersion;
  ExperimentalComments: ResolverTypeWrapper<ExperimentalComments>;
  ExperimentalConnectContext: ResolverTypeWrapper<ExperimentalConnectContext>;
  ExperimentalConnectIFrame: ResolverTypeWrapper<ExperimentalConnectIFrame>;
  ExperimentalConnectModule: ResolverTypeWrapper<ExperimentalConnectModule>;
  ExperimentalConnectServletResponse: ResolverTypeWrapper<ExperimentalConnectServletResponse>;
  ExperimentalConnectionConfig: ExperimentalConnectionConfig;
  ExperimentalConnectionContainer: ResolverTypeWrapper<ExperimentalConnectionContainer>;
  ExperimentalConnectionContainerInput: ExperimentalConnectionContainerInput;
  ExperimentalConnectionTargetConfig: ResolverTypeWrapper<ExperimentalConnectionTargetConfig>;
  ExperimentalContainer: ResolverTypeWrapper<ExperimentalContainer>;
  ExperimentalContent: ResolverTypeWrapper<ExperimentalContent>;
  ExperimentalContentBody: ResolverTypeWrapper<ExperimentalContentBody>;
  ExperimentalContentBodyConvertResult: ResolverTypeWrapper<ExperimentalContentBodyConvertResult>;
  ExperimentalContentBodyPerRepresentation: ResolverTypeWrapper<ExperimentalContentBodyPerRepresentation>;
  ExperimentalContentDraftDiff: ResolverTypeWrapper<ExperimentalContentDraftDiff>;
  ExperimentalContentHistory: ResolverTypeWrapper<ExperimentalContentHistory>;
  ExperimentalContentHistoryUser: ResolverTypeWrapper<ExperimentalContentHistoryUser>;
  ExperimentalContentMetadata: ResolverTypeWrapper<ExperimentalContentMetadata>;
  ExperimentalContentMetadataLabelResult: ResolverTypeWrapper<ExperimentalContentMetadataLabelResult>;
  ExperimentalContentMetadataLabels: ResolverTypeWrapper<ExperimentalContentMetadataLabels>;
  ExperimentalContentOperations: ResolverTypeWrapper<ExperimentalContentOperations>;
  ExperimentalContentType: ResolverTypeWrapper<ExperimentalContentType>;
  ExperimentalContentVersionRestored: ResolverTypeWrapper<ExperimentalContentVersionRestored>;
  ExperimentalCopyPageTreeLinksResponse: ResolverTypeWrapper<ExperimentalCopyPageTreeLinksResponse>;
  ExperimentalCopyPageTreeResponse: ResolverTypeWrapper<ExperimentalCopyPageTreeResponse>;
  ExperimentalCreateAutomationRuleFromTemplateParameter: ExperimentalCreateAutomationRuleFromTemplateParameter;
  ExperimentalCreateAutomationRuleFromTemplateResponse: ResolverTypeWrapper<ExperimentalCreateAutomationRuleFromTemplateResponse>;
  ExperimentalCreateContentResponse: ResolverTypeWrapper<ExperimentalCreateContentResponse>;
  ExperimentalCrossProductSearchFilter: ExperimentalCrossProductSearchFilter;
  ExperimentalCrossProductSearchFilterDate: ExperimentalCrossProductSearchFilterDate;
  ExperimentalCrossProductSearchResult: ResolverTypeWrapper<ExperimentalCrossProductSearchResult>;
  ExperimentalCrossProductSearchResultItem: ResolverTypeWrapper<ExperimentalCrossProductSearchResultItem>;
  ExperimentalCrossProductSearchResultItemContent: ResolverTypeWrapper<ExperimentalCrossProductSearchResultItemContent>;
  ExperimentalCrossProductSearchResultItemSpace: ResolverTypeWrapper<ExperimentalCrossProductSearchResultItemSpace>;
  ExperimentalCrossProductSearchResultItemSpaceLinks: ResolverTypeWrapper<ExperimentalCrossProductSearchResultItemSpaceLinks>;
  ExperimentalCurrentUser: ResolverTypeWrapper<ExperimentalCurrentUser>;
  ExperimentalCustomContentExpandable: ResolverTypeWrapper<ExperimentalCustomContentExpandable>;
  ExperimentalCustomContentPageResponse: ResolverTypeWrapper<ExperimentalCustomContentPageResponse>;
  ExperimentalCustomContentPageResponseResult: ResolverTypeWrapper<ExperimentalCustomContentPageResponseResult>;
  ExperimentalCustomContentPropertiesPageResponse: ResolverTypeWrapper<ExperimentalCustomContentPropertiesPageResponse>;
  ExperimentalCustomContentPropertiesResponse: ResolverTypeWrapper<ExperimentalCustomContentPropertiesResponse>;
  ExperimentalDRSEligibility: ResolverTypeWrapper<ExperimentalDRSEligibility>;
  ExperimentalDRSSettings: ResolverTypeWrapper<ExperimentalDRSSettings>;
  ExperimentalDRSSettingsInput: ExperimentalDRSSettingsInput;
  ExperimentalDefaultLogoForSpace: ResolverTypeWrapper<ExperimentalDefaultLogoForSpace>;
  ExperimentalDeleteComment: ResolverTypeWrapper<ExperimentalDeleteComment>;
  ExperimentalDemoSpace: ResolverTypeWrapper<ExperimentalDemoSpace>;
  ExperimentalDesPromotionEligibility: ResolverTypeWrapper<ExperimentalDesPromotionEligibility>;
  ExperimentalDesSettings: ResolverTypeWrapper<ExperimentalDesSettings>;
  ExperimentalDesSettingsInput: ExperimentalDesSettingsInput;
  ExperimentalDiscoveredFeature: ResolverTypeWrapper<ExperimentalDiscoveredFeature>;
  ExperimentalEditorBreadcrumb: ResolverTypeWrapper<ExperimentalEditorBreadcrumb>;
  ExperimentalEditorBreadcrumbs: ResolverTypeWrapper<ExperimentalEditorBreadcrumbs>;
  ExperimentalEditorHeartbeatResponse: ResolverTypeWrapper<ExperimentalEditorHeartbeatResponse>;
  ExperimentalExpandable: ResolverTypeWrapper<ExperimentalExpandable>;
  ExperimentalExtension: ResolverTypeWrapper<ExperimentalExtension>;
  ExperimentalFabricComment: ResolverTypeWrapper<ExperimentalFabricComment>;
  ExperimentalFabricCommentInput: ExperimentalFabricCommentInput;
  ExperimentalFabricInlineComment: ResolverTypeWrapper<ExperimentalFabricInlineComment>;
  ExperimentalFabricInlineCommentError: ResolverTypeWrapper<ExperimentalFabricInlineCommentError>;
  ExperimentalFabricInlineCommentInput: ExperimentalFabricInlineCommentInput;
  ExperimentalFabricInlineCommentResolveProperties: ResolverTypeWrapper<ExperimentalFabricInlineCommentResolveProperties>;
  ExperimentalFabricInlineCommentResponse: ResolverTypeWrapper<ExperimentalFabricInlineCommentResponse>;
  ExperimentalFabricInlineReply: ResolverTypeWrapper<ExperimentalFabricInlineReply>;
  ExperimentalFabricInlineReplyError: ResolverTypeWrapper<ExperimentalFabricInlineReplyError>;
  ExperimentalFabricInlineReplyInput: ExperimentalFabricInlineReplyInput;
  ExperimentalFabricInlineReplyResponse: ResolverTypeWrapper<ExperimentalFabricInlineReplyResponse>;
  ExperimentalFavouriteSpaceQuery: ResolverTypeWrapper<ExperimentalFavouriteSpaceQuery>;
  ExperimentalFavouriteSpaceType: ResolverTypeWrapper<ExperimentalFavouriteSpaceType>;
  ExperimentalFlagResult: ResolverTypeWrapper<ExperimentalFlagResult>;
  ExperimentalFormattedBody: ResolverTypeWrapper<ExperimentalFormattedBody>;
  ExperimentalGenerateSpaceKey: ResolverTypeWrapper<ExperimentalGenerateSpaceKey>;
  ExperimentalGetAutomationRuleByIdResponse: ResolverTypeWrapper<ExperimentalGetAutomationRuleByIdResponse>;
  ExperimentalGrantAccess: ResolverTypeWrapper<ExperimentalGrantAccess>;
  ExperimentalGroup: ResolverTypeWrapper<ExperimentalGroup>;
  ExperimentalHeartbeatUser: ResolverTypeWrapper<ExperimentalHeartbeatUser>;
  ExperimentalHeartbeatUserType: ExperimentalHeartbeatUserType;
  ExperimentalHistory: ResolverTypeWrapper<ExperimentalHistory>;
  ExperimentalIcon: ResolverTypeWrapper<ExperimentalIcon>;
  ExperimentalInlineComment: ResolverTypeWrapper<ExperimentalInlineComment>;
  ExperimentalInlineCommentReopened: ResolverTypeWrapper<ExperimentalInlineCommentReopened>;
  ExperimentalIntegrationsInstalled: ResolverTypeWrapper<ExperimentalIntegrationsInstalled>;
  ExperimentalJiraIssue: ResolverTypeWrapper<ExperimentalJiraIssue>;
  ExperimentalKeyboardShortcutsStatus: ResolverTypeWrapper<ExperimentalKeyboardShortcutsStatus>;
  ExperimentalKnownUser: ResolverTypeWrapper<ExperimentalKnownUser>;
  ExperimentalLinks: ResolverTypeWrapper<ExperimentalLinks>;
  ExperimentalLinksContextBase: ResolverTypeWrapper<ExperimentalLinksContextBase>;
  ExperimentalLinksContextSelfBase: ResolverTypeWrapper<ExperimentalLinksContextSelfBase>;
  ExperimentalLinksContextSelfCollectionWebuiBase: ResolverTypeWrapper<ExperimentalLinksContextSelfCollectionWebuiBase>;
  ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase: ResolverTypeWrapper<ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase>;
  ExperimentalLong: ResolverTypeWrapper<Scalars['ExperimentalLong']['output']>;
  ExperimentalLongTask: ResolverTypeWrapper<ExperimentalLongTask>;
  ExperimentalMacroNode: ExperimentalMacroNode;
  ExperimentalMacroParameters: ExperimentalMacroParameters;
  ExperimentalMacroPayload: ResolverTypeWrapper<ExperimentalMacroPayload>;
  ExperimentalMacroPlaceholderResponse: ResolverTypeWrapper<ExperimentalMacroPlaceholderResponse>;
  ExperimentalMarketplaceApp: ResolverTypeWrapper<ExperimentalMarketplaceApp>;
  ExperimentalMarketplaceAppRating: ResolverTypeWrapper<ExperimentalMarketplaceAppRating>;
  ExperimentalMigratePages: ResolverTypeWrapper<ExperimentalMigratePages>;
  ExperimentalMigrateTemplate: ResolverTypeWrapper<ExperimentalMigrateTemplate>;
  ExperimentalNotification: ResolverTypeWrapper<ExperimentalNotification>;
  ExperimentalNotificationActor: ResolverTypeWrapper<ExperimentalNotificationActor>;
  ExperimentalNotificationBody: ResolverTypeWrapper<ExperimentalNotificationBody>;
  ExperimentalNotificationContent: ResolverTypeWrapper<ExperimentalNotificationContent>;
  ExperimentalNotificationPathNode: ResolverTypeWrapper<ExperimentalNotificationPathNode>;
  ExperimentalNotificationReadState: ExperimentalNotificationReadState;
  ExperimentalNotificationsResponse: ResolverTypeWrapper<ExperimentalNotificationsResponse>;
  ExperimentalNotifyOnError: ExperimentalNotifyOnError;
  ExperimentalOnboardingCompletion: ResolverTypeWrapper<ExperimentalOnboardingCompletion>;
  ExperimentalOnboardingIntegration: ResolverTypeWrapper<ExperimentalOnboardingIntegration>;
  ExperimentalOnboardingSpace: ResolverTypeWrapper<ExperimentalOnboardingSpace>;
  ExperimentalOnboardingSpaceBlueprints: ResolverTypeWrapper<ExperimentalOnboardingSpaceBlueprints>;
  ExperimentalOnboardingTemplate: ResolverTypeWrapper<ExperimentalOnboardingTemplate>;
  ExperimentalOpenInvite: ResolverTypeWrapper<ExperimentalOpenInvite>;
  ExperimentalOpenInviteSettings: ResolverTypeWrapper<ExperimentalOpenInviteSettings>;
  ExperimentalOpenInviteSettingsInput: ExperimentalOpenInviteSettingsInput;
  ExperimentalOperationCheckResult: ResolverTypeWrapper<ExperimentalOperationCheckResult>;
  ExperimentalPageInfo: ResolverTypeWrapper<ExperimentalPageInfo>;
  ExperimentalPathType: ExperimentalPathType;
  ExperimentalPromotedSpace: ResolverTypeWrapper<ExperimentalPromotedSpace>;
  ExperimentalPromotedSpaces: ResolverTypeWrapper<ExperimentalPromotedSpaces>;
  ExperimentalPublishContent: ResolverTypeWrapper<ExperimentalPublishContent>;
  ExperimentalPublishContentLink: ResolverTypeWrapper<ExperimentalPublishContentLink>;
  ExperimentalPublishEditorContentResponse: ResolverTypeWrapper<ExperimentalPublishEditorContentResponse>;
  ExperimentalPublishEditorContentResponseSpace: ResolverTypeWrapper<ExperimentalPublishEditorContentResponseSpace>;
  ExperimentalPublishPageAsBlog: ResolverTypeWrapper<ExperimentalPublishPageAsBlog>;
  ExperimentalPublishPageAsBlogLinks: ResolverTypeWrapper<ExperimentalPublishPageAsBlogLinks>;
  ExperimentalQuickLinks: ResolverTypeWrapper<ExperimentalQuickLinks>;
  ExperimentalQuickReload: ResolverTypeWrapper<ExperimentalQuickReload>;
  ExperimentalQuickReloadComment: ResolverTypeWrapper<ExperimentalQuickReloadComment>;
  ExperimentalQuickReloadCommentComment: ResolverTypeWrapper<ExperimentalQuickReloadCommentComment>;
  ExperimentalQuickReloadUser: ResolverTypeWrapper<ExperimentalQuickReloadUser>;
  ExperimentalRecentContainer: ResolverTypeWrapper<ExperimentalRecentContainer>;
  ExperimentalRecentContainerList: ResolverTypeWrapper<ExperimentalRecentContainerList>;
  ExperimentalRelation: ResolverTypeWrapper<ExperimentalRelation>;
  ExperimentalRelationDataForContent: ResolverTypeWrapper<ExperimentalRelationDataForContent>;
  ExperimentalRelationForContent: ResolverTypeWrapper<ExperimentalRelationForContent>;
  ExperimentalRelations: ResolverTypeWrapper<ExperimentalRelations>;
  ExperimentalRelationsForContent: ResolverTypeWrapper<ExperimentalRelationsForContent>;
  ExperimentalRemoveUnlicensedPermissionResponse: ResolverTypeWrapper<ExperimentalRemoveUnlicensedPermissionResponse>;
  ExperimentalRequestAccess: ResolverTypeWrapper<ExperimentalRequestAccess>;
  ExperimentalResetCollabServiceResponse: ResolverTypeWrapper<ExperimentalResetCollabServiceResponse>;
  ExperimentalResolveProperties: ResolverTypeWrapper<ExperimentalResolveProperties>;
  ExperimentalRuleHomeBilling: ResolverTypeWrapper<ExperimentalRuleHomeBilling>;
  ExperimentalRuleHomeLifecycle: ResolverTypeWrapper<ExperimentalRuleHomeLifecycle>;
  ExperimentalSearchSessionType: ExperimentalSearchSessionType;
  ExperimentalShareRequestBodyCommentType: ExperimentalShareRequestBodyCommentType;
  ExperimentalShareRequestBodyContentType: ExperimentalShareRequestBodyContentType;
  ExperimentalShareRequestBodyMetadataType: ExperimentalShareRequestBodyMetadataType;
  ExperimentalShareRequestBodyType: ExperimentalShareRequestBodyType;
  ExperimentalShareRequestBodyUserOrGroupEntityList: ExperimentalShareRequestBodyUserOrGroupEntityList;
  ExperimentalShareResponse: ResolverTypeWrapper<ExperimentalShareResponse>;
  ExperimentalSitePersonalization: ResolverTypeWrapper<ExperimentalSitePersonalization>;
  ExperimentalSitePersonalizationAttributes: ResolverTypeWrapper<ExperimentalSitePersonalizationAttributes>;
  ExperimentalSiteSignUpSettings: ResolverTypeWrapper<ExperimentalSiteSignUpSettings>;
  ExperimentalSiteSignUpSettingsInput: ExperimentalSiteSignUpSettingsInput;
  ExperimentalSpace: ResolverTypeWrapper<ExperimentalSpace>;
  ExperimentalSpaceLogo: ResolverTypeWrapper<ExperimentalSpaceLogo>;
  ExperimentalSpaceOrContent: ResolverTypeWrapper<ExperimentalSpaceOrContent>;
  ExperimentalSpaceProperty: ResolverTypeWrapper<ExperimentalSpaceProperty>;
  ExperimentalSpacePropertyVersion: ResolverTypeWrapper<ExperimentalSpacePropertyVersion>;
  ExperimentalSpaceSidebarLink: ExperimentalSpaceSidebarLink;
  ExperimentalSpaceSidebarQuickLink: ResolverTypeWrapper<ExperimentalSpaceSidebarQuickLink>;
  ExperimentalSpaceWatch: ResolverTypeWrapper<ExperimentalSpaceWatch>;
  ExperimentalSuggestLabel: ResolverTypeWrapper<ExperimentalSuggestLabel>;
  ExperimentalSuperBatchWebResources: ResolverTypeWrapper<ExperimentalSuperBatchWebResources>;
  ExperimentalSynchronyJwt: ResolverTypeWrapper<ExperimentalSynchronyJwt>;
  ExperimentalSynchronySnapshot: ResolverTypeWrapper<ExperimentalSynchronySnapshot>;
  ExperimentalSystemInfoSettings: ResolverTypeWrapper<ExperimentalSystemInfoSettings>;
  ExperimentalTCCustomEventType: ResolverTypeWrapper<ExperimentalTCCustomEventType>;
  ExperimentalTCDateField: ResolverTypeWrapper<ExperimentalTCDateField>;
  ExperimentalTCDecoratedSubCalendar: ResolverTypeWrapper<ExperimentalTCDecoratedSubCalendar>;
  ExperimentalTCEvent: ResolverTypeWrapper<ExperimentalTCEvent>;
  ExperimentalTCEventExtraProperties: ResolverTypeWrapper<ExperimentalTCEventExtraProperties>;
  ExperimentalTCEventInvitees: ResolverTypeWrapper<ExperimentalTCEventInvitees>;
  ExperimentalTCEventRecur: ResolverTypeWrapper<ExperimentalTCEventRecur>;
  ExperimentalTCEventTypeCustomDeleteResponse: ResolverTypeWrapper<ExperimentalTCEventTypeCustomDeleteResponse>;
  ExperimentalTCEventTypeCustomUpdateResponse: ResolverTypeWrapper<ExperimentalTCEventTypeCustomUpdateResponse>;
  ExperimentalTCEventTypeDefaultUpdateResponse: ResolverTypeWrapper<ExperimentalTCEventTypeDefaultUpdateResponse>;
  ExperimentalTCEventTypeDisableResponse: ResolverTypeWrapper<ExperimentalTCEventTypeDisableResponse>;
  ExperimentalTCEventTypeReminder: ResolverTypeWrapper<ExperimentalTCEventTypeReminder>;
  ExperimentalTCEvents: ResolverTypeWrapper<ExperimentalTCEvents>;
  ExperimentalTCFieldError: ResolverTypeWrapper<ExperimentalTCFieldError>;
  ExperimentalTCFormatDate: ResolverTypeWrapper<ExperimentalTCFormatDate>;
  ExperimentalTCJiraCalendarDurations: ResolverTypeWrapper<ExperimentalTCJiraCalendarDurations>;
  ExperimentalTCJiraEventProps: ResolverTypeWrapper<ExperimentalTCJiraEventProps>;
  ExperimentalTCJiraLink: ResolverTypeWrapper<ExperimentalTCJiraLink>;
  ExperimentalTCJiraLinks: ResolverTypeWrapper<ExperimentalTCJiraLinks>;
  ExperimentalTCJiraOption: ResolverTypeWrapper<ExperimentalTCJiraOption>;
  ExperimentalTCJiraOptions: ResolverTypeWrapper<ExperimentalTCJiraOptions>;
  ExperimentalTCJiraSearchRequest: ResolverTypeWrapper<ExperimentalTCJiraSearchRequest>;
  ExperimentalTCSubCalendar: ResolverTypeWrapper<ExperimentalTCSubCalendar>;
  ExperimentalTCSubCalendars: ResolverTypeWrapper<ExperimentalTCSubCalendars>;
  ExperimentalTCSubscriberCount: ResolverTypeWrapper<ExperimentalTCSubscriberCount>;
  ExperimentalTCTimezone: ResolverTypeWrapper<ExperimentalTCTimezone>;
  ExperimentalTCTimezones: ResolverTypeWrapper<ExperimentalTCTimezones>;
  ExperimentalTCUser: ResolverTypeWrapper<ExperimentalTCUser>;
  ExperimentalTCWatchStatus: ResolverTypeWrapper<ExperimentalTCWatchStatus>;
  ExperimentalTCWatchStatusEachCal: ResolverTypeWrapper<ExperimentalTCWatchStatusEachCal>;
  ExperimentalTagType: ExperimentalTagType;
  ExperimentalTaskLinks: ResolverTypeWrapper<ExperimentalTaskLinks>;
  ExperimentalTaskMessage: ResolverTypeWrapper<ExperimentalTaskMessage>;
  ExperimentalTaskName: ResolverTypeWrapper<ExperimentalTaskName>;
  ExperimentalTeamCalendarColorsResponse: ResolverTypeWrapper<ExperimentalTeamCalendarColorsResponse>;
  ExperimentalTeamCalendarDeleteEventResponse: ResolverTypeWrapper<ExperimentalTeamCalendarDeleteEventResponse>;
  ExperimentalTeamCalendarEditResponse: ResolverTypeWrapper<ExperimentalTeamCalendarEditResponse>;
  ExperimentalTeamCalendarImportResponse: ResolverTypeWrapper<ExperimentalTeamCalendarImportResponse>;
  ExperimentalTeamCalendarJiraJQLValidateResponse: ResolverTypeWrapper<ExperimentalTeamCalendarJiraJQLValidateResponse>;
  ExperimentalTeamCalendarRemindersResponse: ResolverTypeWrapper<ExperimentalTeamCalendarRemindersResponse>;
  ExperimentalTeamCalendarRestrictionResponse: ResolverTypeWrapper<ExperimentalTeamCalendarRestrictionResponse>;
  ExperimentalTeamCalendarsAddEventPerson: ExperimentalTeamCalendarsAddEventPerson;
  ExperimentalTeamCalendarsAddEventResponse: ResolverTypeWrapper<ExperimentalTeamCalendarsAddEventResponse>;
  ExperimentalTeamCalendarsResetSubscribeLinkResponse: ResolverTypeWrapper<ExperimentalTeamCalendarsResetSubscribeLinkResponse>;
  ExperimentalTeamCalendarsSubscribe: ResolverTypeWrapper<ExperimentalTeamCalendarsSubscribe>;
  ExperimentalThemeAPIMigrations: ResolverTypeWrapper<ExperimentalThemeAPIMigrations>;
  ExperimentalThemeSpaceHomeOverride: ResolverTypeWrapper<ExperimentalThemeSpaceHomeOverride>;
  ExperimentalUnlicensedPermissionResponse: ResolverTypeWrapper<ExperimentalUnlicensedPermissionResponse>;
  ExperimentalUpdateAutomationRuleConfigBean: ExperimentalUpdateAutomationRuleConfigBean;
  ExperimentalUpdateAutomationRuleConnectionResponse: ResolverTypeWrapper<ExperimentalUpdateAutomationRuleConnectionResponse>;
  ExperimentalUpdateAutomationRuleResponse: ResolverTypeWrapper<ExperimentalUpdateAutomationRuleResponse>;
  ExperimentalUpdateContentProperty: ResolverTypeWrapper<ExperimentalUpdateContentProperty>;
  ExperimentalUpdateInstanceContent: ResolverTypeWrapper<ExperimentalUpdateInstanceContent>;
  ExperimentalUpdateInstanceLinks: ResolverTypeWrapper<ExperimentalUpdateInstanceLinks>;
  ExperimentalUpdateInstanceMetadata: ResolverTypeWrapper<ExperimentalUpdateInstanceMetadata>;
  ExperimentalUpdateInstanceMetadataProperties: ResolverTypeWrapper<ExperimentalUpdateInstanceMetadataProperties>;
  ExperimentalUpdateInstanceMetadataPropertiesEditor: ResolverTypeWrapper<ExperimentalUpdateInstanceMetadataPropertiesEditor>;
  ExperimentalUpdateInstanceResponse: ResolverTypeWrapper<ExperimentalUpdateInstanceResponse>;
  ExperimentalUpdateInstanceSpace: ResolverTypeWrapper<ExperimentalUpdateInstanceSpace>;
  ExperimentalUser: ResolverTypeWrapper<ExperimentalUser>;
  ExperimentalUserInvitation: ResolverTypeWrapper<ExperimentalUserInvitation>;
  ExperimentalUserInvitationResult: ExperimentalUserInvitationResult;
  ExperimentalUserInvitationResults: ResolverTypeWrapper<ExperimentalUserInvitationResults>;
  ExperimentalUserPermissions: ResolverTypeWrapper<ExperimentalUserPermissions>;
  ExperimentalUserPersonalization: ResolverTypeWrapper<ExperimentalUserPersonalization>;
  ExperimentalUserPersonalizationAttributes: ResolverTypeWrapper<ExperimentalUserPersonalizationAttributes>;
  ExperimentalVersion: ResolverTypeWrapper<ExperimentalVersion>;
  ExperimentalWebResourceDependencies: ResolverTypeWrapper<ExperimentalWebResourceDependencies>;
  ExperimentalWebResourceTags: ResolverTypeWrapper<ExperimentalWebResourceTags>;
  ExperimentalWebResourceUris: ResolverTypeWrapper<ExperimentalWebResourceUris>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GroupRestrictions: GroupRestrictions;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  MentionOptions: MentionOptions;
  MoveRequestObj: MoveRequestObj;
  Mutation: ResolverTypeWrapper<{}>;
  NotificationActionEnum: NotificationActionEnum;
  ProfilePicture: ProfilePicture;
  Query: ResolverTypeWrapper<{}>;
  RESTGroup: RESTGroup;
  RESTUser: RESTUser;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  TemplateParameterTypeEnum: TemplateParameterTypeEnum;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  UserAndGroupRestrictions: UserAndGroupRestrictions;
  UserRestrictions: UserRestrictions;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Ancestor: Ancestor;
  Boolean: Scalars['Boolean']['output'];
  ContentRestrictionObj: ContentRestrictionObj;
  ContentRestrictionsObj: ContentRestrictionsObj;
  ExperimentalAbTest: ExperimentalAbTest;
  ExperimentalAboutConfluence: ExperimentalAboutConfluence;
  ExperimentalAddCustomizedPersonalSpaceResult: ExperimentalAddCustomizedPersonalSpaceResult;
  ExperimentalAnalyticsActivityByDateActivity: ExperimentalAnalyticsActivityByDateActivity;
  ExperimentalAnalyticsActivityByDateDateLevelActivity: ExperimentalAnalyticsActivityByDateDateLevelActivity;
  ExperimentalAnalyticsActivityByDateResponse: ExperimentalAnalyticsActivityByDateResponse;
  ExperimentalAnalyticsActivityBySpaceResponse: ExperimentalAnalyticsActivityBySpaceResponse;
  ExperimentalAnalyticsActivityByUser: ExperimentalAnalyticsActivityByUser;
  ExperimentalAnalyticsActivityByUserResponse: ExperimentalAnalyticsActivityByUserResponse;
  ExperimentalAnalyticsContentViews: ExperimentalAnalyticsContentViews;
  ExperimentalAnalyticsContentViewsResponse: ExperimentalAnalyticsContentViewsResponse;
  ExperimentalAnalyticsPagination: ExperimentalAnalyticsPagination;
  ExperimentalAnalyticsPaginationInfo: ExperimentalAnalyticsPaginationInfo;
  ExperimentalAnalyticsSpaceLevelActivity: ExperimentalAnalyticsSpaceLevelActivity;
  ExperimentalAnalyticsViewsByDate: ExperimentalAnalyticsViewsByDate;
  ExperimentalAnalyticsViewsByDateResponse: ExperimentalAnalyticsViewsByDateResponse;
  ExperimentalApplication: ExperimentalApplication;
  ExperimentalApplicationList: ExperimentalApplicationList;
  ExperimentalArchiveSpace: ExperimentalArchiveSpace;
  ExperimentalAutomationActor: ExperimentalAutomationActor;
  ExperimentalAutomationComponent: ExperimentalAutomationComponent;
  ExperimentalAutomationComponentConfigSummary: ExperimentalAutomationComponentConfigSummary;
  ExperimentalAutomationRuleConnectionsResponse: ExperimentalAutomationRuleConnectionsResponse;
  ExperimentalAutomationRuleHome: ExperimentalAutomationRuleHome;
  ExperimentalAutomationRuleScope: ExperimentalAutomationRuleScope;
  ExperimentalAutomationRuleSummaryResponse: ExperimentalAutomationRuleSummaryResponse;
  ExperimentalAutomationRuleTag: ExperimentalAutomationRuleTag;
  ExperimentalAutomationUpdateRuleActor: ExperimentalAutomationUpdateRuleActor;
  ExperimentalAutomationUpdateRuleComponent: ExperimentalAutomationUpdateRuleComponent;
  ExperimentalAutomationUpdateRuleHome: ExperimentalAutomationUpdateRuleHome;
  ExperimentalAutomationUpdateRuleHomeBilling: ExperimentalAutomationUpdateRuleHomeBilling;
  ExperimentalAutomationUpdateRuleHomeLifecycle: ExperimentalAutomationUpdateRuleHomeLifecycle;
  ExperimentalAutomationUpdateRuleScope: ExperimentalAutomationUpdateRuleScope;
  ExperimentalAutomationUpdateRuleTag: ExperimentalAutomationUpdateRuleTag;
  ExperimentalBlueprint: ExperimentalBlueprint;
  ExperimentalBlueprintWizard: ExperimentalBlueprintWizard;
  ExperimentalBlueprintWizardPage: ExperimentalBlueprintWizardPage;
  ExperimentalCalendarViewPreference: ExperimentalCalendarViewPreference;
  ExperimentalCancelScheduledPublishResponse: ExperimentalCancelScheduledPublishResponse;
  ExperimentalCaptcha: ExperimentalCaptcha;
  ExperimentalComment: ExperimentalComment;
  ExperimentalCommentInput: ExperimentalCommentInput;
  ExperimentalCommentMutationResponse: ExperimentalCommentMutationResponse;
  ExperimentalCommentVersion: ExperimentalCommentVersion;
  ExperimentalComments: ExperimentalComments;
  ExperimentalConnectContext: ExperimentalConnectContext;
  ExperimentalConnectIFrame: ExperimentalConnectIFrame;
  ExperimentalConnectModule: ExperimentalConnectModule;
  ExperimentalConnectServletResponse: ExperimentalConnectServletResponse;
  ExperimentalConnectionConfig: ExperimentalConnectionConfig;
  ExperimentalConnectionContainer: ExperimentalConnectionContainer;
  ExperimentalConnectionContainerInput: ExperimentalConnectionContainerInput;
  ExperimentalConnectionTargetConfig: ExperimentalConnectionTargetConfig;
  ExperimentalContainer: ExperimentalContainer;
  ExperimentalContent: ExperimentalContent;
  ExperimentalContentBody: ExperimentalContentBody;
  ExperimentalContentBodyConvertResult: ExperimentalContentBodyConvertResult;
  ExperimentalContentBodyPerRepresentation: ExperimentalContentBodyPerRepresentation;
  ExperimentalContentDraftDiff: ExperimentalContentDraftDiff;
  ExperimentalContentHistory: ExperimentalContentHistory;
  ExperimentalContentHistoryUser: ExperimentalContentHistoryUser;
  ExperimentalContentMetadata: ExperimentalContentMetadata;
  ExperimentalContentMetadataLabelResult: ExperimentalContentMetadataLabelResult;
  ExperimentalContentMetadataLabels: ExperimentalContentMetadataLabels;
  ExperimentalContentOperations: ExperimentalContentOperations;
  ExperimentalContentType: ExperimentalContentType;
  ExperimentalContentVersionRestored: ExperimentalContentVersionRestored;
  ExperimentalCopyPageTreeLinksResponse: ExperimentalCopyPageTreeLinksResponse;
  ExperimentalCopyPageTreeResponse: ExperimentalCopyPageTreeResponse;
  ExperimentalCreateAutomationRuleFromTemplateParameter: ExperimentalCreateAutomationRuleFromTemplateParameter;
  ExperimentalCreateAutomationRuleFromTemplateResponse: ExperimentalCreateAutomationRuleFromTemplateResponse;
  ExperimentalCreateContentResponse: ExperimentalCreateContentResponse;
  ExperimentalCrossProductSearchFilter: ExperimentalCrossProductSearchFilter;
  ExperimentalCrossProductSearchFilterDate: ExperimentalCrossProductSearchFilterDate;
  ExperimentalCrossProductSearchResult: ExperimentalCrossProductSearchResult;
  ExperimentalCrossProductSearchResultItem: ExperimentalCrossProductSearchResultItem;
  ExperimentalCrossProductSearchResultItemContent: ExperimentalCrossProductSearchResultItemContent;
  ExperimentalCrossProductSearchResultItemSpace: ExperimentalCrossProductSearchResultItemSpace;
  ExperimentalCrossProductSearchResultItemSpaceLinks: ExperimentalCrossProductSearchResultItemSpaceLinks;
  ExperimentalCurrentUser: ExperimentalCurrentUser;
  ExperimentalCustomContentExpandable: ExperimentalCustomContentExpandable;
  ExperimentalCustomContentPageResponse: ExperimentalCustomContentPageResponse;
  ExperimentalCustomContentPageResponseResult: ExperimentalCustomContentPageResponseResult;
  ExperimentalCustomContentPropertiesPageResponse: ExperimentalCustomContentPropertiesPageResponse;
  ExperimentalCustomContentPropertiesResponse: ExperimentalCustomContentPropertiesResponse;
  ExperimentalDRSEligibility: ExperimentalDRSEligibility;
  ExperimentalDRSSettings: ExperimentalDRSSettings;
  ExperimentalDRSSettingsInput: ExperimentalDRSSettingsInput;
  ExperimentalDefaultLogoForSpace: ExperimentalDefaultLogoForSpace;
  ExperimentalDeleteComment: ExperimentalDeleteComment;
  ExperimentalDemoSpace: ExperimentalDemoSpace;
  ExperimentalDesPromotionEligibility: ExperimentalDesPromotionEligibility;
  ExperimentalDesSettings: ExperimentalDesSettings;
  ExperimentalDesSettingsInput: ExperimentalDesSettingsInput;
  ExperimentalDiscoveredFeature: ExperimentalDiscoveredFeature;
  ExperimentalEditorBreadcrumb: ExperimentalEditorBreadcrumb;
  ExperimentalEditorBreadcrumbs: ExperimentalEditorBreadcrumbs;
  ExperimentalEditorHeartbeatResponse: ExperimentalEditorHeartbeatResponse;
  ExperimentalExpandable: ExperimentalExpandable;
  ExperimentalExtension: ExperimentalExtension;
  ExperimentalFabricComment: ExperimentalFabricComment;
  ExperimentalFabricCommentInput: ExperimentalFabricCommentInput;
  ExperimentalFabricInlineComment: ExperimentalFabricInlineComment;
  ExperimentalFabricInlineCommentError: ExperimentalFabricInlineCommentError;
  ExperimentalFabricInlineCommentInput: ExperimentalFabricInlineCommentInput;
  ExperimentalFabricInlineCommentResolveProperties: ExperimentalFabricInlineCommentResolveProperties;
  ExperimentalFabricInlineCommentResponse: ExperimentalFabricInlineCommentResponse;
  ExperimentalFabricInlineReply: ExperimentalFabricInlineReply;
  ExperimentalFabricInlineReplyError: ExperimentalFabricInlineReplyError;
  ExperimentalFabricInlineReplyInput: ExperimentalFabricInlineReplyInput;
  ExperimentalFabricInlineReplyResponse: ExperimentalFabricInlineReplyResponse;
  ExperimentalFavouriteSpaceQuery: ExperimentalFavouriteSpaceQuery;
  ExperimentalFavouriteSpaceType: ExperimentalFavouriteSpaceType;
  ExperimentalFlagResult: ExperimentalFlagResult;
  ExperimentalFormattedBody: ExperimentalFormattedBody;
  ExperimentalGenerateSpaceKey: ExperimentalGenerateSpaceKey;
  ExperimentalGetAutomationRuleByIdResponse: ExperimentalGetAutomationRuleByIdResponse;
  ExperimentalGrantAccess: ExperimentalGrantAccess;
  ExperimentalGroup: ExperimentalGroup;
  ExperimentalHeartbeatUser: ExperimentalHeartbeatUser;
  ExperimentalHistory: ExperimentalHistory;
  ExperimentalIcon: ExperimentalIcon;
  ExperimentalInlineComment: ExperimentalInlineComment;
  ExperimentalInlineCommentReopened: ExperimentalInlineCommentReopened;
  ExperimentalIntegrationsInstalled: ExperimentalIntegrationsInstalled;
  ExperimentalJiraIssue: ExperimentalJiraIssue;
  ExperimentalKeyboardShortcutsStatus: ExperimentalKeyboardShortcutsStatus;
  ExperimentalKnownUser: ExperimentalKnownUser;
  ExperimentalLinks: ExperimentalLinks;
  ExperimentalLinksContextBase: ExperimentalLinksContextBase;
  ExperimentalLinksContextSelfBase: ExperimentalLinksContextSelfBase;
  ExperimentalLinksContextSelfCollectionWebuiBase: ExperimentalLinksContextSelfCollectionWebuiBase;
  ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase: ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase;
  ExperimentalLong: Scalars['ExperimentalLong']['output'];
  ExperimentalLongTask: ExperimentalLongTask;
  ExperimentalMacroNode: ExperimentalMacroNode;
  ExperimentalMacroParameters: ExperimentalMacroParameters;
  ExperimentalMacroPayload: ExperimentalMacroPayload;
  ExperimentalMacroPlaceholderResponse: ExperimentalMacroPlaceholderResponse;
  ExperimentalMarketplaceApp: ExperimentalMarketplaceApp;
  ExperimentalMarketplaceAppRating: ExperimentalMarketplaceAppRating;
  ExperimentalMigratePages: ExperimentalMigratePages;
  ExperimentalMigrateTemplate: ExperimentalMigrateTemplate;
  ExperimentalNotification: ExperimentalNotification;
  ExperimentalNotificationActor: ExperimentalNotificationActor;
  ExperimentalNotificationBody: ExperimentalNotificationBody;
  ExperimentalNotificationContent: ExperimentalNotificationContent;
  ExperimentalNotificationPathNode: ExperimentalNotificationPathNode;
  ExperimentalNotificationsResponse: ExperimentalNotificationsResponse;
  ExperimentalOnboardingCompletion: ExperimentalOnboardingCompletion;
  ExperimentalOnboardingIntegration: ExperimentalOnboardingIntegration;
  ExperimentalOnboardingSpace: ExperimentalOnboardingSpace;
  ExperimentalOnboardingSpaceBlueprints: ExperimentalOnboardingSpaceBlueprints;
  ExperimentalOnboardingTemplate: ExperimentalOnboardingTemplate;
  ExperimentalOpenInvite: ExperimentalOpenInvite;
  ExperimentalOpenInviteSettings: ExperimentalOpenInviteSettings;
  ExperimentalOpenInviteSettingsInput: ExperimentalOpenInviteSettingsInput;
  ExperimentalOperationCheckResult: ExperimentalOperationCheckResult;
  ExperimentalPageInfo: ExperimentalPageInfo;
  ExperimentalPromotedSpace: ExperimentalPromotedSpace;
  ExperimentalPromotedSpaces: ExperimentalPromotedSpaces;
  ExperimentalPublishContent: ExperimentalPublishContent;
  ExperimentalPublishContentLink: ExperimentalPublishContentLink;
  ExperimentalPublishEditorContentResponse: ExperimentalPublishEditorContentResponse;
  ExperimentalPublishEditorContentResponseSpace: ExperimentalPublishEditorContentResponseSpace;
  ExperimentalPublishPageAsBlog: ExperimentalPublishPageAsBlog;
  ExperimentalPublishPageAsBlogLinks: ExperimentalPublishPageAsBlogLinks;
  ExperimentalQuickLinks: ExperimentalQuickLinks;
  ExperimentalQuickReload: ExperimentalQuickReload;
  ExperimentalQuickReloadComment: ExperimentalQuickReloadComment;
  ExperimentalQuickReloadCommentComment: ExperimentalQuickReloadCommentComment;
  ExperimentalQuickReloadUser: ExperimentalQuickReloadUser;
  ExperimentalRecentContainer: ExperimentalRecentContainer;
  ExperimentalRecentContainerList: ExperimentalRecentContainerList;
  ExperimentalRelation: ExperimentalRelation;
  ExperimentalRelationDataForContent: ExperimentalRelationDataForContent;
  ExperimentalRelationForContent: ExperimentalRelationForContent;
  ExperimentalRelations: ExperimentalRelations;
  ExperimentalRelationsForContent: ExperimentalRelationsForContent;
  ExperimentalRemoveUnlicensedPermissionResponse: ExperimentalRemoveUnlicensedPermissionResponse;
  ExperimentalRequestAccess: ExperimentalRequestAccess;
  ExperimentalResetCollabServiceResponse: ExperimentalResetCollabServiceResponse;
  ExperimentalResolveProperties: ExperimentalResolveProperties;
  ExperimentalRuleHomeBilling: ExperimentalRuleHomeBilling;
  ExperimentalRuleHomeLifecycle: ExperimentalRuleHomeLifecycle;
  ExperimentalSearchSessionType: ExperimentalSearchSessionType;
  ExperimentalShareRequestBodyCommentType: ExperimentalShareRequestBodyCommentType;
  ExperimentalShareRequestBodyContentType: ExperimentalShareRequestBodyContentType;
  ExperimentalShareRequestBodyMetadataType: ExperimentalShareRequestBodyMetadataType;
  ExperimentalShareRequestBodyType: ExperimentalShareRequestBodyType;
  ExperimentalShareRequestBodyUserOrGroupEntityList: ExperimentalShareRequestBodyUserOrGroupEntityList;
  ExperimentalShareResponse: ExperimentalShareResponse;
  ExperimentalSitePersonalization: ExperimentalSitePersonalization;
  ExperimentalSitePersonalizationAttributes: ExperimentalSitePersonalizationAttributes;
  ExperimentalSiteSignUpSettings: ExperimentalSiteSignUpSettings;
  ExperimentalSiteSignUpSettingsInput: ExperimentalSiteSignUpSettingsInput;
  ExperimentalSpace: ExperimentalSpace;
  ExperimentalSpaceLogo: ExperimentalSpaceLogo;
  ExperimentalSpaceOrContent: ExperimentalSpaceOrContent;
  ExperimentalSpaceProperty: ExperimentalSpaceProperty;
  ExperimentalSpacePropertyVersion: ExperimentalSpacePropertyVersion;
  ExperimentalSpaceSidebarLink: ExperimentalSpaceSidebarLink;
  ExperimentalSpaceSidebarQuickLink: ExperimentalSpaceSidebarQuickLink;
  ExperimentalSpaceWatch: ExperimentalSpaceWatch;
  ExperimentalSuggestLabel: ExperimentalSuggestLabel;
  ExperimentalSuperBatchWebResources: ExperimentalSuperBatchWebResources;
  ExperimentalSynchronyJwt: ExperimentalSynchronyJwt;
  ExperimentalSynchronySnapshot: ExperimentalSynchronySnapshot;
  ExperimentalSystemInfoSettings: ExperimentalSystemInfoSettings;
  ExperimentalTCCustomEventType: ExperimentalTCCustomEventType;
  ExperimentalTCDateField: ExperimentalTCDateField;
  ExperimentalTCDecoratedSubCalendar: ExperimentalTCDecoratedSubCalendar;
  ExperimentalTCEvent: ExperimentalTCEvent;
  ExperimentalTCEventExtraProperties: ExperimentalTCEventExtraProperties;
  ExperimentalTCEventInvitees: ExperimentalTCEventInvitees;
  ExperimentalTCEventRecur: ExperimentalTCEventRecur;
  ExperimentalTCEventTypeCustomDeleteResponse: ExperimentalTCEventTypeCustomDeleteResponse;
  ExperimentalTCEventTypeCustomUpdateResponse: ExperimentalTCEventTypeCustomUpdateResponse;
  ExperimentalTCEventTypeDefaultUpdateResponse: ExperimentalTCEventTypeDefaultUpdateResponse;
  ExperimentalTCEventTypeDisableResponse: ExperimentalTCEventTypeDisableResponse;
  ExperimentalTCEventTypeReminder: ExperimentalTCEventTypeReminder;
  ExperimentalTCEvents: ExperimentalTCEvents;
  ExperimentalTCFieldError: ExperimentalTCFieldError;
  ExperimentalTCFormatDate: ExperimentalTCFormatDate;
  ExperimentalTCJiraCalendarDurations: ExperimentalTCJiraCalendarDurations;
  ExperimentalTCJiraEventProps: ExperimentalTCJiraEventProps;
  ExperimentalTCJiraLink: ExperimentalTCJiraLink;
  ExperimentalTCJiraLinks: ExperimentalTCJiraLinks;
  ExperimentalTCJiraOption: ExperimentalTCJiraOption;
  ExperimentalTCJiraOptions: ExperimentalTCJiraOptions;
  ExperimentalTCJiraSearchRequest: ExperimentalTCJiraSearchRequest;
  ExperimentalTCSubCalendar: ExperimentalTCSubCalendar;
  ExperimentalTCSubCalendars: ExperimentalTCSubCalendars;
  ExperimentalTCSubscriberCount: ExperimentalTCSubscriberCount;
  ExperimentalTCTimezone: ExperimentalTCTimezone;
  ExperimentalTCTimezones: ExperimentalTCTimezones;
  ExperimentalTCUser: ExperimentalTCUser;
  ExperimentalTCWatchStatus: ExperimentalTCWatchStatus;
  ExperimentalTCWatchStatusEachCal: ExperimentalTCWatchStatusEachCal;
  ExperimentalTaskLinks: ExperimentalTaskLinks;
  ExperimentalTaskMessage: ExperimentalTaskMessage;
  ExperimentalTaskName: ExperimentalTaskName;
  ExperimentalTeamCalendarColorsResponse: ExperimentalTeamCalendarColorsResponse;
  ExperimentalTeamCalendarDeleteEventResponse: ExperimentalTeamCalendarDeleteEventResponse;
  ExperimentalTeamCalendarEditResponse: ExperimentalTeamCalendarEditResponse;
  ExperimentalTeamCalendarImportResponse: ExperimentalTeamCalendarImportResponse;
  ExperimentalTeamCalendarJiraJQLValidateResponse: ExperimentalTeamCalendarJiraJQLValidateResponse;
  ExperimentalTeamCalendarRemindersResponse: ExperimentalTeamCalendarRemindersResponse;
  ExperimentalTeamCalendarRestrictionResponse: ExperimentalTeamCalendarRestrictionResponse;
  ExperimentalTeamCalendarsAddEventPerson: ExperimentalTeamCalendarsAddEventPerson;
  ExperimentalTeamCalendarsAddEventResponse: ExperimentalTeamCalendarsAddEventResponse;
  ExperimentalTeamCalendarsResetSubscribeLinkResponse: ExperimentalTeamCalendarsResetSubscribeLinkResponse;
  ExperimentalTeamCalendarsSubscribe: ExperimentalTeamCalendarsSubscribe;
  ExperimentalThemeAPIMigrations: ExperimentalThemeAPIMigrations;
  ExperimentalThemeSpaceHomeOverride: ExperimentalThemeSpaceHomeOverride;
  ExperimentalUnlicensedPermissionResponse: ExperimentalUnlicensedPermissionResponse;
  ExperimentalUpdateAutomationRuleConfigBean: ExperimentalUpdateAutomationRuleConfigBean;
  ExperimentalUpdateAutomationRuleConnectionResponse: ExperimentalUpdateAutomationRuleConnectionResponse;
  ExperimentalUpdateAutomationRuleResponse: ExperimentalUpdateAutomationRuleResponse;
  ExperimentalUpdateContentProperty: ExperimentalUpdateContentProperty;
  ExperimentalUpdateInstanceContent: ExperimentalUpdateInstanceContent;
  ExperimentalUpdateInstanceLinks: ExperimentalUpdateInstanceLinks;
  ExperimentalUpdateInstanceMetadata: ExperimentalUpdateInstanceMetadata;
  ExperimentalUpdateInstanceMetadataProperties: ExperimentalUpdateInstanceMetadataProperties;
  ExperimentalUpdateInstanceMetadataPropertiesEditor: ExperimentalUpdateInstanceMetadataPropertiesEditor;
  ExperimentalUpdateInstanceResponse: ExperimentalUpdateInstanceResponse;
  ExperimentalUpdateInstanceSpace: ExperimentalUpdateInstanceSpace;
  ExperimentalUser: ExperimentalUser;
  ExperimentalUserInvitation: ExperimentalUserInvitation;
  ExperimentalUserInvitationResults: ExperimentalUserInvitationResults;
  ExperimentalUserPermissions: ExperimentalUserPermissions;
  ExperimentalUserPersonalization: ExperimentalUserPersonalization;
  ExperimentalUserPersonalizationAttributes: ExperimentalUserPersonalizationAttributes;
  ExperimentalVersion: ExperimentalVersion;
  ExperimentalWebResourceDependencies: ExperimentalWebResourceDependencies;
  ExperimentalWebResourceTags: ExperimentalWebResourceTags;
  ExperimentalWebResourceUris: ExperimentalWebResourceUris;
  Float: Scalars['Float']['output'];
  GroupRestrictions: GroupRestrictions;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  JSON: Scalars['JSON']['output'];
  MentionOptions: MentionOptions;
  MoveRequestObj: MoveRequestObj;
  Mutation: {};
  ProfilePicture: ProfilePicture;
  Query: {};
  RESTGroup: RESTGroup;
  RESTUser: RESTUser;
  String: Scalars['String']['output'];
  Upload: Scalars['Upload']['output'];
  UserAndGroupRestrictions: UserAndGroupRestrictions;
  UserRestrictions: UserRestrictions;
};

export type SLADirectiveArgs = { };

export type SLADirectiveResolver<Result, Parent, ContextType = ResolverContext, Args = SLADirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type experimentalDirectiveArgs = { };

export type experimentalDirectiveResolver<Result, Parent, ContextType = ResolverContext, Args = experimentalDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ExperimentalAbTestResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAbTest'] = ResolversParentTypes['ExperimentalAbTest']> = {
  abTestId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  controlId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  experimentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAboutConfluenceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAboutConfluence'] = ResolversParentTypes['ExperimentalAboutConfluence']> = {
  html?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAddCustomizedPersonalSpaceResultResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAddCustomizedPersonalSpaceResult'] = ResolversParentTypes['ExperimentalAddCustomizedPersonalSpaceResult']> = {
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsActivityByDateActivityResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsActivityByDateActivity'] = ResolversParentTypes['ExperimentalAnalyticsActivityByDateActivity']> = {
  creates?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByDateDateLevelActivity']>>>, ParentType, ContextType>;
  searches?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByDateDateLevelActivity']>>>, ParentType, ContextType>;
  updates?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByDateDateLevelActivity']>>>, ParentType, ContextType>;
  views?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByDateDateLevelActivity']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsActivityByDateDateLevelActivityResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsActivityByDateDateLevelActivity'] = ResolversParentTypes['ExperimentalAnalyticsActivityByDateDateLevelActivity']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsActivityByDateResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsActivityByDateResponse'] = ResolversParentTypes['ExperimentalAnalyticsActivityByDateResponse']> = {
  activityByDate?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByDateActivity']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsActivityBySpaceResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsActivityBySpaceResponse'] = ResolversParentTypes['ExperimentalAnalyticsActivityBySpaceResponse']> = {
  activityBySpace?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsSpaceLevelActivity']>>>, ParentType, ContextType>;
  paginationInfo?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsPagination']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsActivityByUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsActivityByUser'] = ResolversParentTypes['ExperimentalAnalyticsActivityByUser']> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commentCreated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  searchPerformed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  viewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsActivityByUserResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsActivityByUserResponse'] = ResolversParentTypes['ExperimentalAnalyticsActivityByUserResponse']> = {
  activityByUser?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByUser']>>>, ParentType, ContextType>;
  paginationInfo?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsPaginationInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsContentViewsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsContentViews'] = ResolversParentTypes['ExperimentalAnalyticsContentViews']> = {
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModificationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastViewedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalComments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalViewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uniqueUsersViewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  webui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsContentViewsResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsContentViewsResponse'] = ResolversParentTypes['ExperimentalAnalyticsContentViewsResponse']> = {
  contentViews?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsContentViews']>>>, ParentType, ContextType>;
  paginationInfo?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsPaginationInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsPaginationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsPagination'] = ResolversParentTypes['ExperimentalAnalyticsPagination']> = {
  next?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previous?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsPaginationInfoResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsPaginationInfo'] = ResolversParentTypes['ExperimentalAnalyticsPaginationInfo']> = {
  next?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsSpaceLevelActivityResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsSpaceLevelActivity'] = ResolversParentTypes['ExperimentalAnalyticsSpaceLevelActivity']> = {
  created?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  iconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastViewedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usersViewed?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  views?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  webui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsViewsByDateResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsViewsByDate'] = ResolversParentTypes['ExperimentalAnalyticsViewsByDate']> = {
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAnalyticsViewsByDateResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAnalyticsViewsByDateResponse'] = ResolversParentTypes['ExperimentalAnalyticsViewsByDateResponse']> = {
  viewsByDate?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAnalyticsViewsByDate']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalApplicationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalApplication'] = ResolversParentTypes['ExperimentalApplication']> = {
  applicationType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  local?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalApplicationListResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalApplicationList'] = ResolversParentTypes['ExperimentalApplicationList']> = {
  linkedApplications?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalApplication']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalArchiveSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalArchiveSpace'] = ResolversParentTypes['ExperimentalArchiveSpace']> = {
  archived?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationActorResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationActor'] = ResolversParentTypes['ExperimentalAutomationActor']> = {
  type?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationActorConfigType']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationComponentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationComponent'] = ResolversParentTypes['ExperimentalAutomationComponent']> = {
  children?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  component?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  conditionParentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  conditions?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  connectionId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  schemaVersion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationComponentConfigSummaryResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationComponentConfigSummary'] = ResolversParentTypes['ExperimentalAutomationComponentConfigSummary']> = {
  childComponentSummaries?: Resolver<Array<ResolversTypes['ExperimentalAutomationComponentConfigSummary']>, ParentType, ContextType>;
  component?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  componentName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationRuleConnectionsResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationRuleConnectionsResponse'] = ResolversParentTypes['ExperimentalAutomationRuleConnectionsResponse']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  connectionTargetKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  container?: Resolver<Maybe<ResolversTypes['ExperimentalConnectionContainer']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetConfigJson?: Resolver<Maybe<ResolversTypes['ExperimentalConnectionTargetConfig']>, ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationRuleHomeResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationRuleHome'] = ResolversParentTypes['ExperimentalAutomationRuleHome']> = {
  ruleBillingHome?: Resolver<Maybe<ResolversTypes['ExperimentalRuleHomeBilling']>, ParentType, ContextType>;
  ruleLifecycleHome?: Resolver<Maybe<ResolversTypes['ExperimentalRuleHomeLifecycle']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationRuleScopeResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationRuleScope'] = ResolversParentTypes['ExperimentalAutomationRuleScope']> = {
  resources?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationRuleSummaryResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationRuleSummaryResponse'] = ResolversParentTypes['ExperimentalAutomationRuleSummaryResponse']> = {
  authorAccountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  componentSummaries?: Resolver<Array<ResolversTypes['ExperimentalAutomationComponentConfigSummary']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ruleState?: Resolver<ResolversTypes['ExperimentalAutomationRuleState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalAutomationRuleTagResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalAutomationRuleTag'] = ResolversParentTypes['ExperimentalAutomationRuleTag']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  tagType?: Resolver<Maybe<ResolversTypes['ExperimentalTagType']>, ParentType, ContextType>;
  tagValue?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalBlueprintResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalBlueprint'] = ResolversParentTypes['ExperimentalBlueprint']> = {
  blueprintModuleCompleteKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentBlueprintId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createResult?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  howToUseTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconURL?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isNew?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isPromoted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  itemModuleCompleteKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  new?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  promoted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  skipHowToUse?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  styleClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  wizard?: Resolver<Maybe<ResolversTypes['ExperimentalBlueprintWizard']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalBlueprintWizardResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalBlueprintWizard'] = ResolversParentTypes['ExperimentalBlueprintWizard']> = {
  pages?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalBlueprintWizardPage']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalBlueprintWizardPageResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalBlueprintWizardPage'] = ResolversParentTypes['ExperimentalBlueprintWizardPage']> = {
  descriptionContent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionHeader?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descriptionHeaderLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  last?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  templateKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCalendarViewPreferenceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCalendarViewPreference'] = ResolversParentTypes['ExperimentalCalendarViewPreference']> = {
  subCalendarsInView?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  view?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCancelScheduledPublishResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCancelScheduledPublishResponse'] = ResolversParentTypes['ExperimentalCancelScheduledPublishResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCommentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalComment'] = ResolversParentTypes['ExperimentalComment']> = {
  author?: Resolver<ResolversTypes['ExperimentalUser'], ParentType, ContextType>;
  body?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  friendlyLastModified?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['ExperimentalInlineComment']>, ParentType, ContextType>;
  replies?: Resolver<ResolversTypes['ExperimentalComments'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCommentMutationResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCommentMutationResponse'] = ResolversParentTypes['ExperimentalCommentMutationResponse']> = {
  asyncRenderSafe?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  html?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isInlineComment?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ownerId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCommentsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalComments'] = ResolversParentTypes['ExperimentalComments']> = {
  nodes?: Resolver<Array<ResolversTypes['ExperimentalComment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalConnectContextResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalConnectContext'] = ResolversParentTypes['ExperimentalConnectContext']> = {
  connectDescriptor?: Resolver<Maybe<ResolversTypes['ExperimentalConnectIFrame']>, ParentType, ContextType>;
  hasResponse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalConnectIFrameResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalConnectIFrame'] = ResolversParentTypes['ExperimentalConnectIFrame']> = {
  addon_key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  apiMigrations?: Resolver<Maybe<ResolversTypes['ExperimentalThemeAPIMigrations']>, ParentType, ContextType>;
  contentClassifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contextJwt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  cp?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  general?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  h?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hostOrigin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  moduleType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  origin?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  productCtx?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sandbox?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  structuredContext?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeZone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uniqueKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  w?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalConnectModuleResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalConnectModule'] = ResolversParentTypes['ExperimentalConnectModule']> = {
  modules?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalConnectServletResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalConnectServletResponse'] = ResolversParentTypes['ExperimentalConnectServletResponse']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalConnectionContainerResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalConnectionContainer'] = ResolversParentTypes['ExperimentalConnectionContainer']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalConnectionTargetConfigResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalConnectionTargetConfig'] = ResolversParentTypes['ExperimentalConnectionTargetConfig']> = {
  baseUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  cloudId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContainerResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContainer'] = ResolversParentTypes['ExperimentalContainer']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  macroRenderedOutput?: Resolver<Maybe<ResolversTypes['ExperimentalFormattedBody']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContent'] = ResolversParentTypes['ExperimentalContent']> = {
  ancestors?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalContent']>>>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['ExperimentalContentBodyPerRepresentation']>, ParentType, ContextType>;
  container?: Resolver<Maybe<ResolversTypes['ExperimentalSpaceOrContent']>, ParentType, ContextType>;
  history?: Resolver<Maybe<ResolversTypes['ExperimentalHistory']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase']>, ParentType, ContextType>;
  operations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalOperationCheckResult']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['ExperimentalVersion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentBodyResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentBody'] = ResolversParentTypes['ExperimentalContentBody']> = {
  content?: Resolver<Maybe<ResolversTypes['ExperimentalContent']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextBase']>, ParentType, ContextType>;
  macroRenderedOutput?: Resolver<Maybe<ResolversTypes['ExperimentalFormattedBody']>, ParentType, ContextType>;
  representation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webresource?: Resolver<Maybe<ResolversTypes['ExperimentalWebResourceDependencies']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentBodyConvertResultResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentBodyConvertResult'] = ResolversParentTypes['ExperimentalContentBodyConvertResult']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentBodyPerRepresentationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentBodyPerRepresentation'] = ResolversParentTypes['ExperimentalContentBodyPerRepresentation']> = {
  editor?: Resolver<Maybe<ResolversTypes['ExperimentalContentBody']>, ParentType, ContextType>;
  view?: Resolver<Maybe<ResolversTypes['ExperimentalContentBody']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentDraftDiffResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentDraftDiff'] = ResolversParentTypes['ExperimentalContentDraftDiff']> = {
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentHistoryResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentHistory'] = ResolversParentTypes['ExperimentalContentHistory']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['ExperimentalContentHistoryUser']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  latest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentHistoryUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentHistoryUser'] = ResolversParentTypes['ExperimentalContentHistoryUser']> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  accountType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<ResolversTypes['ExperimentalIcon']>, ParentType, ContextType>;
  publicName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeZone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentMetadataResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentMetadata'] = ResolversParentTypes['ExperimentalContentMetadata']> = {
  labels?: Resolver<Maybe<ResolversTypes['ExperimentalContentMetadataLabels']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentMetadataLabelResultResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentMetadataLabelResult'] = ResolversParentTypes['ExperimentalContentMetadataLabelResult']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  prefix?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentMetadataLabelsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentMetadataLabels'] = ResolversParentTypes['ExperimentalContentMetadataLabels']> = {
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalContentMetadataLabelResult']>>>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentOperationsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentOperations'] = ResolversParentTypes['ExperimentalContentOperations']> = {
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentTypeResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentType'] = ResolversParentTypes['ExperimentalContentType']> = {
  label?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalContentVersionRestoredResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalContentVersionRestored'] = ResolversParentTypes['ExperimentalContentVersionRestored']> = {
  restored?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCopyPageTreeLinksResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCopyPageTreeLinksResponse'] = ResolversParentTypes['ExperimentalCopyPageTreeLinksResponse']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCopyPageTreeResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCopyPageTreeResponse'] = ResolversParentTypes['ExperimentalCopyPageTreeResponse']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalCopyPageTreeLinksResponse']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCreateAutomationRuleFromTemplateResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCreateAutomationRuleFromTemplateResponse'] = ResolversParentTypes['ExperimentalCreateAutomationRuleFromTemplateResponse']> = {
  ruleId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCreateContentResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCreateContentResponse'] = ResolversParentTypes['ExperimentalCreateContentResponse']> = {
  collabService?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalPublishContent']>, ParentType, ContextType>;
  spaceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCrossProductSearchResultResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCrossProductSearchResult'] = ResolversParentTypes['ExperimentalCrossProductSearchResult']> = {
  abTest?: Resolver<Maybe<ResolversTypes['ExperimentalAbTest']>, ParentType, ContextType>;
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalCrossProductSearchResultItem']>>>, ParentType, ContextType>;
  pageInfo?: Resolver<Maybe<ResolversTypes['ExperimentalPageInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCrossProductSearchResultItemResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCrossProductSearchResultItem'] = ResolversParentTypes['ExperimentalCrossProductSearchResultItem']> = {
  content?: Resolver<Maybe<ResolversTypes['ExperimentalCrossProductSearchResultItemContent']>, ParentType, ContextType>;
  entityType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  excerpt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastModified?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  space?: Resolver<Maybe<ResolversTypes['ExperimentalCrossProductSearchResultItemSpace']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCrossProductSearchResultItemContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCrossProductSearchResultItemContent'] = ResolversParentTypes['ExperimentalCrossProductSearchResultItemContent']> = {
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  space?: Resolver<Maybe<ResolversTypes['ExperimentalCrossProductSearchResultItemSpace']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCrossProductSearchResultItemSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCrossProductSearchResultItemSpace'] = ResolversParentTypes['ExperimentalCrossProductSearchResultItemSpace']> = {
  icon?: Resolver<Maybe<ResolversTypes['ExperimentalIcon']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalCrossProductSearchResultItemSpaceLinks']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCrossProductSearchResultItemSpaceLinksResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCrossProductSearchResultItemSpaceLinks'] = ResolversParentTypes['ExperimentalCrossProductSearchResultItemSpaceLinks']> = {
  webui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCurrentUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCurrentUser'] = ResolversParentTypes['ExperimentalCurrentUser']> = {
  timeZone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCustomContentExpandableResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCustomContentExpandable'] = ResolversParentTypes['ExperimentalCustomContentExpandable']> = {
  ancestors?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  childTypes?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  children?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  container?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  descendants?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  history?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  operations?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  restrictions?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schedulePublishDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  space?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCustomContentPageResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCustomContentPageResponse'] = ResolversParentTypes['ExperimentalCustomContentPageResponse']> = {
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextSelfBase']>, ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalCustomContentPageResponseResult']>>>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCustomContentPageResponseResultResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCustomContentPageResponseResult'] = ResolversParentTypes['ExperimentalCustomContentPageResponseResult']> = {
  _expandable?: Resolver<Maybe<ResolversTypes['ExperimentalCustomContentExpandable']>, ParentType, ContextType>;
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextSelfCollectionWebuiBase']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  macroRenderedOutput?: Resolver<Maybe<ResolversTypes['ExperimentalFormattedBody']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCustomContentPropertiesPageResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCustomContentPropertiesPageResponse'] = ResolversParentTypes['ExperimentalCustomContentPropertiesPageResponse']> = {
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalCustomContentPropertiesResponse']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalCustomContentPropertiesResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalCustomContentPropertiesResponse'] = ResolversParentTypes['ExperimentalCustomContentPropertiesResponse']> = {
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextSelfCollectionWebuiBase']>, ParentType, ContextType>;
  history?: Resolver<Maybe<ResolversTypes['ExperimentalContentHistory']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['ExperimentalContentMetadata']>, ParentType, ContextType>;
  operations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalContentOperations']>>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDRSEligibilityResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDRSEligibility'] = ResolversParentTypes['ExperimentalDRSEligibility']> = {
  isAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEligible?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDRSSettingsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDRSSettings'] = ResolversParentTypes['ExperimentalDRSSettings']> = {
  cloudId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDefaultLogoForSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDefaultLogoForSpace'] = ResolversParentTypes['ExperimentalDefaultLogoForSpace']> = {
  logoDownloadPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDeleteCommentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDeleteComment'] = ResolversParentTypes['ExperimentalDeleteComment']> = {
  contentId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  statusCode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDemoSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDemoSpace'] = ResolversParentTypes['ExperimentalDemoSpace']> = {
  draftId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDesPromotionEligibilityResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDesPromotionEligibility'] = ResolversParentTypes['ExperimentalDesPromotionEligibility']> = {
  desPromotionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  domain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  role?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDesSettingsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDesSettings'] = ResolversParentTypes['ExperimentalDesSettings']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalDiscoveredFeatureResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalDiscoveredFeature'] = ResolversParentTypes['ExperimentalDiscoveredFeature']> = {
  featureKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pluginKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalEditorBreadcrumbResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalEditorBreadcrumb'] = ResolversParentTypes['ExperimentalEditorBreadcrumb']> = {
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalEditorBreadcrumbsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalEditorBreadcrumbs'] = ResolversParentTypes['ExperimentalEditorBreadcrumbs']> = {
  breadcrumbs?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalEditorBreadcrumb']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalEditorHeartbeatResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalEditorHeartbeatResponse'] = ResolversParentTypes['ExperimentalEditorHeartbeatResponse']> = {
  editorSessionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  orderedUsers?: Resolver<Maybe<Array<ResolversTypes['ExperimentalHeartbeatUser']>>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalExpandableResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalExpandable'] = ResolversParentTypes['ExperimentalExpandable']> = {
  relationData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalExtensionResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalExtension'] = ResolversParentTypes['ExperimentalExtension']> = {
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricCommentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricComment'] = ResolversParentTypes['ExperimentalFabricComment']> = {
  ancestors?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalFabricComment']>>>, ParentType, ContextType>;
  container?: Resolver<Maybe<ResolversTypes['ExperimentalContainer']>, ParentType, ContextType>;
  extensions?: Resolver<Maybe<ResolversTypes['ExperimentalExtension']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricInlineCommentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricInlineComment'] = ResolversParentTypes['ExperimentalFabricInlineComment']> = {
  authorAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorAvatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  authorDisplayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  authorUserName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commentDateUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasDeletePermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasEditPermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasReplyPermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasResolvePermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastModificationDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  markerRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalSelection?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentCommentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  resolveProperties?: Resolver<Maybe<ResolversTypes['ExperimentalFabricInlineCommentResolveProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricInlineCommentErrorResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricInlineCommentError'] = ResolversParentTypes['ExperimentalFabricInlineCommentError']> = {
  errorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricInlineCommentResolvePropertiesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricInlineCommentResolveProperties'] = ResolversParentTypes['ExperimentalFabricInlineCommentResolveProperties']> = {
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resolvedByDangling?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resolvedTime?: Resolver<Maybe<ResolversTypes['ExperimentalLong']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricInlineCommentResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricInlineCommentResponse'] = ResolversParentTypes['ExperimentalFabricInlineCommentResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['ExperimentalFabricInlineCommentError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ExperimentalFabricInlineComment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricInlineReplyResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricInlineReply'] = ResolversParentTypes['ExperimentalFabricInlineReply']> = {
  authorAccountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorAvatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  authorUserName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  commentDateUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commentId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  hasDeletePermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasEditPermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastModificationDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricInlineReplyErrorResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricInlineReplyError'] = ResolversParentTypes['ExperimentalFabricInlineReplyError']> = {
  errorId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFabricInlineReplyResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFabricInlineReplyResponse'] = ResolversParentTypes['ExperimentalFabricInlineReplyResponse']> = {
  error?: Resolver<Maybe<ResolversTypes['ExperimentalFabricInlineReplyError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ExperimentalFabricInlineReply']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFavouriteSpaceQueryResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFavouriteSpaceQuery'] = ResolversParentTypes['ExperimentalFavouriteSpaceQuery']> = {
  isSpaceFavourited?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFavouriteSpaceTypeResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFavouriteSpaceType'] = ResolversParentTypes['ExperimentalFavouriteSpaceType']> = {
  spaceKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFlagResultResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFlagResult'] = ResolversParentTypes['ExperimentalFlagResult']> = {
  lastSeenDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalFormattedBodyResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalFormattedBody'] = ResolversParentTypes['ExperimentalFormattedBody']> = {
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextBase']>, ParentType, ContextType>;
  representation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webresource?: Resolver<Maybe<ResolversTypes['ExperimentalWebResourceDependencies']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalGenerateSpaceKeyResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalGenerateSpaceKey'] = ResolversParentTypes['ExperimentalGenerateSpaceKey']> = {
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalGetAutomationRuleByIdResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalGetAutomationRuleByIdResponse'] = ResolversParentTypes['ExperimentalGetAutomationRuleByIdResponse']> = {
  actor?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationActor']>, ParentType, ContextType>;
  authorAccountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  billingType?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationBillingType']>, ParentType, ContextType>;
  canOtherRuleTrigger?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  clientKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collaborators?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  components?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAutomationComponent']>>>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['ExperimentalLong']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  labels?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  notifyOnError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  projects?: Resolver<Maybe<Array<Maybe<ResolversTypes['JSON']>>>, ParentType, ContextType>;
  ruleHome?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationRuleHome']>, ParentType, ContextType>;
  ruleScope?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationRuleScope']>, ParentType, ContextType>;
  state?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationRuleState']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAutomationRuleTag']>>>, ParentType, ContextType>;
  trigger?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationComponent']>, ParentType, ContextType>;
  updated?: Resolver<Maybe<ResolversTypes['ExperimentalLong']>, ParentType, ContextType>;
  writeAccessType?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationWriteAccessType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalGrantAccessResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalGrantAccess'] = ResolversParentTypes['ExperimentalGrantAccess']> = {
  responseStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalGroupResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalGroup'] = ResolversParentTypes['ExperimentalGroup']> = {
  content?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalHeartbeatUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalHeartbeatUser'] = ResolversParentTypes['ExperimentalHeartbeatUser']> = {
  accountId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  heartbeatUserType?: Resolver<ResolversTypes['ExperimentalHeartbeatUserType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalHistoryResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalHistory'] = ResolversParentTypes['ExperimentalHistory']> = {
  createdBy?: Resolver<Maybe<ResolversTypes['ExperimentalKnownUser']>, ParentType, ContextType>;
  createdDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastUpdated?: Resolver<Maybe<ResolversTypes['ExperimentalVersion']>, ParentType, ContextType>;
  latest?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextSelfBase']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalIconResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalIcon'] = ResolversParentTypes['ExperimentalIcon']> = {
  height?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  isDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  path?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<ExperimentalIconpathArgs, 'type'>>;
  width?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalInlineCommentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalInlineComment'] = ResolversParentTypes['ExperimentalInlineComment']> = {
  hasResolvePermission?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inlineMarkerRef?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  inlineText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resolveProperties?: Resolver<ResolversTypes['ExperimentalResolveProperties'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalInlineCommentReopenedResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalInlineCommentReopened'] = ResolversParentTypes['ExperimentalInlineCommentReopened']> = {
  result?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalIntegrationsInstalledResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalIntegrationsInstalled'] = ResolversParentTypes['ExperimentalIntegrationsInstalled']> = {
  integrations?: Resolver<Maybe<Array<ResolversTypes['ExperimentalOnboardingIntegration']>>, ParentType, ContextType>;
  isSlackConnected?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSlackEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalJiraIssueResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalJiraIssue'] = ResolversParentTypes['ExperimentalJiraIssue']> = {
  authUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalKeyboardShortcutsStatusResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalKeyboardShortcutsStatus'] = ResolversParentTypes['ExperimentalKeyboardShortcutsStatus']> = {
  enabled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalKnownUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalKnownUser'] = ResolversParentTypes['ExperimentalKnownUser']> = {
  accountId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextSelfBase']>, ParentType, ContextType>;
  operations?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalOperationCheckResult']>>>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<ResolversTypes['ExperimentalIcon']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalLinksResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalLinks'] = ResolversParentTypes['ExperimentalLinks']> = {
  base?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalLinksContextBaseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalLinksContextBase'] = ResolversParentTypes['ExperimentalLinksContextBase']> = {
  base?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalLinksContextSelfBaseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalLinksContextSelfBase'] = ResolversParentTypes['ExperimentalLinksContextSelfBase']> = {
  base?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalLinksContextSelfCollectionWebuiBaseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalLinksContextSelfCollectionWebuiBase'] = ResolversParentTypes['ExperimentalLinksContextSelfCollectionWebuiBase']> = {
  base?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBaseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase'] = ResolversParentTypes['ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase']> = {
  base?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  collection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  download?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  editui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  self?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tinyui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface ExperimentalLongScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['ExperimentalLong'], any> {
  name: 'ExperimentalLong';
}

export type ExperimentalLongTaskResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalLongTask'] = ResolversParentTypes['ExperimentalLongTask']> = {
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalTaskLinks']>, ParentType, ContextType>;
  elapsedTime?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  finished?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['ExperimentalTaskMessage']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['ExperimentalTaskName']>, ParentType, ContextType>;
  percentageComplete?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  successful?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalMacroPayloadResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalMacroPayload'] = ResolversParentTypes['ExperimentalMacroPayload']> = {
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalMacroPlaceholderResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalMacroPlaceholderResponse'] = ResolversParentTypes['ExperimentalMacroPlaceholderResponse']> = {
  json?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalMarketplaceAppResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalMarketplaceApp'] = ResolversParentTypes['ExperimentalMarketplaceApp']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  listingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ratings?: Resolver<ResolversTypes['ExperimentalMarketplaceAppRating'], ParentType, ContextType>;
  tagLine?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalMarketplaceAppRatingResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalMarketplaceAppRating'] = ResolversParentTypes['ExperimentalMarketplaceAppRating']> = {
  averageStars?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalMigratePagesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalMigratePages'] = ResolversParentTypes['ExperimentalMigratePages']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalMigrateTemplateResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalMigrateTemplate'] = ResolversParentTypes['ExperimentalMigrateTemplate']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalNotificationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalNotification'] = ResolversParentTypes['ExperimentalNotification']> = {
  content?: Resolver<ResolversTypes['ExperimentalNotificationContent'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['ExperimentalNotificationPathNode']>, ParentType, ContextType>;
  readState?: Resolver<ResolversTypes['ExperimentalNotificationReadState'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalNotificationActorResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalNotificationActor'] = ResolversParentTypes['ExperimentalNotificationActor']> = {
  avatarUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalNotificationBodyResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalNotificationBody'] = ResolversParentTypes['ExperimentalNotificationBody']> = {
  data?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalNotificationContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalNotificationContent'] = ResolversParentTypes['ExperimentalNotificationContent']> = {
  actor?: Resolver<ResolversTypes['ExperimentalNotificationActor'], ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['ExperimentalNotificationBody']>, ParentType, ContextType>;
  iconUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalNotificationPathNodeResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalNotificationPathNode'] = ResolversParentTypes['ExperimentalNotificationPathNode']> = {
  iconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalNotificationsResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalNotificationsResponse'] = ResolversParentTypes['ExperimentalNotificationsResponse']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ExperimentalNotification']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOnboardingCompletionResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOnboardingCompletion'] = ResolversParentTypes['ExperimentalOnboardingCompletion']> = {
  complete?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOnboardingIntegrationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOnboardingIntegration'] = ResolversParentTypes['ExperimentalOnboardingIntegration']> = {
  appKey?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isInstalled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOnboardingSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOnboardingSpace'] = ResolversParentTypes['ExperimentalOnboardingSpace']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  draftId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOnboardingSpaceBlueprintsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOnboardingSpaceBlueprints'] = ResolversParentTypes['ExperimentalOnboardingSpaceBlueprints']> = {
  spaceBlueprints?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalBlueprint']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOnboardingTemplateResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOnboardingTemplate'] = ResolversParentTypes['ExperimentalOnboardingTemplate']> = {
  templateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOpenInviteResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOpenInvite'] = ResolversParentTypes['ExperimentalOpenInvite']> = {
  mode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOpenInviteSettingsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOpenInviteSettings'] = ResolversParentTypes['ExperimentalOpenInviteSettings']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalOperationCheckResultResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalOperationCheckResult'] = ResolversParentTypes['ExperimentalOperationCheckResult']> = {
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextBase']>, ParentType, ContextType>;
  operation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  targetType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPageInfoResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPageInfo'] = ResolversParentTypes['ExperimentalPageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPromotedSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPromotedSpace'] = ResolversParentTypes['ExperimentalPromotedSpace']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPromotedSpacesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPromotedSpaces'] = ResolversParentTypes['ExperimentalPromotedSpaces']> = {
  nodes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalPromotedSpace']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPublishContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPublishContent'] = ResolversParentTypes['ExperimentalPublishContent']> = {
  draftUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPublishContentLinkResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPublishContentLink'] = ResolversParentTypes['ExperimentalPublishContentLink']> = {
  links?: Resolver<Maybe<ResolversTypes['ExperimentalPublishContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPublishEditorContentResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPublishEditorContentResponse'] = ResolversParentTypes['ExperimentalPublishEditorContentResponse']> = {
  createdDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  space?: Resolver<Maybe<ResolversTypes['ExperimentalPublishEditorContentResponseSpace']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  traceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPublishEditorContentResponseSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPublishEditorContentResponseSpace'] = ResolversParentTypes['ExperimentalPublishEditorContentResponseSpace']> = {
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPublishPageAsBlogResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPublishPageAsBlog'] = ResolversParentTypes['ExperimentalPublishPageAsBlog']> = {
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalPublishPageAsBlogLinks']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalPublishPageAsBlogLinksResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalPublishPageAsBlogLinks'] = ResolversParentTypes['ExperimentalPublishPageAsBlogLinks']> = {
  editui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  webui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalQuickLinksResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalQuickLinks'] = ResolversParentTypes['ExperimentalQuickLinks']> = {
  quickLinks?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalSpaceSidebarQuickLink']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalQuickReloadResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalQuickReload'] = ResolversParentTypes['ExperimentalQuickReload']> = {
  comments?: Resolver<Array<ResolversTypes['ExperimentalQuickReloadComment']>, ParentType, ContextType>;
  editorForPage?: Resolver<Maybe<ResolversTypes['ExperimentalQuickReloadUser']>, ParentType, ContextType>;
  time?: Resolver<ResolversTypes['ExperimentalLong'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalQuickReloadCommentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalQuickReloadComment'] = ResolversParentTypes['ExperimentalQuickReloadComment']> = {
  comment?: Resolver<Maybe<ResolversTypes['ExperimentalQuickReloadCommentComment']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalQuickReloadCommentCommentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalQuickReloadCommentComment'] = ResolversParentTypes['ExperimentalQuickReloadCommentComment']> = {
  author?: Resolver<ResolversTypes['ExperimentalQuickReloadUser'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalQuickReloadUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalQuickReloadUser'] = ResolversParentTypes['ExperimentalQuickReloadUser']> = {
  accountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRecentContainerResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRecentContainer'] = ResolversParentTypes['ExperimentalRecentContainer']> = {
  iconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  objectId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRecentContainerListResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRecentContainerList'] = ResolversParentTypes['ExperimentalRecentContainerList']> = {
  recentContainers?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalRecentContainer']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRelationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRelation'] = ResolversParentTypes['ExperimentalRelation']> = {
  _expandable?: Resolver<Maybe<ResolversTypes['ExperimentalExpandable']>, ParentType, ContextType>;
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalLinks']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  relationData?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRelationDataForContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRelationDataForContent'] = ResolversParentTypes['ExperimentalRelationDataForContent']> = {
  friendlyCreatedDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRelationForContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRelationForContent'] = ResolversParentTypes['ExperimentalRelationForContent']> = {
  relationData?: Resolver<Maybe<ResolversTypes['ExperimentalRelationDataForContent']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['ExperimentalKnownUser']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRelationsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRelations'] = ResolversParentTypes['ExperimentalRelations']> = {
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalLinks']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalRelation']>>>, ParentType, ContextType>;
  size?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  start?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRelationsForContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRelationsForContent'] = ResolversParentTypes['ExperimentalRelationsForContent']> = {
  results?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalRelationForContent']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRemoveUnlicensedPermissionResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRemoveUnlicensedPermissionResponse'] = ResolversParentTypes['ExperimentalRemoveUnlicensedPermissionResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRequestAccessResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRequestAccess'] = ResolversParentTypes['ExperimentalRequestAccess']> = {
  complete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalResetCollabServiceResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalResetCollabServiceResponse'] = ResolversParentTypes['ExperimentalResetCollabServiceResponse']> = {
  traceId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalResolvePropertiesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalResolveProperties'] = ResolversParentTypes['ExperimentalResolveProperties']> = {
  resolvedByDangling?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  resolvedFriendlyDate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resolvedUser?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRuleHomeBillingResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRuleHomeBilling'] = ResolversParentTypes['ExperimentalRuleHomeBilling']> = {
  locationARI?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalRuleHomeLifecycleResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalRuleHomeLifecycle'] = ResolversParentTypes['ExperimentalRuleHomeLifecycle']> = {
  locationARI?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalShareResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalShareResponse'] = ResolversParentTypes['ExperimentalShareResponse']> = {
  status?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSitePersonalizationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSitePersonalization'] = ResolversParentTypes['ExperimentalSitePersonalization']> = {
  attributes?: Resolver<Maybe<Array<ResolversTypes['ExperimentalSitePersonalizationAttributes']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSitePersonalizationAttributesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSitePersonalizationAttributes'] = ResolversParentTypes['ExperimentalSitePersonalizationAttributes']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSiteSignUpSettingsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSiteSignUpSettings'] = ResolversParentTypes['ExperimentalSiteSignUpSettings']> = {
  domains?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  isDefault?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  notifyAdmin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  openInvite?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  selfJoinMode?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSpace'] = ResolversParentTypes['ExperimentalSpace']> = {
  statusCode?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSpaceLogoResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSpaceLogo'] = ResolversParentTypes['ExperimentalSpaceLogo']> = {
  iconPath?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSpaceOrContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSpaceOrContent'] = ResolversParentTypes['ExperimentalSpaceOrContent']> = {
  ancestors?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalContent']>>>, ParentType, ContextType>;
  body?: Resolver<Maybe<ResolversTypes['ExperimentalContentBodyPerRepresentation']>, ParentType, ContextType>;
  container?: Resolver<Maybe<ResolversTypes['ExperimentalSpaceOrContent']>, ParentType, ContextType>;
  history?: Resolver<Maybe<ResolversTypes['ExperimentalHistory']>, ParentType, ContextType>;
  homepage?: Resolver<Maybe<ResolversTypes['ExperimentalContent']>, ParentType, ContextType>;
  homepageId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['ExperimentalIcon']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSpacePropertyResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSpaceProperty'] = ResolversParentTypes['ExperimentalSpaceProperty']> = {
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  version?: Resolver<Maybe<ResolversTypes['ExperimentalSpacePropertyVersion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSpacePropertyVersionResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSpacePropertyVersion'] = ResolversParentTypes['ExperimentalSpacePropertyVersion']> = {
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSpaceSidebarQuickLinkResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSpaceSidebarQuickLink'] = ResolversParentTypes['ExperimentalSpaceSidebarQuickLink']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  position?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  styleClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSpaceWatchResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSpaceWatch'] = ResolversParentTypes['ExperimentalSpaceWatch']> = {
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watching?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSuggestLabelResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSuggestLabel'] = ResolversParentTypes['ExperimentalSuggestLabel']> = {
  className?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  href?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSuperBatchWebResourcesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSuperBatchWebResources'] = ResolversParentTypes['ExperimentalSuperBatchWebResources']> = {
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextBase']>, ParentType, ContextType>;
  metatags?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<ResolversTypes['ExperimentalWebResourceTags']>, ParentType, ContextType>;
  uris?: Resolver<Maybe<ResolversTypes['ExperimentalWebResourceUris']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSynchronyJwtResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSynchronyJwt'] = ResolversParentTypes['ExperimentalSynchronyJwt']> = {
  applicationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  configuredUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  synchronyExpiry?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  synchronyToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSynchronySnapshotResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSynchronySnapshot'] = ResolversParentTypes['ExperimentalSynchronySnapshot']> = {
  adf?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalSystemInfoSettingsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalSystemInfoSettings'] = ResolversParentTypes['ExperimentalSystemInfoSettings']> = {
  baseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  defaultTimeZone?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fallbackBaseUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCCustomEventTypeResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCCustomEventType'] = ResolversParentTypes['ExperimentalTCCustomEventType']> = {
  created?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customEventTypeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentSubCalendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  periodInMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCDateFieldResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCDateField'] = ResolversParentTypes['ExperimentalTCDateField']> = {
  customfield?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCDecoratedSubCalendarResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCDecoratedSubCalendar'] = ResolversParentTypes['ExperimentalTCDecoratedSubCalendar']> = {
  administrable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  childSubCalendars?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCDecoratedSubCalendar']>>, ParentType, ContextType>;
  deletable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  editable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eventsEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  eventsHidden?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  groupsPermittedToEdit?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  groupsPermittedToView?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  reminderMe?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  subCalendar?: Resolver<ResolversTypes['ExperimentalTCSubCalendar'], ParentType, ContextType>;
  subscriberCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  usersPermittedToEdit?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCUser']>>>, ParentType, ContextType>;
  usersPermittedToView?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCUser']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEvent'] = ResolversParentTypes['ExperimentalTCEvent']> = {
  allDay?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  backgroundColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  borderColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  calendarReloadRequiredOnUpdate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  className?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  colorScheme?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  confluenceFormattedStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customEventTypeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  editable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  end?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  eventType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expandDates?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  extraProperties?: Resolver<Maybe<ResolversTypes['ExperimentalTCEventExtraProperties']>, ParentType, ContextType>;
  extraPropertiesTemplate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  invitees?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCEventInvitees']>>, ParentType, ContextType>;
  localizedEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizedEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizedOriginalEndDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizedOriginalStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizedStartDate?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  localizedStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mediumIconUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalEndDateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalEndTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalStart?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  originalStartDateTime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  originalStartTime?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  recur?: Resolver<Maybe<ResolversTypes['ExperimentalTCEventRecur']>, ParentType, ContextType>;
  recurId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rruleStr?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  secondaryBorderColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortTitle?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subCalendarId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  textColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  urlAlias?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  where?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workingUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventExtraPropertiesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventExtraProperties'] = ResolversParentTypes['ExperimentalTCEventExtraProperties']> = {
  assigneeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assigneeProfileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateField?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issueLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jiraIssueDisplayDayDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jiraVersionDisplayDayDuration?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  releaseNotesLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolved?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewBoardsUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewIssuesLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventInviteesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventInvitees'] = ResolversParentTypes['ExperimentalTCEventInvitees']> = {
  avatarIconUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventRecurResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventRecur'] = ResolversParentTypes['ExperimentalTCEventRecur']> = {
  byDay?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  freq?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  interval?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  until?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventTypeCustomDeleteResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventTypeCustomDeleteResponse'] = ResolversParentTypes['ExperimentalTCEventTypeCustomDeleteResponse']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventTypeCustomUpdateResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventTypeCustomUpdateResponse'] = ResolversParentTypes['ExperimentalTCEventTypeCustomUpdateResponse']> = {
  created?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  customEventTypeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  parentSubCalendarId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  periodInMins?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventTypeDefaultUpdateResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventTypeDefaultUpdateResponse'] = ResolversParentTypes['ExperimentalTCEventTypeDefaultUpdateResponse']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventTypeDisableResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventTypeDisableResponse'] = ResolversParentTypes['ExperimentalTCEventTypeDisableResponse']> = {
  modifiedSubCalendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCDecoratedSubCalendar']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventTypeReminderResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEventTypeReminder'] = ResolversParentTypes['ExperimentalTCEventTypeReminder']> = {
  eventTypeId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isCustomEventType?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  periodInMins?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCEventsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCEvents'] = ResolversParentTypes['ExperimentalTCEvents']> = {
  events?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCEvent']>>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCFieldErrorResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCFieldError'] = ResolversParentTypes['ExperimentalTCFieldError']> = {
  errorMessages?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  field?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCFormatDateResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCFormatDate'] = ResolversParentTypes['ExperimentalTCFormatDate']> = {
  dates?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCJiraCalendarDurationsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCJiraCalendarDurations'] = ResolversParentTypes['ExperimentalTCJiraCalendarDurations']> = {
  endDateFieldName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDateFieldName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCJiraEventPropsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCJiraEventProps'] = ResolversParentTypes['ExperimentalTCJiraEventProps']> = {
  assigneeName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  assigneeProfileUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  dateField?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  issueLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jiraIssueDisplayDayDuration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jiraVersionDisplayDayDuration?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  releaseNotesLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statusText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  summaryLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewBoardsUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  viewIssuesLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCJiraLinkResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCJiraLink'] = ResolversParentTypes['ExperimentalTCJiraLink']> = {
  displayUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCJiraLinksResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCJiraLinks'] = ResolversParentTypes['ExperimentalTCJiraLinks']> = {
  jiraLinks?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCJiraLink']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCJiraOptionResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCJiraOption'] = ResolversParentTypes['ExperimentalTCJiraOption']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCJiraOptionsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCJiraOptions'] = ResolversParentTypes['ExperimentalTCJiraOptions']> = {
  projects?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCJiraOption']>>, ParentType, ContextType>;
  searchRequests?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCJiraSearchRequest']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCJiraSearchRequestResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCJiraSearchRequest'] = ResolversParentTypes['ExperimentalTCJiraSearchRequest']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCSubCalendarResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCSubCalendar'] = ResolversParentTypes['ExperimentalTCSubCalendar']> = {
  applicationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  applicationName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  customEventTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCCustomEventType']>>>, ParentType, ContextType>;
  dateFieldNames?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  disableEventTypes?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  durations?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCJiraCalendarDurations']>>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jql?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  parentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sanboxEventTypeReminders?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCEventTypeReminder']>>>, ParentType, ContextType>;
  searchFilterId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  sourceLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceKey?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  spaceName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subscriptionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  timeZoneId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCSubCalendarsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCSubCalendars'] = ResolversParentTypes['ExperimentalTCSubCalendars']> = {
  payload?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCDecoratedSubCalendar']>>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCSubscriberCountResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCSubscriberCount'] = ResolversParentTypes['ExperimentalTCSubscriberCount']> = {
  subscriptionCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCTimezoneResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCTimezone'] = ResolversParentTypes['ExperimentalTCTimezone']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCTimezonesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCTimezones'] = ResolversParentTypes['ExperimentalTCTimezones']> = {
  timeZones?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCTimezone']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCUser'] = ResolversParentTypes['ExperimentalTCUser']> = {
  avatarUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCWatchStatusResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCWatchStatus'] = ResolversParentTypes['ExperimentalTCWatchStatus']> = {
  payload?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCWatchStatusEachCal']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTCWatchStatusEachCalResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTCWatchStatusEachCal'] = ResolversParentTypes['ExperimentalTCWatchStatusEachCal']> = {
  isWatchable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  subCalendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  watched?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  watchedViaContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTaskLinksResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTaskLinks'] = ResolversParentTypes['ExperimentalTaskLinks']> = {
  base?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  context?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTaskMessageResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTaskMessage'] = ResolversParentTypes['ExperimentalTaskMessage']> = {
  args?: Resolver<Array<Maybe<ResolversTypes['String']>>, ParentType, ContextType>;
  translation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTaskNameResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTaskName'] = ResolversParentTypes['ExperimentalTaskName']> = {
  args?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarColorsResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarColorsResponse'] = ResolversParentTypes['ExperimentalTeamCalendarColorsResponse']> = {
  modifiedSubCalendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCDecoratedSubCalendar']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarDeleteEventResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarDeleteEventResponse'] = ResolversParentTypes['ExperimentalTeamCalendarDeleteEventResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarEditResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarEditResponse'] = ResolversParentTypes['ExperimentalTeamCalendarEditResponse']> = {
  fieldErrors?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCFieldError']>>>, ParentType, ContextType>;
  modifiedSubCalendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  payload?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCDecoratedSubCalendar']>>>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarImportResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarImportResponse'] = ResolversParentTypes['ExperimentalTeamCalendarImportResponse']> = {
  fieldErrors?: Resolver<Maybe<Array<ResolversTypes['ExperimentalTCFieldError']>>, ParentType, ContextType>;
  subCalendarId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarJiraJQLValidateResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarJiraJQLValidateResponse'] = ResolversParentTypes['ExperimentalTeamCalendarJiraJQLValidateResponse']> = {
  valid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarRemindersResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarRemindersResponse'] = ResolversParentTypes['ExperimentalTeamCalendarRemindersResponse']> = {
  for_user?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  on_calendar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reminder_status?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarRestrictionResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarRestrictionResponse'] = ResolversParentTypes['ExperimentalTeamCalendarRestrictionResponse']> = {
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarsAddEventResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarsAddEventResponse'] = ResolversParentTypes['ExperimentalTeamCalendarsAddEventResponse']> = {
  event?: Resolver<Maybe<ResolversTypes['ExperimentalTCEvent']>, ParentType, ContextType>;
  fieldErrors?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCFieldError']>>>, ParentType, ContextType>;
  subCalendar?: Resolver<Maybe<ResolversTypes['ExperimentalTCDecoratedSubCalendar']>, ParentType, ContextType>;
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarsResetSubscribeLinkResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarsResetSubscribeLinkResponse'] = ResolversParentTypes['ExperimentalTeamCalendarsResetSubscribeLinkResponse']> = {
  success?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalTeamCalendarsSubscribeResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalTeamCalendarsSubscribe'] = ResolversParentTypes['ExperimentalTeamCalendarsSubscribe']> = {
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalThemeAPIMigrationsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalThemeAPIMigrations'] = ResolversParentTypes['ExperimentalThemeAPIMigrations']> = {
  gdpr?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalThemeSpaceHomeOverrideResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalThemeSpaceHomeOverride'] = ResolversParentTypes['ExperimentalThemeSpaceHomeOverride']> = {
  hasSpaceHomeOverride?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  spaceHomeOverrideDescriptor?: Resolver<Maybe<ResolversTypes['ExperimentalConnectIFrame']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUnlicensedPermissionResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUnlicensedPermissionResponse'] = ResolversParentTypes['ExperimentalUnlicensedPermissionResponse']> = {
  unlicensedPermissionId?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateAutomationRuleConnectionResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateAutomationRuleConnectionResponse'] = ResolversParentTypes['ExperimentalUpdateAutomationRuleConnectionResponse']> = {
  id?: Resolver<ResolversTypes['ExperimentalLong'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['ExperimentalAutomationRuleState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateAutomationRuleResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateAutomationRuleResponse'] = ResolversParentTypes['ExperimentalUpdateAutomationRuleResponse']> = {
  id?: Resolver<ResolversTypes['ExperimentalLong'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['ExperimentalAutomationRuleState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateContentPropertyResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateContentProperty'] = ResolversParentTypes['ExperimentalUpdateContentProperty']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateInstanceContentResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateInstanceContent'] = ResolversParentTypes['ExperimentalUpdateInstanceContent']> = {
  _links?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceLinks']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceMetadata']>, ParentType, ContextType>;
  space?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceSpace']>, ParentType, ContextType>;
  subType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateInstanceLinksResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateInstanceLinks'] = ResolversParentTypes['ExperimentalUpdateInstanceLinks']> = {
  editui?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateInstanceMetadataResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateInstanceMetadata'] = ResolversParentTypes['ExperimentalUpdateInstanceMetadata']> = {
  properties?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceMetadataProperties']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateInstanceMetadataPropertiesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateInstanceMetadataProperties'] = ResolversParentTypes['ExperimentalUpdateInstanceMetadataProperties']> = {
  editor?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceMetadataPropertiesEditor']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateInstanceMetadataPropertiesEditorResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateInstanceMetadataPropertiesEditor'] = ResolversParentTypes['ExperimentalUpdateInstanceMetadataPropertiesEditor']> = {
  value?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateInstanceResponseResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateInstanceResponse'] = ResolversParentTypes['ExperimentalUpdateInstanceResponse']> = {
  content?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceContent']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUpdateInstanceSpaceResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUpdateInstanceSpace'] = ResolversParentTypes['ExperimentalUpdateInstanceSpace']> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  key?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUserResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUser'] = ResolversParentTypes['ExperimentalUser']> = {
  accountId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  currentUserCanFollow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  currentUserIsFollowing?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  detailsDepartment?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailsLocation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  detailsPosition?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  displayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasBlog?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasExperimentalKnownUseralSpace?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  profilePicture?: Resolver<Maybe<ResolversTypes['ExperimentalIcon']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUserInvitationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUserInvitation'] = ResolversParentTypes['ExperimentalUserInvitation']> = {
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  results?: Resolver<Maybe<ResolversTypes['ExperimentalUserInvitationResults']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUserInvitationResultsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUserInvitationResults'] = ResolversParentTypes['ExperimentalUserInvitationResults']> = {
  conf?: Resolver<Maybe<ResolversTypes['ExperimentalUserInvitationResult']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUserPermissionsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUserPermissions'] = ResolversParentTypes['ExperimentalUserPermissions']> = {
  canAddProducts?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  canInviteUsers?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUserPersonalizationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUserPersonalization'] = ResolversParentTypes['ExperimentalUserPersonalization']> = {
  attributes?: Resolver<Maybe<Array<ResolversTypes['ExperimentalUserPersonalizationAttributes']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalUserPersonalizationAttributesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalUserPersonalizationAttributes'] = ResolversParentTypes['ExperimentalUserPersonalizationAttributes']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalVersionResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalVersion'] = ResolversParentTypes['ExperimentalVersion']> = {
  by?: Resolver<Maybe<ResolversTypes['ExperimentalKnownUser']>, ParentType, ContextType>;
  collaborators?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalKnownUser']>>>, ParentType, ContextType>;
  confRev?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  friendlyWhen?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  minorEdit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  when?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalWebResourceDependenciesResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalWebResourceDependencies'] = ResolversParentTypes['ExperimentalWebResourceDependencies']> = {
  contexts?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  keys?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  links?: Resolver<Maybe<ResolversTypes['ExperimentalLinksContextBase']>, ParentType, ContextType>;
  superbatch?: Resolver<Maybe<ResolversTypes['ExperimentalSuperBatchWebResources']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<ResolversTypes['ExperimentalWebResourceTags']>, ParentType, ContextType>;
  uris?: Resolver<Maybe<ResolversTypes['ExperimentalWebResourceUris']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalWebResourceTagsResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalWebResourceTags'] = ResolversParentTypes['ExperimentalWebResourceTags']> = {
  css?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  js?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExperimentalWebResourceUrisResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['ExperimentalWebResourceUris'] = ResolversParentTypes['ExperimentalWebResourceUris']> = {
  css?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  data?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  js?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JSONScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type MutationResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  experimentalAddCustomizedPersonalSpace?: Resolver<Maybe<ResolversTypes['ExperimentalAddCustomizedPersonalSpaceResult']>, ParentType, ContextType, RequireFields<MutationexperimentalAddCustomizedPersonalSpaceArgs, 'spaceName'>>;
  experimentalAddPersonalSpaceLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalAddPersonalSpaceLinkArgs, 'spaceUserKey'>>;
  experimentalAddSpaceLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalAddSpaceLinkArgs, 'id' | 'spaceKey'>>;
  experimentalArchiveSpace?: Resolver<Maybe<ResolversTypes['ExperimentalArchiveSpace']>, ParentType, ContextType, RequireFields<MutationexperimentalArchiveSpaceArgs, 'archived' | 'homePageTitle' | 'spaceKey' | 'spaceName'>>;
  experimentalCancelScheduledPublish?: Resolver<Maybe<ResolversTypes['ExperimentalCancelScheduledPublishResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalCancelScheduledPublishArgs, 'contentId'>>;
  experimentalCopyPageTree?: Resolver<Maybe<ResolversTypes['ExperimentalCopyPageTreeResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalCopyPageTreeArgs, 'contentId' | 'copyDescendants' | 'copyLabels' | 'copyPermissions' | 'destinationPageId' | 'mentionOptions' | 'prefix' | 'replace' | 'search'>>;
  experimentalCreateAutomationRuleFromTemplate?: Resolver<Maybe<ResolversTypes['ExperimentalCreateAutomationRuleFromTemplateResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalCreateAutomationRuleFromTemplateArgs, 'automationStack' | 'cloudId' | 'templateId'>>;
  experimentalCreateBlankFabricPage?: Resolver<Maybe<ResolversTypes['ExperimentalCreateContentResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalCreateBlankFabricPageArgs, 'spaceKey'>>;
  experimentalCreateDemoSpace?: Resolver<Maybe<ResolversTypes['ExperimentalDemoSpace']>, ParentType, ContextType, RequireFields<MutationexperimentalCreateDemoSpaceArgs, 'spaceKey' | 'spaceName'>>;
  experimentalCreateFabricBlogpost?: Resolver<Maybe<ResolversTypes['ExperimentalCreateContentResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalCreateFabricBlogpostArgs, 'spaceKey'>>;
  experimentalCreateSpecificSpace?: Resolver<Maybe<ResolversTypes['ExperimentalOnboardingSpace']>, ParentType, ContextType, RequireFields<MutationexperimentalCreateSpecificSpaceArgs, 'spaceBlueprintId' | 'spaceKey' | 'spaceName'>>;
  experimentalDeleteComment?: Resolver<Maybe<ResolversTypes['ExperimentalDeleteComment']>, ParentType, ContextType, RequireFields<MutationexperimentalDeleteCommentArgs, 'contentId'>>;
  experimentalDeleteContentVersion?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalDeleteContentVersionArgs, 'contentId' | 'versionNumber'>>;
  experimentalDisableKeyboardShortcuts?: Resolver<Maybe<ResolversTypes['ExperimentalKeyboardShortcutsStatus']>, ParentType, ContextType>;
  experimentalDraftSync?: Resolver<Maybe<ResolversTypes['ExperimentalContent']>, ParentType, ContextType, RequireFields<MutationexperimentalDraftSyncArgs, 'content' | 'contentId' | 'contentType' | 'ncsStepVersion'>>;
  experimentalEditorStartHeartbeat?: Resolver<Maybe<ResolversTypes['ExperimentalEditorHeartbeatResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalEditorStartHeartbeatArgs, 'collabService' | 'contentId'>>;
  experimentalEditorStopHeartbeat?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalEditorStopHeartbeatArgs, 'contentId'>>;
  experimentalEnableKeyboardShortcuts?: Resolver<Maybe<ResolversTypes['ExperimentalKeyboardShortcutsStatus']>, ParentType, ContextType>;
  experimentalFavouriteSpace?: Resolver<Maybe<ResolversTypes['ExperimentalFavouriteSpaceType']>, ParentType, ContextType, RequireFields<MutationexperimentalFavouriteSpaceArgs, 'spaceKey'>>;
  experimentalFileUpload?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalFileUploadArgs, 'collectionName' | 'contentType' | 'fileName' | 'fileStoreId' | 'mimeType' | 'pageId' | 'size'>>;
  experimentalGrantAccess?: Resolver<Maybe<ResolversTypes['ExperimentalGrantAccess']>, ParentType, ContextType, RequireFields<MutationexperimentalGrantAccessArgs, 'accessType' | 'accountId' | 'contentId'>>;
  experimentalMigratePages?: Resolver<Maybe<ResolversTypes['ExperimentalMigratePages']>, ParentType, ContextType, RequireFields<MutationexperimentalMigratePagesArgs, 'contentHash' | 'contentId'>>;
  experimentalMigrateTemplate?: Resolver<Maybe<ResolversTypes['ExperimentalMigrateTemplate']>, ParentType, ContextType, RequireFields<MutationexperimentalMigrateTemplateArgs, 'templateId'>>;
  experimentalPublishEditorContent?: Resolver<Maybe<ResolversTypes['ExperimentalPublishEditorContentResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalPublishEditorContentArgs, 'content' | 'contentId' | 'contentType' | 'spaceKey' | 'title' | 'version'>>;
  experimentalPublishPageAsBlog?: Resolver<Maybe<ResolversTypes['ExperimentalPublishPageAsBlog']>, ParentType, ContextType, RequireFields<MutationexperimentalPublishPageAsBlogArgs, 'contentId' | 'destinationType' | 'sourceStatus'>>;
  experimentalPublishPageByBlueprint?: Resolver<Maybe<ResolversTypes['ExperimentalPublishContentLink']>, ParentType, ContextType, RequireFields<MutationexperimentalPublishPageByBlueprintArgs, 'blueprint' | 'spaceKey'>>;
  experimentalPublishPageByTemplate?: Resolver<Maybe<ResolversTypes['ExperimentalPublishContentLink']>, ParentType, ContextType, RequireFields<MutationexperimentalPublishPageByTemplateArgs, 'spaceKey'>>;
  experimentalRemoveSpaceLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalRemoveSpaceLinkArgs, 'id' | 'spaceKey'>>;
  experimentalRemoveUnlicensedPermission?: Resolver<Maybe<ResolversTypes['ExperimentalRemoveUnlicensedPermissionResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalRemoveUnlicensedPermissionArgs, 'permissionId' | 'spaceKey'>>;
  experimentalRequestAccess?: Resolver<Maybe<ResolversTypes['ExperimentalRequestAccess']>, ParentType, ContextType, RequireFields<MutationexperimentalRequestAccessArgs, 'accessType' | 'contentId'>>;
  experimentalResetCollabService?: Resolver<Maybe<ResolversTypes['ExperimentalResetCollabServiceResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalResetCollabServiceArgs, 'contentId'>>;
  experimentalRestoreContentVersion?: Resolver<Maybe<ResolversTypes['ExperimentalContentVersionRestored']>, ParentType, ContextType, RequireFields<MutationexperimentalRestoreContentVersionArgs, 'contentId' | 'versionNumber'>>;
  experimentalRevertContent?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalRevertContentArgs, 'contentId'>>;
  experimentalSaveFabricComment?: Resolver<Maybe<ResolversTypes['ExperimentalFabricComment']>, ParentType, ContextType, Partial<MutationexperimentalSaveFabricCommentArgs>>;
  experimentalSetFeatureDiscovered?: Resolver<Maybe<ResolversTypes['ExperimentalDiscoveredFeature']>, ParentType, ContextType, RequireFields<MutationexperimentalSetFeatureDiscoveredArgs, 'featureKey' | 'pluginKey'>>;
  experimentalSetHaveISeenIt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalSetHaveISeenItArgs, 'flagKey'>>;
  experimentalShare?: Resolver<Maybe<ResolversTypes['ExperimentalShareResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalShareArgs, 'requestBody'>>;
  experimentalSubmitFeedbackCollector?: Resolver<Maybe<ResolversTypes['ExperimentalJiraIssue']>, ParentType, ContextType, RequireFields<MutationexperimentalSubmitFeedbackCollectorArgs, 'component' | 'summary'>>;
  experimentalTeamCalendarColors?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarColorsResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarColorsArgs, 'calendarContext' | 'color' | 'subCalendarId' | 'viewingSpaceKey'>>;
  experimentalTeamCalendarDelete?: Resolver<Maybe<ResolversTypes['ExperimentalTCSubCalendars']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarDeleteArgs, 'calendarContext' | 'subCalendarId'>>;
  experimentalTeamCalendarDeleteAllFutureEvents?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarDeleteEventResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarDeleteAllFutureEventsArgs, 'subCalendarId' | 'uid'>>;
  experimentalTeamCalendarDeleteEvent?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarDeleteEventResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarDeleteEventArgs, 'subCalendarId' | 'uid'>>;
  experimentalTeamCalendarDeleteSingleEvent?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarDeleteEventResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarDeleteSingleEventArgs, 'subCalendarId' | 'uid'>>;
  experimentalTeamCalendarEdit?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarEditResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarEditArgs, 'type'>>;
  experimentalTeamCalendarEventTypeCustomDelete?: Resolver<Maybe<ResolversTypes['ExperimentalTCEventTypeCustomDeleteResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarEventTypeCustomDeleteArgs, 'customEventTypeId' | 'subCalendarId'>>;
  experimentalTeamCalendarEventTypeCustomUpdate?: Resolver<Maybe<ResolversTypes['ExperimentalTCEventTypeCustomUpdateResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarEventTypeCustomUpdateArgs, 'customEventTypeId' | 'icon' | 'periodInMins' | 'subCalendarId' | 'title'>>;
  experimentalTeamCalendarEventTypeDefaultUpdate?: Resolver<Maybe<ResolversTypes['ExperimentalTCEventTypeDefaultUpdateResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarEventTypeDefaultUpdateArgs, 'eventTypeId' | 'icon' | 'periodInMins' | 'subCalendarId' | 'title'>>;
  experimentalTeamCalendarImport?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarImportResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarImportArgs, 'file_0'>>;
  experimentalTeamCalendarJiraJQLValidate?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarJiraJQLValidateResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarJiraJQLValidateArgs, 'jql' | 'serverId'>>;
  experimentalTeamCalendarPreferences?: Resolver<Maybe<ResolversTypes['ExperimentalTCSubCalendars']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarPreferencesArgs, 'calendarContext' | 'subCalendarId'>>;
  experimentalTeamCalendarReminders?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarRemindersResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarRemindersArgs, 'isReminder' | 'subCalendarId'>>;
  experimentalTeamCalendarResetSubscribeLink?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarResetSubscribeLinkArgs, 'subCalendarId'>>;
  experimentalTeamCalendarRestriction?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarRestrictionResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarRestrictionArgs, 'calendarContext' | 'subCalendarId' | 'updateGroupsPermittedToView' | 'updateUsersPermittedToEdit' | 'updateUsersPermittedToView' | 'viewingSpaceKey'>>;
  experimentalTeamCalendarSubscribe?: Resolver<Maybe<ResolversTypes['ExperimentalTCSubCalendars']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarSubscribeArgs, 'calendarContext' | 'color' | 'subCalendarIds' | 'watchSubCalendars'>>;
  experimentalTeamCalendarUpdateViewPreference?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendarUpdateViewPreferenceArgs, 'view'>>;
  experimentalTeamCalendar_EventType_Disable?: Resolver<Maybe<ResolversTypes['ExperimentalTCEventTypeDisableResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendar_EventType_DisableArgs, 'calendarId'>>;
  experimentalTeamCalendar_Hide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendar_HideArgs, 'action'>>;
  experimentalTeamCalendar_Watch?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<MutationexperimentalTeamCalendar_WatchArgs, 'action' | 'calendarId'>>;
  experimentalTeamCalendarsAddEvent?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarsAddEventResponse']>, ParentType, ContextType, Partial<MutationexperimentalTeamCalendarsAddEventArgs>>;
  experimentalUnfavouriteSpace?: Resolver<Maybe<ResolversTypes['ExperimentalFavouriteSpaceType']>, ParentType, ContextType, RequireFields<MutationexperimentalUnfavouriteSpaceArgs, 'spaceKey'>>;
  experimentalUpdateAutomationRule?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateAutomationRuleResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateAutomationRuleArgs, 'automationStack' | 'body' | 'cloudId' | 'ruleId'>>;
  experimentalUpdateAutomationRuleWithConnection?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateAutomationRuleConnectionResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateAutomationRuleWithConnectionArgs, 'automationStack' | 'cloudId' | 'ruleConfig' | 'ruleId'>>;
  experimentalUpdateContentProperty?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateContentProperty']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateContentPropertyArgs, 'contentId' | 'propertyKey'>>;
  experimentalUpdateDesSettings?: Resolver<Maybe<ResolversTypes['ExperimentalDesSettings']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateDesSettingsArgs, 'cloudId'>>;
  experimentalUpdateDraftWithBlueprint?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateDraftWithBlueprintArgs, 'blueprint' | 'contentId' | 'spaceKey'>>;
  experimentalUpdateDraftWithTemplate?: Resolver<Maybe<ResolversTypes['ExperimentalUpdateInstanceResponse']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateDraftWithTemplateArgs, 'blueprint' | 'contentId' | 'spaceKey'>>;
  experimentalUpdateOpenInviteSettings?: Resolver<Maybe<ResolversTypes['ExperimentalOpenInviteSettings']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateOpenInviteSettingsArgs, 'cloudId'>>;
  experimentalUpdateShortcutLinks?: Resolver<Maybe<ResolversTypes['ExperimentalQuickLinks']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateShortcutLinksArgs, 'spaceKey'>>;
  experimentalUpdateSiteSignUpSettings?: Resolver<Maybe<ResolversTypes['ExperimentalSiteSignUpSettings']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateSiteSignUpSettingsArgs, 'cloudId'>>;
  experimentalUpdateSpaceLogo?: Resolver<Maybe<ResolversTypes['ExperimentalSpaceLogo']>, ParentType, ContextType, RequireFields<MutationexperimentalUpdateSpaceLogoArgs, 'logoDataURI' | 'spaceKey' | 'spaceName'>>;
};

export type QueryResolvers<ContextType = ResolverContext, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  experimentalAboutConfluence?: Resolver<Maybe<ResolversTypes['ExperimentalAboutConfluence']>, ParentType, ContextType>;
  experimentalAnalyticsActivityByDate?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByDateResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalAnalyticsActivityByDateArgs, 'cloudId' | 'content' | 'entity' | 'fromDate' | 'period' | 'timezone' | 'toDate'>>;
  experimentalAnalyticsActivityBySpace?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsActivityBySpaceResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalAnalyticsActivityBySpaceArgs, 'cloudId' | 'content' | 'fromDate' | 'period' | 'spaceType' | 'timezone' | 'toDate'>>;
  experimentalAnalyticsActivityByUser?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsActivityByUserResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalAnalyticsActivityByUserArgs, 'cloudId' | 'content' | 'fromDate' | 'timezone' | 'toDate'>>;
  experimentalAnalyticsContentViews?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsContentViewsResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalAnalyticsContentViewsArgs, 'cloudId' | 'content' | 'fromDate' | 'spaceId' | 'timezone' | 'toDate'>>;
  experimentalAnalyticsViewsByDate?: Resolver<Maybe<ResolversTypes['ExperimentalAnalyticsViewsByDateResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalAnalyticsViewsByDateArgs, 'cloudId' | 'contentId' | 'contentType' | 'fromDate' | 'period' | 'timezone' | 'toDate' | 'type'>>;
  experimentalAutomationRuleConnections?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalAutomationRuleConnectionsResponse']>>>, ParentType, ContextType, RequireFields<QueryexperimentalAutomationRuleConnectionsArgs, 'automationStack' | 'cloudId' | 'ruleId'>>;
  experimentalAutomationRuleSummary?: Resolver<Maybe<ResolversTypes['ExperimentalAutomationRuleSummaryResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalAutomationRuleSummaryArgs, 'automationStack' | 'cloudId' | 'ruleId' | 'spaceId'>>;
  experimentalConnectContext?: Resolver<Maybe<ResolversTypes['ExperimentalConnectContext']>, ParentType, ContextType, RequireFields<QueryexperimentalConnectContextArgs, 'addonKey' | 'moduleKey'>>;
  experimentalConnectServlet?: Resolver<Maybe<ResolversTypes['ExperimentalConnectServletResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalConnectServletArgs, 'addonKey' | 'moduleKey'>>;
  experimentalContentBodyConvert?: Resolver<Maybe<ResolversTypes['ExperimentalContentBodyConvertResult']>, ParentType, ContextType, RequireFields<QueryexperimentalContentBodyConvertArgs, 'body' | 'from' | 'to'>>;
  experimentalContentDraftDiff?: Resolver<Maybe<ResolversTypes['ExperimentalContentDraftDiff']>, ParentType, ContextType, RequireFields<QueryexperimentalContentDraftDiffArgs, 'contentId'>>;
  experimentalCrossProductAdvancedSearch?: Resolver<Maybe<ResolversTypes['ExperimentalCrossProductSearchResult']>, ParentType, ContextType, RequireFields<QueryexperimentalCrossProductAdvancedSearchArgs, 'first' | 'query'>>;
  experimentalCurrentUser?: Resolver<Maybe<ResolversTypes['ExperimentalCurrentUser']>, ParentType, ContextType>;
  experimentalCustomContentConnectModules?: Resolver<ResolversTypes['ExperimentalConnectModule'], ParentType, ContextType>;
  experimentalCustomContentPage?: Resolver<Maybe<ResolversTypes['ExperimentalCustomContentPageResponse']>, ParentType, ContextType, Partial<QueryexperimentalCustomContentPageArgs>>;
  experimentalCustomContentProperties?: Resolver<Maybe<ResolversTypes['ExperimentalCustomContentPropertiesResponse']>, ParentType, ContextType, Partial<QueryexperimentalCustomContentPropertiesArgs>>;
  experimentalCustomContentPropertiesPage?: Resolver<Maybe<ResolversTypes['ExperimentalCustomContentPropertiesPageResponse']>, ParentType, ContextType, Partial<QueryexperimentalCustomContentPropertiesPageArgs>>;
  experimentalDefaultLogoForSpace?: Resolver<Maybe<ResolversTypes['ExperimentalDefaultLogoForSpace']>, ParentType, ContextType, RequireFields<QueryexperimentalDefaultLogoForSpaceArgs, 'spaceKey'>>;
  experimentalDesPromotionEligibility?: Resolver<Maybe<ResolversTypes['ExperimentalDesPromotionEligibility']>, ParentType, ContextType, RequireFields<QueryexperimentalDesPromotionEligibilityArgs, 'cloudId' | 'domain'>>;
  experimentalEditorBreadcrumbs?: Resolver<Maybe<ResolversTypes['ExperimentalEditorBreadcrumbs']>, ParentType, ContextType, RequireFields<QueryexperimentalEditorBreadcrumbsArgs, 'contentId'>>;
  experimentalFetchHaveISeenIt?: Resolver<Maybe<ResolversTypes['ExperimentalFlagResult']>, ParentType, ContextType, RequireFields<QueryexperimentalFetchHaveISeenItArgs, 'flagKey'>>;
  experimentalGenerateSpaceKey?: Resolver<Maybe<ResolversTypes['ExperimentalGenerateSpaceKey']>, ParentType, ContextType, RequireFields<QueryexperimentalGenerateSpaceKeyArgs, 'spaceName'>>;
  experimentalGetAutomationRuleById?: Resolver<Maybe<ResolversTypes['ExperimentalGetAutomationRuleByIdResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalGetAutomationRuleByIdArgs, 'automationStack' | 'cloudId' | 'ruleId'>>;
  experimentalGetCompleteOnboarding?: Resolver<Maybe<ResolversTypes['ExperimentalOnboardingCompletion']>, ParentType, ContextType, Partial<QueryexperimentalGetCompleteOnboardingArgs>>;
  experimentalIntegrationsInstalled?: Resolver<Maybe<ResolversTypes['ExperimentalIntegrationsInstalled']>, ParentType, ContextType, Partial<QueryexperimentalIntegrationsInstalledArgs>>;
  experimentalKeyboardShortcutsStatus?: Resolver<Maybe<ResolversTypes['ExperimentalKeyboardShortcutsStatus']>, ParentType, ContextType>;
  experimentalLongTask?: Resolver<Maybe<ResolversTypes['ExperimentalLongTask']>, ParentType, ContextType, RequireFields<QueryexperimentalLongTaskArgs, 'taskId'>>;
  experimentalMacroMetadata?: Resolver<Maybe<ResolversTypes['ExperimentalMacroPayload']>, ParentType, ContextType, RequireFields<QueryexperimentalMacroMetadataArgs, 'contentId' | 'macroNode'>>;
  experimentalMacroPlaceholderADF?: Resolver<Maybe<ResolversTypes['ExperimentalMacroPlaceholderResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalMacroPlaceholderADFArgs, 'contentId' | 'macroDefinition'>>;
  experimentalMarketplaceApps?: Resolver<Maybe<Array<ResolversTypes['ExperimentalMarketplaceApp']>>, ParentType, ContextType, RequireFields<QueryexperimentalMarketplaceAppsArgs, 'application' | 'isSiteAdmin'>>;
  experimentalNotifications?: Resolver<ResolversTypes['ExperimentalNotificationsResponse'], ParentType, ContextType, RequireFields<QueryexperimentalNotificationsArgs, 'first'>>;
  experimentalOnboardingSpaceBlueprints?: Resolver<Maybe<ResolversTypes['ExperimentalOnboardingSpaceBlueprints']>, ParentType, ContextType>;
  experimentalOnboardingTemplate?: Resolver<Maybe<ResolversTypes['ExperimentalOnboardingTemplate']>, ParentType, ContextType>;
  experimentalOpenInvite?: Resolver<Maybe<ResolversTypes['ExperimentalOpenInvite']>, ParentType, ContextType, RequireFields<QueryexperimentalOpenInviteArgs, 'cloudId'>>;
  experimentalPromotedSpaces?: Resolver<Maybe<ResolversTypes['ExperimentalPromotedSpaces']>, ParentType, ContextType, RequireFields<QueryexperimentalPromotedSpacesArgs, 'otherSpacesLimit' | 'promotedSpaceKey' | 'promotedSpacesLimit'>>;
  experimentalQuickReload?: Resolver<Maybe<ResolversTypes['ExperimentalQuickReload']>, ParentType, ContextType, RequireFields<QueryexperimentalQuickReloadArgs, 'contentId' | 'since'>>;
  experimentalRelationsForContent?: Resolver<Maybe<ResolversTypes['ExperimentalRelationsForContent']>, ParentType, ContextType, RequireFields<QueryexperimentalRelationsForContentArgs, 'relationName' | 'sourceType' | 'targetKey' | 'targetStatus'>>;
  experimentalResolvedInlineComments?: Resolver<Maybe<ResolversTypes['ExperimentalComments']>, ParentType, ContextType, RequireFields<QueryexperimentalResolvedInlineCommentsArgs, 'contentId'>>;
  experimentalSitePersonalization?: Resolver<Maybe<ResolversTypes['ExperimentalSitePersonalization']>, ParentType, ContextType, RequireFields<QueryexperimentalSitePersonalizationArgs, 'cloudId'>>;
  experimentalSpace?: Resolver<Maybe<ResolversTypes['ExperimentalSpace']>, ParentType, ContextType, RequireFields<QueryexperimentalSpaceArgs, 'spaceKey'>>;
  experimentalSpaceProperties?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalSpaceProperty']>>>, ParentType, ContextType, RequireFields<QueryexperimentalSpacePropertiesArgs, 'propertyKeys' | 'spaceKey'>>;
  experimentalSynchronyJwt?: Resolver<Maybe<ResolversTypes['ExperimentalSynchronyJwt']>, ParentType, ContextType, Partial<QueryexperimentalSynchronyJwtArgs>>;
  experimentalSynchronySnapshot?: Resolver<Maybe<ResolversTypes['ExperimentalSynchronySnapshot']>, ParentType, ContextType, Partial<QueryexperimentalSynchronySnapshotArgs>>;
  experimentalSystemInfoSettings?: Resolver<Maybe<ResolversTypes['ExperimentalSystemInfoSettings']>, ParentType, ContextType>;
  experimentalTeamCalendarEvents?: Resolver<Maybe<ResolversTypes['ExperimentalTCEvents']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarEventsArgs, 'end' | 'start' | 'subCalendarId' | 'userTimeZoneId'>>;
  experimentalTeamCalendarJiraDateFieldsQuery?: Resolver<Array<ResolversTypes['ExperimentalTCDateField']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarJiraDateFieldsQueryArgs, 'fieldParam' | 'serverId'>>;
  experimentalTeamCalendarJiraLinksQuery?: Resolver<Maybe<ResolversTypes['ExperimentalTCJiraLinks']>, ParentType, ContextType>;
  experimentalTeamCalendarJiraOptionsQuery?: Resolver<Maybe<ResolversTypes['ExperimentalTCJiraOptions']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarJiraOptionsQueryArgs, 'serverId'>>;
  experimentalTeamCalendarSubscriberCount?: Resolver<Maybe<ResolversTypes['ExperimentalTCSubscriberCount']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarSubscriberCountArgs, 'calendarContext' | 'calendarId'>>;
  experimentalTeamCalendarTimezonesQuery?: Resolver<Maybe<ResolversTypes['ExperimentalTCTimezones']>, ParentType, ContextType>;
  experimentalTeamCalendarViewPreference?: Resolver<Maybe<ResolversTypes['ExperimentalCalendarViewPreference']>, ParentType, ContextType>;
  experimentalTeamCalendarWatchStatus?: Resolver<Maybe<Array<Maybe<ResolversTypes['ExperimentalTCWatchStatusEachCal']>>>, ParentType, ContextType, Partial<QueryexperimentalTeamCalendarWatchStatusArgs>>;
  experimentalTeamCalendars?: Resolver<Maybe<ResolversTypes['ExperimentalTCSubCalendars']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarsArgs, 'calendarContext'>>;
  experimentalTeamCalendarsFormatDate?: Resolver<Maybe<ResolversTypes['ExperimentalTCFormatDate']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarsFormatDateArgs, 'dateTimes' | 'pattern'>>;
  experimentalTeamCalendarsSearch?: Resolver<Maybe<ResolversTypes['ExperimentalTCSubCalendars']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarsSearchArgs, 'isPopular' | 'pageSize' | 'showSubCalendarsInView' | 'showSubscriberCount' | 'startIndex'>>;
  experimentalTeamCalendarsSubscribe?: Resolver<Maybe<ResolversTypes['ExperimentalTeamCalendarsSubscribe']>, ParentType, ContextType, RequireFields<QueryexperimentalTeamCalendarsSubscribeArgs, 'calendarId'>>;
  experimentalThemeSpaceHomeOverride?: Resolver<Maybe<ResolversTypes['ExperimentalThemeSpaceHomeOverride']>, ParentType, ContextType, RequireFields<QueryexperimentalThemeSpaceHomeOverrideArgs, 'spaceHomePageId' | 'spaceKey'>>;
  experimentalUnlicensedPermission?: Resolver<Maybe<ResolversTypes['ExperimentalUnlicensedPermissionResponse']>, ParentType, ContextType, RequireFields<QueryexperimentalUnlicensedPermissionArgs, 'spaceKey'>>;
  experimentalUserPersonalization?: Resolver<Maybe<ResolversTypes['ExperimentalUserPersonalization']>, ParentType, ContextType, RequireFields<QueryexperimentalUserPersonalizationArgs, 'userId'>>;
};

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type Resolvers<ContextType = ResolverContext> = {
  ExperimentalAbTest?: ExperimentalAbTestResolvers<ContextType>;
  ExperimentalAboutConfluence?: ExperimentalAboutConfluenceResolvers<ContextType>;
  ExperimentalAddCustomizedPersonalSpaceResult?: ExperimentalAddCustomizedPersonalSpaceResultResolvers<ContextType>;
  ExperimentalAnalyticsActivityByDateActivity?: ExperimentalAnalyticsActivityByDateActivityResolvers<ContextType>;
  ExperimentalAnalyticsActivityByDateDateLevelActivity?: ExperimentalAnalyticsActivityByDateDateLevelActivityResolvers<ContextType>;
  ExperimentalAnalyticsActivityByDateResponse?: ExperimentalAnalyticsActivityByDateResponseResolvers<ContextType>;
  ExperimentalAnalyticsActivityBySpaceResponse?: ExperimentalAnalyticsActivityBySpaceResponseResolvers<ContextType>;
  ExperimentalAnalyticsActivityByUser?: ExperimentalAnalyticsActivityByUserResolvers<ContextType>;
  ExperimentalAnalyticsActivityByUserResponse?: ExperimentalAnalyticsActivityByUserResponseResolvers<ContextType>;
  ExperimentalAnalyticsContentViews?: ExperimentalAnalyticsContentViewsResolvers<ContextType>;
  ExperimentalAnalyticsContentViewsResponse?: ExperimentalAnalyticsContentViewsResponseResolvers<ContextType>;
  ExperimentalAnalyticsPagination?: ExperimentalAnalyticsPaginationResolvers<ContextType>;
  ExperimentalAnalyticsPaginationInfo?: ExperimentalAnalyticsPaginationInfoResolvers<ContextType>;
  ExperimentalAnalyticsSpaceLevelActivity?: ExperimentalAnalyticsSpaceLevelActivityResolvers<ContextType>;
  ExperimentalAnalyticsViewsByDate?: ExperimentalAnalyticsViewsByDateResolvers<ContextType>;
  ExperimentalAnalyticsViewsByDateResponse?: ExperimentalAnalyticsViewsByDateResponseResolvers<ContextType>;
  ExperimentalApplication?: ExperimentalApplicationResolvers<ContextType>;
  ExperimentalApplicationList?: ExperimentalApplicationListResolvers<ContextType>;
  ExperimentalArchiveSpace?: ExperimentalArchiveSpaceResolvers<ContextType>;
  ExperimentalAutomationActor?: ExperimentalAutomationActorResolvers<ContextType>;
  ExperimentalAutomationComponent?: ExperimentalAutomationComponentResolvers<ContextType>;
  ExperimentalAutomationComponentConfigSummary?: ExperimentalAutomationComponentConfigSummaryResolvers<ContextType>;
  ExperimentalAutomationRuleConnectionsResponse?: ExperimentalAutomationRuleConnectionsResponseResolvers<ContextType>;
  ExperimentalAutomationRuleHome?: ExperimentalAutomationRuleHomeResolvers<ContextType>;
  ExperimentalAutomationRuleScope?: ExperimentalAutomationRuleScopeResolvers<ContextType>;
  ExperimentalAutomationRuleSummaryResponse?: ExperimentalAutomationRuleSummaryResponseResolvers<ContextType>;
  ExperimentalAutomationRuleTag?: ExperimentalAutomationRuleTagResolvers<ContextType>;
  ExperimentalBlueprint?: ExperimentalBlueprintResolvers<ContextType>;
  ExperimentalBlueprintWizard?: ExperimentalBlueprintWizardResolvers<ContextType>;
  ExperimentalBlueprintWizardPage?: ExperimentalBlueprintWizardPageResolvers<ContextType>;
  ExperimentalCalendarViewPreference?: ExperimentalCalendarViewPreferenceResolvers<ContextType>;
  ExperimentalCancelScheduledPublishResponse?: ExperimentalCancelScheduledPublishResponseResolvers<ContextType>;
  ExperimentalComment?: ExperimentalCommentResolvers<ContextType>;
  ExperimentalCommentMutationResponse?: ExperimentalCommentMutationResponseResolvers<ContextType>;
  ExperimentalComments?: ExperimentalCommentsResolvers<ContextType>;
  ExperimentalConnectContext?: ExperimentalConnectContextResolvers<ContextType>;
  ExperimentalConnectIFrame?: ExperimentalConnectIFrameResolvers<ContextType>;
  ExperimentalConnectModule?: ExperimentalConnectModuleResolvers<ContextType>;
  ExperimentalConnectServletResponse?: ExperimentalConnectServletResponseResolvers<ContextType>;
  ExperimentalConnectionContainer?: ExperimentalConnectionContainerResolvers<ContextType>;
  ExperimentalConnectionTargetConfig?: ExperimentalConnectionTargetConfigResolvers<ContextType>;
  ExperimentalContainer?: ExperimentalContainerResolvers<ContextType>;
  ExperimentalContent?: ExperimentalContentResolvers<ContextType>;
  ExperimentalContentBody?: ExperimentalContentBodyResolvers<ContextType>;
  ExperimentalContentBodyConvertResult?: ExperimentalContentBodyConvertResultResolvers<ContextType>;
  ExperimentalContentBodyPerRepresentation?: ExperimentalContentBodyPerRepresentationResolvers<ContextType>;
  ExperimentalContentDraftDiff?: ExperimentalContentDraftDiffResolvers<ContextType>;
  ExperimentalContentHistory?: ExperimentalContentHistoryResolvers<ContextType>;
  ExperimentalContentHistoryUser?: ExperimentalContentHistoryUserResolvers<ContextType>;
  ExperimentalContentMetadata?: ExperimentalContentMetadataResolvers<ContextType>;
  ExperimentalContentMetadataLabelResult?: ExperimentalContentMetadataLabelResultResolvers<ContextType>;
  ExperimentalContentMetadataLabels?: ExperimentalContentMetadataLabelsResolvers<ContextType>;
  ExperimentalContentOperations?: ExperimentalContentOperationsResolvers<ContextType>;
  ExperimentalContentType?: ExperimentalContentTypeResolvers<ContextType>;
  ExperimentalContentVersionRestored?: ExperimentalContentVersionRestoredResolvers<ContextType>;
  ExperimentalCopyPageTreeLinksResponse?: ExperimentalCopyPageTreeLinksResponseResolvers<ContextType>;
  ExperimentalCopyPageTreeResponse?: ExperimentalCopyPageTreeResponseResolvers<ContextType>;
  ExperimentalCreateAutomationRuleFromTemplateResponse?: ExperimentalCreateAutomationRuleFromTemplateResponseResolvers<ContextType>;
  ExperimentalCreateContentResponse?: ExperimentalCreateContentResponseResolvers<ContextType>;
  ExperimentalCrossProductSearchResult?: ExperimentalCrossProductSearchResultResolvers<ContextType>;
  ExperimentalCrossProductSearchResultItem?: ExperimentalCrossProductSearchResultItemResolvers<ContextType>;
  ExperimentalCrossProductSearchResultItemContent?: ExperimentalCrossProductSearchResultItemContentResolvers<ContextType>;
  ExperimentalCrossProductSearchResultItemSpace?: ExperimentalCrossProductSearchResultItemSpaceResolvers<ContextType>;
  ExperimentalCrossProductSearchResultItemSpaceLinks?: ExperimentalCrossProductSearchResultItemSpaceLinksResolvers<ContextType>;
  ExperimentalCurrentUser?: ExperimentalCurrentUserResolvers<ContextType>;
  ExperimentalCustomContentExpandable?: ExperimentalCustomContentExpandableResolvers<ContextType>;
  ExperimentalCustomContentPageResponse?: ExperimentalCustomContentPageResponseResolvers<ContextType>;
  ExperimentalCustomContentPageResponseResult?: ExperimentalCustomContentPageResponseResultResolvers<ContextType>;
  ExperimentalCustomContentPropertiesPageResponse?: ExperimentalCustomContentPropertiesPageResponseResolvers<ContextType>;
  ExperimentalCustomContentPropertiesResponse?: ExperimentalCustomContentPropertiesResponseResolvers<ContextType>;
  ExperimentalDRSEligibility?: ExperimentalDRSEligibilityResolvers<ContextType>;
  ExperimentalDRSSettings?: ExperimentalDRSSettingsResolvers<ContextType>;
  ExperimentalDefaultLogoForSpace?: ExperimentalDefaultLogoForSpaceResolvers<ContextType>;
  ExperimentalDeleteComment?: ExperimentalDeleteCommentResolvers<ContextType>;
  ExperimentalDemoSpace?: ExperimentalDemoSpaceResolvers<ContextType>;
  ExperimentalDesPromotionEligibility?: ExperimentalDesPromotionEligibilityResolvers<ContextType>;
  ExperimentalDesSettings?: ExperimentalDesSettingsResolvers<ContextType>;
  ExperimentalDiscoveredFeature?: ExperimentalDiscoveredFeatureResolvers<ContextType>;
  ExperimentalEditorBreadcrumb?: ExperimentalEditorBreadcrumbResolvers<ContextType>;
  ExperimentalEditorBreadcrumbs?: ExperimentalEditorBreadcrumbsResolvers<ContextType>;
  ExperimentalEditorHeartbeatResponse?: ExperimentalEditorHeartbeatResponseResolvers<ContextType>;
  ExperimentalExpandable?: ExperimentalExpandableResolvers<ContextType>;
  ExperimentalExtension?: ExperimentalExtensionResolvers<ContextType>;
  ExperimentalFabricComment?: ExperimentalFabricCommentResolvers<ContextType>;
  ExperimentalFabricInlineComment?: ExperimentalFabricInlineCommentResolvers<ContextType>;
  ExperimentalFabricInlineCommentError?: ExperimentalFabricInlineCommentErrorResolvers<ContextType>;
  ExperimentalFabricInlineCommentResolveProperties?: ExperimentalFabricInlineCommentResolvePropertiesResolvers<ContextType>;
  ExperimentalFabricInlineCommentResponse?: ExperimentalFabricInlineCommentResponseResolvers<ContextType>;
  ExperimentalFabricInlineReply?: ExperimentalFabricInlineReplyResolvers<ContextType>;
  ExperimentalFabricInlineReplyError?: ExperimentalFabricInlineReplyErrorResolvers<ContextType>;
  ExperimentalFabricInlineReplyResponse?: ExperimentalFabricInlineReplyResponseResolvers<ContextType>;
  ExperimentalFavouriteSpaceQuery?: ExperimentalFavouriteSpaceQueryResolvers<ContextType>;
  ExperimentalFavouriteSpaceType?: ExperimentalFavouriteSpaceTypeResolvers<ContextType>;
  ExperimentalFlagResult?: ExperimentalFlagResultResolvers<ContextType>;
  ExperimentalFormattedBody?: ExperimentalFormattedBodyResolvers<ContextType>;
  ExperimentalGenerateSpaceKey?: ExperimentalGenerateSpaceKeyResolvers<ContextType>;
  ExperimentalGetAutomationRuleByIdResponse?: ExperimentalGetAutomationRuleByIdResponseResolvers<ContextType>;
  ExperimentalGrantAccess?: ExperimentalGrantAccessResolvers<ContextType>;
  ExperimentalGroup?: ExperimentalGroupResolvers<ContextType>;
  ExperimentalHeartbeatUser?: ExperimentalHeartbeatUserResolvers<ContextType>;
  ExperimentalHistory?: ExperimentalHistoryResolvers<ContextType>;
  ExperimentalIcon?: ExperimentalIconResolvers<ContextType>;
  ExperimentalInlineComment?: ExperimentalInlineCommentResolvers<ContextType>;
  ExperimentalInlineCommentReopened?: ExperimentalInlineCommentReopenedResolvers<ContextType>;
  ExperimentalIntegrationsInstalled?: ExperimentalIntegrationsInstalledResolvers<ContextType>;
  ExperimentalJiraIssue?: ExperimentalJiraIssueResolvers<ContextType>;
  ExperimentalKeyboardShortcutsStatus?: ExperimentalKeyboardShortcutsStatusResolvers<ContextType>;
  ExperimentalKnownUser?: ExperimentalKnownUserResolvers<ContextType>;
  ExperimentalLinks?: ExperimentalLinksResolvers<ContextType>;
  ExperimentalLinksContextBase?: ExperimentalLinksContextBaseResolvers<ContextType>;
  ExperimentalLinksContextSelfBase?: ExperimentalLinksContextSelfBaseResolvers<ContextType>;
  ExperimentalLinksContextSelfCollectionWebuiBase?: ExperimentalLinksContextSelfCollectionWebuiBaseResolvers<ContextType>;
  ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase?: ExperimentalLinksDownloadEdituiWebuiContextSelfTinyuiCollectionBaseResolvers<ContextType>;
  ExperimentalLong?: GraphQLScalarType;
  ExperimentalLongTask?: ExperimentalLongTaskResolvers<ContextType>;
  ExperimentalMacroPayload?: ExperimentalMacroPayloadResolvers<ContextType>;
  ExperimentalMacroPlaceholderResponse?: ExperimentalMacroPlaceholderResponseResolvers<ContextType>;
  ExperimentalMarketplaceApp?: ExperimentalMarketplaceAppResolvers<ContextType>;
  ExperimentalMarketplaceAppRating?: ExperimentalMarketplaceAppRatingResolvers<ContextType>;
  ExperimentalMigratePages?: ExperimentalMigratePagesResolvers<ContextType>;
  ExperimentalMigrateTemplate?: ExperimentalMigrateTemplateResolvers<ContextType>;
  ExperimentalNotification?: ExperimentalNotificationResolvers<ContextType>;
  ExperimentalNotificationActor?: ExperimentalNotificationActorResolvers<ContextType>;
  ExperimentalNotificationBody?: ExperimentalNotificationBodyResolvers<ContextType>;
  ExperimentalNotificationContent?: ExperimentalNotificationContentResolvers<ContextType>;
  ExperimentalNotificationPathNode?: ExperimentalNotificationPathNodeResolvers<ContextType>;
  ExperimentalNotificationsResponse?: ExperimentalNotificationsResponseResolvers<ContextType>;
  ExperimentalOnboardingCompletion?: ExperimentalOnboardingCompletionResolvers<ContextType>;
  ExperimentalOnboardingIntegration?: ExperimentalOnboardingIntegrationResolvers<ContextType>;
  ExperimentalOnboardingSpace?: ExperimentalOnboardingSpaceResolvers<ContextType>;
  ExperimentalOnboardingSpaceBlueprints?: ExperimentalOnboardingSpaceBlueprintsResolvers<ContextType>;
  ExperimentalOnboardingTemplate?: ExperimentalOnboardingTemplateResolvers<ContextType>;
  ExperimentalOpenInvite?: ExperimentalOpenInviteResolvers<ContextType>;
  ExperimentalOpenInviteSettings?: ExperimentalOpenInviteSettingsResolvers<ContextType>;
  ExperimentalOperationCheckResult?: ExperimentalOperationCheckResultResolvers<ContextType>;
  ExperimentalPageInfo?: ExperimentalPageInfoResolvers<ContextType>;
  ExperimentalPromotedSpace?: ExperimentalPromotedSpaceResolvers<ContextType>;
  ExperimentalPromotedSpaces?: ExperimentalPromotedSpacesResolvers<ContextType>;
  ExperimentalPublishContent?: ExperimentalPublishContentResolvers<ContextType>;
  ExperimentalPublishContentLink?: ExperimentalPublishContentLinkResolvers<ContextType>;
  ExperimentalPublishEditorContentResponse?: ExperimentalPublishEditorContentResponseResolvers<ContextType>;
  ExperimentalPublishEditorContentResponseSpace?: ExperimentalPublishEditorContentResponseSpaceResolvers<ContextType>;
  ExperimentalPublishPageAsBlog?: ExperimentalPublishPageAsBlogResolvers<ContextType>;
  ExperimentalPublishPageAsBlogLinks?: ExperimentalPublishPageAsBlogLinksResolvers<ContextType>;
  ExperimentalQuickLinks?: ExperimentalQuickLinksResolvers<ContextType>;
  ExperimentalQuickReload?: ExperimentalQuickReloadResolvers<ContextType>;
  ExperimentalQuickReloadComment?: ExperimentalQuickReloadCommentResolvers<ContextType>;
  ExperimentalQuickReloadCommentComment?: ExperimentalQuickReloadCommentCommentResolvers<ContextType>;
  ExperimentalQuickReloadUser?: ExperimentalQuickReloadUserResolvers<ContextType>;
  ExperimentalRecentContainer?: ExperimentalRecentContainerResolvers<ContextType>;
  ExperimentalRecentContainerList?: ExperimentalRecentContainerListResolvers<ContextType>;
  ExperimentalRelation?: ExperimentalRelationResolvers<ContextType>;
  ExperimentalRelationDataForContent?: ExperimentalRelationDataForContentResolvers<ContextType>;
  ExperimentalRelationForContent?: ExperimentalRelationForContentResolvers<ContextType>;
  ExperimentalRelations?: ExperimentalRelationsResolvers<ContextType>;
  ExperimentalRelationsForContent?: ExperimentalRelationsForContentResolvers<ContextType>;
  ExperimentalRemoveUnlicensedPermissionResponse?: ExperimentalRemoveUnlicensedPermissionResponseResolvers<ContextType>;
  ExperimentalRequestAccess?: ExperimentalRequestAccessResolvers<ContextType>;
  ExperimentalResetCollabServiceResponse?: ExperimentalResetCollabServiceResponseResolvers<ContextType>;
  ExperimentalResolveProperties?: ExperimentalResolvePropertiesResolvers<ContextType>;
  ExperimentalRuleHomeBilling?: ExperimentalRuleHomeBillingResolvers<ContextType>;
  ExperimentalRuleHomeLifecycle?: ExperimentalRuleHomeLifecycleResolvers<ContextType>;
  ExperimentalShareResponse?: ExperimentalShareResponseResolvers<ContextType>;
  ExperimentalSitePersonalization?: ExperimentalSitePersonalizationResolvers<ContextType>;
  ExperimentalSitePersonalizationAttributes?: ExperimentalSitePersonalizationAttributesResolvers<ContextType>;
  ExperimentalSiteSignUpSettings?: ExperimentalSiteSignUpSettingsResolvers<ContextType>;
  ExperimentalSpace?: ExperimentalSpaceResolvers<ContextType>;
  ExperimentalSpaceLogo?: ExperimentalSpaceLogoResolvers<ContextType>;
  ExperimentalSpaceOrContent?: ExperimentalSpaceOrContentResolvers<ContextType>;
  ExperimentalSpaceProperty?: ExperimentalSpacePropertyResolvers<ContextType>;
  ExperimentalSpacePropertyVersion?: ExperimentalSpacePropertyVersionResolvers<ContextType>;
  ExperimentalSpaceSidebarQuickLink?: ExperimentalSpaceSidebarQuickLinkResolvers<ContextType>;
  ExperimentalSpaceWatch?: ExperimentalSpaceWatchResolvers<ContextType>;
  ExperimentalSuggestLabel?: ExperimentalSuggestLabelResolvers<ContextType>;
  ExperimentalSuperBatchWebResources?: ExperimentalSuperBatchWebResourcesResolvers<ContextType>;
  ExperimentalSynchronyJwt?: ExperimentalSynchronyJwtResolvers<ContextType>;
  ExperimentalSynchronySnapshot?: ExperimentalSynchronySnapshotResolvers<ContextType>;
  ExperimentalSystemInfoSettings?: ExperimentalSystemInfoSettingsResolvers<ContextType>;
  ExperimentalTCCustomEventType?: ExperimentalTCCustomEventTypeResolvers<ContextType>;
  ExperimentalTCDateField?: ExperimentalTCDateFieldResolvers<ContextType>;
  ExperimentalTCDecoratedSubCalendar?: ExperimentalTCDecoratedSubCalendarResolvers<ContextType>;
  ExperimentalTCEvent?: ExperimentalTCEventResolvers<ContextType>;
  ExperimentalTCEventExtraProperties?: ExperimentalTCEventExtraPropertiesResolvers<ContextType>;
  ExperimentalTCEventInvitees?: ExperimentalTCEventInviteesResolvers<ContextType>;
  ExperimentalTCEventRecur?: ExperimentalTCEventRecurResolvers<ContextType>;
  ExperimentalTCEventTypeCustomDeleteResponse?: ExperimentalTCEventTypeCustomDeleteResponseResolvers<ContextType>;
  ExperimentalTCEventTypeCustomUpdateResponse?: ExperimentalTCEventTypeCustomUpdateResponseResolvers<ContextType>;
  ExperimentalTCEventTypeDefaultUpdateResponse?: ExperimentalTCEventTypeDefaultUpdateResponseResolvers<ContextType>;
  ExperimentalTCEventTypeDisableResponse?: ExperimentalTCEventTypeDisableResponseResolvers<ContextType>;
  ExperimentalTCEventTypeReminder?: ExperimentalTCEventTypeReminderResolvers<ContextType>;
  ExperimentalTCEvents?: ExperimentalTCEventsResolvers<ContextType>;
  ExperimentalTCFieldError?: ExperimentalTCFieldErrorResolvers<ContextType>;
  ExperimentalTCFormatDate?: ExperimentalTCFormatDateResolvers<ContextType>;
  ExperimentalTCJiraCalendarDurations?: ExperimentalTCJiraCalendarDurationsResolvers<ContextType>;
  ExperimentalTCJiraEventProps?: ExperimentalTCJiraEventPropsResolvers<ContextType>;
  ExperimentalTCJiraLink?: ExperimentalTCJiraLinkResolvers<ContextType>;
  ExperimentalTCJiraLinks?: ExperimentalTCJiraLinksResolvers<ContextType>;
  ExperimentalTCJiraOption?: ExperimentalTCJiraOptionResolvers<ContextType>;
  ExperimentalTCJiraOptions?: ExperimentalTCJiraOptionsResolvers<ContextType>;
  ExperimentalTCJiraSearchRequest?: ExperimentalTCJiraSearchRequestResolvers<ContextType>;
  ExperimentalTCSubCalendar?: ExperimentalTCSubCalendarResolvers<ContextType>;
  ExperimentalTCSubCalendars?: ExperimentalTCSubCalendarsResolvers<ContextType>;
  ExperimentalTCSubscriberCount?: ExperimentalTCSubscriberCountResolvers<ContextType>;
  ExperimentalTCTimezone?: ExperimentalTCTimezoneResolvers<ContextType>;
  ExperimentalTCTimezones?: ExperimentalTCTimezonesResolvers<ContextType>;
  ExperimentalTCUser?: ExperimentalTCUserResolvers<ContextType>;
  ExperimentalTCWatchStatus?: ExperimentalTCWatchStatusResolvers<ContextType>;
  ExperimentalTCWatchStatusEachCal?: ExperimentalTCWatchStatusEachCalResolvers<ContextType>;
  ExperimentalTaskLinks?: ExperimentalTaskLinksResolvers<ContextType>;
  ExperimentalTaskMessage?: ExperimentalTaskMessageResolvers<ContextType>;
  ExperimentalTaskName?: ExperimentalTaskNameResolvers<ContextType>;
  ExperimentalTeamCalendarColorsResponse?: ExperimentalTeamCalendarColorsResponseResolvers<ContextType>;
  ExperimentalTeamCalendarDeleteEventResponse?: ExperimentalTeamCalendarDeleteEventResponseResolvers<ContextType>;
  ExperimentalTeamCalendarEditResponse?: ExperimentalTeamCalendarEditResponseResolvers<ContextType>;
  ExperimentalTeamCalendarImportResponse?: ExperimentalTeamCalendarImportResponseResolvers<ContextType>;
  ExperimentalTeamCalendarJiraJQLValidateResponse?: ExperimentalTeamCalendarJiraJQLValidateResponseResolvers<ContextType>;
  ExperimentalTeamCalendarRemindersResponse?: ExperimentalTeamCalendarRemindersResponseResolvers<ContextType>;
  ExperimentalTeamCalendarRestrictionResponse?: ExperimentalTeamCalendarRestrictionResponseResolvers<ContextType>;
  ExperimentalTeamCalendarsAddEventResponse?: ExperimentalTeamCalendarsAddEventResponseResolvers<ContextType>;
  ExperimentalTeamCalendarsResetSubscribeLinkResponse?: ExperimentalTeamCalendarsResetSubscribeLinkResponseResolvers<ContextType>;
  ExperimentalTeamCalendarsSubscribe?: ExperimentalTeamCalendarsSubscribeResolvers<ContextType>;
  ExperimentalThemeAPIMigrations?: ExperimentalThemeAPIMigrationsResolvers<ContextType>;
  ExperimentalThemeSpaceHomeOverride?: ExperimentalThemeSpaceHomeOverrideResolvers<ContextType>;
  ExperimentalUnlicensedPermissionResponse?: ExperimentalUnlicensedPermissionResponseResolvers<ContextType>;
  ExperimentalUpdateAutomationRuleConnectionResponse?: ExperimentalUpdateAutomationRuleConnectionResponseResolvers<ContextType>;
  ExperimentalUpdateAutomationRuleResponse?: ExperimentalUpdateAutomationRuleResponseResolvers<ContextType>;
  ExperimentalUpdateContentProperty?: ExperimentalUpdateContentPropertyResolvers<ContextType>;
  ExperimentalUpdateInstanceContent?: ExperimentalUpdateInstanceContentResolvers<ContextType>;
  ExperimentalUpdateInstanceLinks?: ExperimentalUpdateInstanceLinksResolvers<ContextType>;
  ExperimentalUpdateInstanceMetadata?: ExperimentalUpdateInstanceMetadataResolvers<ContextType>;
  ExperimentalUpdateInstanceMetadataProperties?: ExperimentalUpdateInstanceMetadataPropertiesResolvers<ContextType>;
  ExperimentalUpdateInstanceMetadataPropertiesEditor?: ExperimentalUpdateInstanceMetadataPropertiesEditorResolvers<ContextType>;
  ExperimentalUpdateInstanceResponse?: ExperimentalUpdateInstanceResponseResolvers<ContextType>;
  ExperimentalUpdateInstanceSpace?: ExperimentalUpdateInstanceSpaceResolvers<ContextType>;
  ExperimentalUser?: ExperimentalUserResolvers<ContextType>;
  ExperimentalUserInvitation?: ExperimentalUserInvitationResolvers<ContextType>;
  ExperimentalUserInvitationResults?: ExperimentalUserInvitationResultsResolvers<ContextType>;
  ExperimentalUserPermissions?: ExperimentalUserPermissionsResolvers<ContextType>;
  ExperimentalUserPersonalization?: ExperimentalUserPersonalizationResolvers<ContextType>;
  ExperimentalUserPersonalizationAttributes?: ExperimentalUserPersonalizationAttributesResolvers<ContextType>;
  ExperimentalVersion?: ExperimentalVersionResolvers<ContextType>;
  ExperimentalWebResourceDependencies?: ExperimentalWebResourceDependenciesResolvers<ContextType>;
  ExperimentalWebResourceTags?: ExperimentalWebResourceTagsResolvers<ContextType>;
  ExperimentalWebResourceUris?: ExperimentalWebResourceUrisResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Upload?: GraphQLScalarType;
};

export type DirectiveResolvers<ContextType = ResolverContext> = {
  SLA?: SLADirectiveResolver<any, any, ContextType>;
  experimental?: experimentalDirectiveResolver<any, any, ContextType>;
};
